import React from 'react';
import { useHistory } from 'react-router-dom';
import { StaticRoomsProps } from 'types';
import styles from '../../styles.module.scss';

const StaticRooms: React.FC<StaticRoomsProps> = ({ literacyCheck }) => {
  const history = useHistory();

  return (
    <>
      <g
        className={`${styles.pointer} prefix__static-item`}
        onClick={() => literacyCheck('/next-room')}
        transform="translate(331 503)"
      >
        <g opacity="0.28">
          <path
            d="M167.09,126.18s-46.57,27.28-66.2,35.23S59.26,183,58.11,185.32s10,7.56,10.79,7.15,31.45-20.17,38.86-22.86,67.77-37.94,67.77-37.94l-8.44-5.49Z"
            fill="#531063"
          />
          <polygon
            points="167.09 126.18 167.09 126.18 167.09 126.18 167.09 126.18"
            fill="#531063"
          />
          <polygon
            points="167.09 126.18 167.09 126.18 167.09 126.18 167.09 126.18"
            fill="#531063"
          />
          <path
            d="M167.09,126.18s-46.57,27.28-66.2,35.23S59.26,183,58.11,185.32s10,7.56,10.79,7.15L71.31,191c-2.55-3.18-5-8.25-2.16-10.37,3.71-2.81,28.83-14.83,34.26-17.41s28.17-13.84,30.62-15.46c2.06-1.35,27.07-15.66,35.07-20.23l-2-1.31Z"
            fill="#531063"
          />
          <path
            d="M161,132.12c2,1.3,7.35,3.72,7.35,3.72l3.88-2-11.56-4.24S159,130.82,161,132.12Z"
            fill="#531063"
          />
          <path
            d="M172.38,134.49A76.76,76.76,0,0,0,194,140.31c-13.7-8.57-28.57-15-43.34-21.43C153.07,123.32,161.12,129.3,172.38,134.49Z"
            fill="#531063"
          />
          <path
            d="M133.06,111.43c-7.51,1.71-7.82,2.92-5.91,4.19,1.61,1.06,11.9,4.09,22.52,2.84-5.37-2.34-10.72-4.7-16-7.17Z"
            fill="#531063"
          />
          <path
            d="M132.3,111.84c-7.51,1.71-7.83,2.91-5.91,4.18,1.64,1.09,12.34,4.23,23.19,2.77,2.12,4.5,10.37,10.72,22,16.11,7.6,3.51,15.25,4.58,22.34,5.41C174.82,128.15,154.36,121,134,111.44Z"
            fill="#531063"
          />
          <path
            d="M131.79,112.11c-7.51,1.71-7.83,2.92-5.91,4.18,1.64,1.09,12.34,4.23,23.19,2.77,2.12,4.5,10.37,10.72,22,16.11,8,3.69,15.57,4.36,22.85,5.14C174.73,128,154.72,121.1,134.2,111.53Z"
            fill="#531063"
          />
          <path
            d="M182.33,133.64a11,11,0,0,0-2.72.53,2.86,2.86,0,0,0-1.9,3.33l5.92-3.16Z"
            fill="#531063"
          />
          <path
            d="M170.79,134.61l.94-.56C169.93,134.59,170.79,134.61,170.79,134.61Z"
            fill="#531063"
          />
          <path
            d="M171.73,134.05,172,134a1.12,1.12,0,0,0,.71-.49Z"
            fill="#531063"
          />
          <path
            d="M173.07,129a1.17,1.17,0,0,0-.43.27c-1,1.16.63,3.2.05,4.23l4.33-2.57C175.71,130.26,174.39,129.61,173.07,129Z"
            fill="#531063"
          />
          <path
            d="M171.87,127.13l-1.13.63C171.47,127.64,171.78,127.41,171.87,127.13Z"
            fill="#531063"
          />
          <path
            d="M170.55,127.79a7.3,7.3,0,0,1-.77.07c-3.42.16-6.19-.65-6.25.52a6.81,6.81,0,0,0,.95,2.89l6.15-3.44Z"
            fill="#531063"
          />
          <path d="M170.74,127.76l-.19,0,.08,0Z" fill="#531063" />
          <path
            d="M161.81,123.79,156,126s3.7.79,6.33-.1c1.16-.38,1.18-.85,1-1.39Z"
            fill="#531063"
          />
          <path
            d="M163.08,123.31l-1.27.48,1.56.7A4,4,0,0,1,163.08,123.31Z"
            fill="#531063"
          />
          <path
            d="M155.37,121,152,122.43a22,22,0,0,0,4.58-.41,6.17,6.17,0,0,0,.82-.2Z"
            fill="#531063"
          />
          <path
            d="M158.18,119.75l-2.81,1.2,2,.87C158.68,121.39,157.89,120.87,158.18,119.75Z"
            fill="#531063"
          />
          <path
            d="M160.18,114.06l.9-.32A8.7,8.7,0,0,0,160.18,114.06Z"
            fill="#531063"
          />
          <path
            d="M151.58,117.15a12.93,12.93,0,0,0-3.32.69l.63.28Z"
            fill="#531063"
          />
          <path
            d="M146.13,119.11l2.76-1-.63-.28A6,6,0,0,0,146.13,119.11Z"
            fill="#531063"
          />
          <path
            d="M138.18,116.79c-2.21,2.14-.93,2.08-.93,2.08l5-2.75C140.84,115.82,139.44,115.58,138.18,116.79Z"
            fill="#531063"
          />
          <path
            d="M143.16,115.6l-.94.52a6.86,6.86,0,0,0,2.67.25Z"
            fill="#531063"
          />
          <path
            d="M129.53,114.66a13.25,13.25,0,0,0-2.71,1.65l3.7-2A5.16,5.16,0,0,0,129.53,114.66Z"
            fill="#531063"
          />
          <path
            d="M135.09,112l-4.57,2.41c1.87-.41,5.18-.6,7.15-1.23Z"
            fill="#531063"
          />
          <path
            d="M177.4,134.93c-8.27-3.94-19.09-10.07-24.14-14.9l-6.38-2.79c-6.78-.33-14.8-.4-16.32-2.4-1.21-1.6.53-2.47,1.89-2.89l-.66.16c-7.51,1.71-7.83,2.92-5.91,4.18,1.64,1.09,12.34,4.23,23.19,2.77,2.12,4.5,10.37,10.72,22,16.11,8,3.69,15.57,4.36,22.85,5.14-1.24-.8-.87-.55-2.13-1.31C186.38,138,181,136.64,177.4,134.93Z"
            fill="#531063"
            opacity="0.46"
          />
          <path
            d="M132.45,112l1.33-.31A10.16,10.16,0,0,0,132.45,112Z"
            fill="#531063"
            opacity="0.46"
          />
          <polygon
            points="133.78 111.64 133.78 111.64 133.78 111.64 133.78 111.64"
            fill="#531063"
            opacity="0.46"
          />
          <path
            d="M151.12,117.52c-1.3-.12-2.74-.21-4.24-.28l6.38,2.79A13.72,13.72,0,0,1,151.12,117.52Z"
            fill="#531063"
            opacity="0.46"
          />
          <polygon
            points="103.21 159.96 89.76 166.39 101.56 172.59 114.61 165.64 103.21 159.96"
            fill="#531063"
            opacity="0.72"
          />
          <polygon
            points="81.09 171.94 67.64 178.37 74.56 180.93 79.22 186.04 92.5 177.62 81.09 171.94"
            fill="#531063"
            opacity="0.72"
          />
          <g>
            <path
              d="M77.69,162.34c-3.14,1.07-17.85,5.9-16.7,8.89s14.14,7.54,16.71,9.55,7.91,8.38,11.86,7.86S112,181,108.8,178.4,80.62,161.35,77.69,162.34Z"
              fill="#531063"
            />
            <path
              d="M91.27,188.26c-.55-1.48-13-10.65-17.87-13.16a82.24,82.24,0,0,1-10.26-6.68c-1.55,1-2.47,2-2.15,2.81,1.15,3,14.14,7.54,16.71,9.55s7.91,8.38,11.86,7.86a15.71,15.71,0,0,0,1.71-.38Z"
              fill="#531063"
            />
            <path
              d="M78.43,161.92c-3.1,1.1-17.62,6.05-16.7,8.89s13.19,6.91,15.54,8.78,7.12,7.86,11,7.26,22.21-7.86,19.24-10.24S81.32,160.9,78.43,161.92Z"
              fill="#531063"
            />
            <path d="M79,162.27c2.5.44,21.28,8.12,30.38,16.38" fill="#531063" />
            <path
              d="M88.24,186.85c.2,0,1.09-.24,1.36-.31-2-2.46-4.28-5.24-6-7.82-3.37-5.07-8.67-4.54-13.51-5.91-3.78-1.08-6.76-1.7-6.74-4.31-1.18.83-1.84,1.63-1.62,2.31.92,2.84,13.19,6.91,15.54,8.78S84.39,187.45,88.24,186.85Z"
              fill="#531063"
            />
          </g>
          <g>
            <path
              d="M71.11,151c-5.09-5.3,3.17-4.08,25.62-4.8,11.79,5.58,60.88,38.41,63.3,43.15-5.69,2.62-24.84-6.12-34.61-6.11s-15.65-9.56-21.29-12.38S71.11,151,71.11,151Z"
              fill="#531063"
            />
            <path
              d="M72.72,150.1c-1.83-1.52.17-4.24,22.62-5,11.78,5.58,59.85,38.64,62.27,43.38-5.69,2.61-20.81-6.19-30.58-6.18s-15.65-9.56-21.28-12.38S72.72,150.1,72.72,150.1Z"
              fill="#531063"
            />
            <path d="M95.77,145.22s51.46,31.57,61.84,43.3" fill="#531063" />
            <path
              d="M129.55,183.58s2.12-.74,1.56-.84-.39-.29-3.68-1.55a14.66,14.66,0,0,1-5.83-3.87"
              fill="#531063"
            />
            <path
              d="M152.42,188.77c-.41-1.27-1.53-1.51-4.13-2.72"
              fill="#531063"
            />
            <path
              d="M114.15,174a137,137,0,0,0-17.94-12.5c-5.73-3.18-7.59-5.89-11.72-6.7-3.08-.61-8.8-4.32-10.06-7.27-2.59.91-2.57,1.9-1.71,2.61,0,0,27.39,17,33,19.86s11.5,12.38,21.28,12.38a20.24,20.24,0,0,1,2.16.12C123.63,179.65,116,175.67,114.15,174Z"
              fill="#531063"
            />
            <path
              d="M89.1,157.76c-1.42-1.84-3.31-2.08-6.09-4s-5.2-2.43-7.73-4.21-1.67-1.71-1.46-1.83-1.17-.72-3-.29"
              fill="#531063"
            />
          </g>
          <polygon
            points="143.21 139.78 132.36 145.55 144.41 149.85 153.73 144.29 143.21 139.78"
            fill="#531063"
            opacity="0.72"
          />
          <polygon
            points="130.53 146.57 119.68 152.34 131.73 156.64 141.05 151.08 130.53 146.57"
            fill="#531063"
            opacity="0.72"
          />
          <g>
            <path
              d="M94.87,133.68c-1.65-1.2,1.36-.93,5.94,1s28.62,10.76,35,12.25,40.48,15.68,42.38,16,2.28,2.22-2,3.55-7.59,1.86-8.27,2.53-6.5-3.51-11.43-5.15-12.51-3.63-15.11-4.74-9.69-3.79-11-4.86-5.22-3.25-10.92-5.42-11-1.42-14.81-2.72-16.21-3.75-15.83-6,3-2.3,3-3.16S94.87,133.68,94.87,133.68Z"
              fill="#531063"
            />
            <path
              d="M94.75,131.87c-1.66-1.2,1.35-.92,5.94,1s28.62,10.76,35,12.25,40.48,15.68,42.37,16,4.45,3.19.19,4.53-9.76.87-10.43,1.54-6.51-3.5-11.43-5.14c-4.71-1.57-12.33-3.56-15.12-4.75-2.59-1.11-9.68-3.78-11-4.86s-5.22-3.25-10.93-5.41-11-1.42-14.81-2.72-16.2-3.75-15.82-6,3-2.3,3-3.17S94.75,131.87,94.75,131.87Z"
              fill="#531063"
            />
            <path
              d="M94.87,133.68c-1.65-1.2,1.36-.93,5.94,1s28.62,10.76,35,12.25,40.48,15.68,42.38,16,2.28,2.22-2,3.55-7.59,1.86-8.27,2.53-6.5-3.51-11.43-5.15-12.51-3.63-15.11-4.74-9.69-3.79-11-4.86-5.22-3.25-10.92-5.42-11-1.42-14.81-2.72-16.21-3.75-15.83-6,3-2.3,3-3.16S94.87,133.68,94.87,133.68Z"
              fill="#531063"
            />
            <path
              d="M94.87,133.68c-1.65-1.2,1.36-.93,5.94,1s28.62,10.76,35,12.25,41.53,16.37,43.42,16.71"
              fill="#531063"
            />
            <path
              d="M92.28,134.21c.11-.2,1.28.72,1.14.75s.57,1.53,2.54,1.52,4.33,1.75,4.33,1.75"
              fill="#531063"
            />
            <path
              d="M94.83,131.88c.68-.67,3.19.59,4.23,1.08s6.66,2.38,6.66,2.38"
              fill="#531063"
            />
            <path
              d="M89.28,136.86s1.12.13.87.58-.24.44-.07.66.69.25,1.65.58a2.16,2.16,0,0,1,1.21.81"
              fill="#531063"
            />
            <path
              d="M167.94,169a4.32,4.32,0,0,1,1.59-.69,85.91,85.91,0,0,0-10.9-5.38c-4.68-1.94-8.72-2.79-14.69-4.67S136.29,157,131,153.91s-11.72-6.86-21.5-8.7a90.71,90.71,0,0,1-13.69-3.3c-2.93-.82-4.37-2.22-5-4.07a3.11,3.11,0,0,0-1.92,2.27c-.38,2.28,12,4.73,15.83,6s9.1.56,14.81,2.72,9.61,4.35,10.92,5.42,8.4,3.74,11,4.86,10.19,3.1,15.11,4.74S167.27,169.7,167.94,169Z"
              fill="#531063"
            />
          </g>
          <g>
            <path d="M175.66,151.39h0Z" fill="#531063" />
            <path
              d="M122,122.46c-2.51-.79-10.87,2.1-14,5.06s66.93,28.66,68.36,27.09c1.72-1.88-.4-3.06-.71-3.22h0c.41.21,6.81,3.41,8.07,2.22s.56-1.65.56-1.65,15.44,3.95,17.58,2.7S159.92,134.38,122,122.46Z"
              fill="#531063"
            />
            <path
              d="M121.31,123.82c-2.43-.74-10.75,2.18-13.92,5.12s65.53,25.84,67.28,24.91,0-2.92,0-2.92,6.86,3.21,8.17,2,.45-1.69.45-1.69,13.14,4.33,15.28,3.09S158.12,135,121.31,123.82Z"
              fill="#531063"
            />
            <path
              d="M199.68,153.75c-8.93-7.55-74.79-30-76.67-30.65Z"
              fill="#531063"
            />
            <path d="M115.69,123.43s.7.51.56,1" fill="#531063" />
            <path
              d="M112.42,124.75c.26-.13.52-.17.36.23s.69.46.69.46"
              fill="#531063"
            />
            <path
              d="M110.1,126l.62.73c.23.81,1.1,1.48,3.52,2.38s7.43,2.59,8.75,4"
              fill="#531063"
            />
            <path
              d="M119.7,123.73s1.55.59,3.46,1.45,2.53,2.18,4,2.65,7.24,1.76,7.5,1.83l-15.48-7.15C119,122.51,119.54,123.76,119.7,123.73Z"
              fill="#531063"
            />
            <path
              d="M108.49,128.06a10.33,10.33,0,0,0-1.1.88c-3.17,2.93,65.53,25.84,67.28,24.91a1.38,1.38,0,0,0,.74-.83c-9.19-3.75-30.4-10.62-41.48-13.77C123.9,136.4,114.36,131.26,108.49,128.06Z"
              fill="#531063"
            />
          </g>
          <path
            d="M98.5,138.87c-.1-.78,1.12-.18,2.58.08s3.16-.64,4.45-.29-.57,1.35,0,1.79,2.27,1.92,1.16,2.19-1.65-.89-2.23.15-2.28,1.63-2.57.22.24-.75-2-.91-2.07-.46-.12-1.5"
            fill="#531063"
          />
          <path
            d="M129,179.62s5.53-2,8.64-.85c.43.08-1.24-1.74-3.13-2.08"
            fill="#531063"
          />
          <path d="M140.16,176.8s-2.13.92-2.19,1.78" fill="#531063" />
          <path d="M142.52,179.07a6.26,6.26,0,0,0-4.55-.49" fill="#531063" />
          <path
            d="M137.52,181.73s1.93-2.16.45-3.15c-2-1.3,2.28,2.53,2.28,2.53"
            fill="#531063"
          />
          <path d="M134.58,180.39s4.19-.46,3-1.62" fill="#531063" />
          <path d="M141.7,180.4a5.62,5.62,0,0,0-3.73-1.82" fill="#531063" />
          <text
            transform="matrix(1.36, 0.5, -0.65, 0.76, 126.33, 134.14)"
            fontSize="10.67"
            fill="#bf7bb2"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="-0.01em">W</tspan>
            <tspan x="8.97" y="0">
              h
            </tspan>
            <tspan x="14.89" y="0" letterSpacing="0em">
              a
            </tspan>
            <tspan x="19.99" y="0" letterSpacing="0.02em">
              t
            </tspan>
            <tspan x="23.74" y="0" letterSpacing="-0.07em">
              ’
            </tspan>
            <tspan x="25.18" y="0">
              s
            </tspan>
          </text>
          <text
            transform="matrix(1.35, 0.5, -0.66, 0.75, 131.25, 153.69)"
            fontSize="12.14"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            n
            <tspan x="6.74" y="0" letterSpacing="0em">
              e
            </tspan>
            <tspan x="12.78" y="0" letterSpacing="0.01em">
              x
            </tspan>
            <tspan x="18.56" y="0">
              t
            </tspan>
          </text>
          <text
            transform="matrix(0.91, 0.6, -0.88, 0.47, 87.93, 152.31)"
            fontSize="15.27"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="-0.01em">r</tspan>
            <tspan x="4.84" y="0">
              oom
            </tspan>
          </text>
          <text
            transform="matrix(0.91, 0.6, -0.88, 0.47, 74.47, 174.34)"
            fontSize="19.97"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            ?
          </text>
          <path
            d="M133.78,111.64s-.26-4.58,2.42-4S149,115,151.12,117.52c5.36-5.32,40.54,4.68,42.83,22.79"
            fill="#531063"
          />
        </g>
        <ellipse cx="57" cy="194.17" rx="28" ry="9" fill="#531063" />
        <g>
          <path
            d="M48.55,25.68s3.09,73.93,0,100.59S47.9,188.86,50,192.73s16,1.16,16,0-4.25-52.17-2.71-61.82S60.91,25.55,60.91,25.55Z"
            fill="#c84300"
          />
          <path
            d="M50,192.73c2.07,3.86,16,1.16,16,0,0-.19-.11-1.63-.29-3.95-5.62-1.9-13.49-6.31-14.27-11.38-1-6.7.65-43.15,1-51s1.42-41.35,1-45.47c-.32-3.46-1.55-42.73-1.94-55.28l-3,0s3.09,73.93,0,100.59S47.9,188.86,50,192.73Z"
            fill="#a63d00"
          />
          <path
            d="M48.55,35.43a3.34,3.34,0,0,0,3.35,2.94,74.92,74.92,0,0,0,9.45-1.47l.08-5.81Z"
            fill="#9d3818"
          />
          <path
            d="M93.69,11.08C89.5,16.23,78.08,28.53,62.33,31.8c-14.36,3-27.51,2-34.47-1.92-5.35,11-16.29,16-18.72,16C6.3,45.9,5,44.1,7.85,35.6s3.09-12.88,1-14.43S-3,9.84.89,3.4c3.28-5.47,20.77,5.4,27,9.91,5.81-5.22,16-9.94,28-12.44C71.66-2.39,87,4.35,92.93,7.4A2.42,2.42,0,0,1,93.69,11.08Z"
            fill="#a63908"
          />
          <path
            d="M93.69,12.24C89.5,17.38,78.08,29.69,62.33,33,48,35.94,34.82,35,27.86,31c-5.35,11-16.29,16-18.72,16-2.84,0-4.12-1.8-1.29-10.3s3.09-12.88,1-14.43S-3,11,.89,4.56c3.28-5.47,20.77,5.4,27,9.91,5.81-5.22,16-9.94,28-12.44C71.66-1.24,87,5.51,92.93,8.56A2.42,2.42,0,0,1,93.69,12.24Z"
            fill="#70220a"
          />
          <path
            d="M93.69,13C89.5,18.16,78.08,30.46,62.33,33.73c-14.36,3-27.51,2-34.47-1.92-5.35,11-16.29,16-18.72,16C6.3,47.83,5,46,7.85,37.53s3.09-12.88,1-14.43S-3,11.77.89,5.33c3.28-5.47,20.77,5.4,27,9.92,5.81-5.23,16-9.94,28-12.45C71.66-.46,87,6.28,92.93,9.33A2.42,2.42,0,0,1,93.69,13Z"
            fill="#f9d91e"
          />
          <path
            d="M77.7,3.6s-6.92,12.41,2.57,22"
            fill="none"
            stroke="#ce9e00"
            strokeMiterlimit="10"
            strokeWidth="1.42"
          />
          <ellipse cx="82.23" cy="11.06" rx="1.93" ry="3.09" fill="#ce9e00" />
          <ellipse cx="82.74" cy="10.87" rx="0.58" ry="1.16" fill="#fafee7" />
          <path
            d="M69.54,2.56S63.1,7.91,64,11.25s5.16,4.51,5.54,6.7-2.32,4.12-2.83,7.34,2.87,5.84,2.87,5.84"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M60,2.56s-3.81,5-3.94,8,5,3,5.41,6.18S55.12,22.07,56,24.91s6,4,5.41,6.57,0,1.8,0,1.8"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M52.46,4c-2.88.83-3.53,1.48-2.24,3.93s1.93,4.25,0,6.69-1.41,4.77,0,6.19,4.25,1.67,2.19,4.76-4.89,4.38-3.48,5.93a16.76,16.76,0,0,0,4.21,2.87"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M45.13,6.17c-2.64,1-4.44,1.61-3.79,4.44s2.83,3.09,1.8,6.18-2.71,2.32-1.93,6.31,4.5,2.84,3.86,6.19S41,34.74,41,34.74"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M36.07,10.1c-2.85,1.54-.66,2.18,0,4s.64,2.7-.65,5.28-2.19,3.48-.77,5.54,2.83,1.67,1.8,4.38a15.36,15.36,0,0,1-2.52,4.37"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M29.18,14.92c-1,3.68,1.47,9.21.05,10s-4.45,5-3.25,9.44"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M19.29,10.1s-1.65,3.22-1.4,9.27,4.51,9.27,4,12.11-5.21,2-4,6.62,2,3.42,2,3.42"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M9.94,5.51S6.17,6.88,6.3,9.71s2.06,3.73,3.61,7.08-.2,6.55,0,7.85a37.3,37.3,0,0,0,2.93,6.84c1.42,2.83-3.22,8.62-3.35,11.2a18.41,18.41,0,0,0,.26,4.38"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.03"
          />
          <path
            d="M27.3,28.13C21.76,33.28,14.67,43.58,10.42,42s-1.84-6.79-1.84-6.79h0c-.22.73-.47,1.48-.73,2.28C5,46,6.3,47.83,9.14,47.83c2.43,0,13.37-5,18.72-16,7,3.93,20.11,4.9,34.47,1.92C78.08,30.46,89.5,18.16,93.69,13a2.41,2.41,0,0,0,.39-2.39c-5.3,4.75-18.36,15.7-27.89,17.51C54,30.44,35.54,31.86,27.3,28.13Z"
            fill="#a57e0f"
            opacity="0.46"
          />
          <path
            d="M93.88,10.61a9.48,9.48,0,0,1-7.47,3.48"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.77"
          />
          <polygon
            points="48.29 122.47 47.39 141.98 62.84 139.92 62.84 120.09 48.29 122.47"
            fill="#9d3818"
            opacity="0.72"
          />
          <polygon
            points="48.55 156.34 47.65 175.85 55.37 173.28 64.78 175.85 63.1 153.96 48.55 156.34"
            fill="#9d3818"
            opacity="0.72"
          />
          <g>
            <path
              d="M34.41,147c-.74,4-4.45,22.54,0,25.38s18.67-2.32,22.85-1.93,15.6,4,17.55,0,5.29-28.73,0-29.24S35.11,143.27,34.41,147Z"
              fill="#d44000"
            />
            <path
              d="M75.47,168.52c-2.19-1.42-21.77-2.58-28.08-1.68-5,.71-11.25.38-15,.15.21,2.58.82,4.6,2.06,5.39,4.46,2.83,18.67-2.32,22.85-1.93s15.6,4,17.55,0a12,12,0,0,0,.66-1.93Z"
              fill="#a93b00"
            />
            <path
              d="M34.38,145.85c-.69,4-4.12,22.53,0,25.37s17.26-2.32,21.12-1.93,14.43,4,16.23,0,4.9-28.73,0-29.24S35,142.11,34.38,145.85Z"
              fill="#ff41d2"
            />
            <path
              d="M35.15,145.85c2.19-1.55,24.09-7.6,40.32-4.77"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.29"
            />
            <path
              d="M71.73,169.29c.1-.21.42-1.23.52-1.55-4.38-1.44-9.33-3.06-13.66-4.89-8.5-3.61-11.33,1.54-16.22,3.86-3.84,1.82-6.56,3.55-9.79.2.26,2.06.82,3.63,1.8,4.31,4.12,2.83,17.26-2.32,21.12-1.93S69.93,173.28,71.73,169.29Z"
              fill="#c62aa8"
            />
          </g>
          <g>
            <path
              d="M16,138.07c-9.92-2.45-3-7.86,10.94-27.69,14.69-2.83,87.71-2.45,95.18,1.55-.51,8.11-23.95,13.13-30.39,21.38s-22.15,1-29.37,2.19S16,138.07,16,138.07Z"
              fill="#ae3a00"
            />
            <path
              d="M16,135.62c-3.09-.38-5.16-5.53,8.75-25.37,14.69-2.83,87.33-1.29,94.8,2.71-.52,8.11-21.38,9.66-27.82,17.9s-22.15,1-29.37,2.19S16,135.62,16,135.62Z"
              fill="#d33c80"
            />
            <path
              d="M25.12,110s73-3.22,94.41,3"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.29"
            />
            <path
              d="M94.9,130.31a13,13,0,0,0,.19-2c0-.15,0-.37-.11-.41a1.33,1.33,0,0,1-.45.19l-1,.17c-1.29.26-2.53.69-3.81,1a12.39,12.39,0,0,1-3.93.37,26.92,26.92,0,0,1-3.9-.66,37.06,37.06,0,0,0,3.9.58,12.24,12.24,0,0,0,3.9-.42c1.27-.34,2.52-.76,3.82-1l1-.16a1.73,1.73,0,0,0,.46-.19c.21.11.14.32.17.48A13,13,0,0,1,94.9,130.31Z"
              fill="#682402"
            />
            <path
              d="M116.41,117.64A4.21,4.21,0,0,0,115,117a3.91,3.91,0,0,0-1.56,0c-1,.16-2,.45-3.1.6,1-.26,2-.52,3.08-.73a4.25,4.25,0,0,1,1.59,0A3.51,3.51,0,0,1,116.41,117.64Z"
              fill="#682402"
            />
            <path
              d="M72.84,131.05a142.47,142.47,0,0,0-27.31-.77c-7.72.77-12.3-1.1-16,1.35-2.78,1.82-11.15,1.92-15.64-.77-.57,3.34.66,4.58,2.12,4.76,0,0,39.15-1.41,46.36-2.57s22.93,6,29.37-2.19a12.32,12.32,0,0,1,1.58-1.66C86.14,130.3,76.21,131.64,72.84,131.05Z"
              fill="#a12880"
            />
            <path
              d="M36.26,131.57a7.68,7.68,0,0,0-3.29-.44c-1.12.08-2.22.31-3.34.4a31.23,31.23,0,0,1-3.35.09A19.42,19.42,0,0,0,23,132c-1.1.21-2.19.46-3.3.61a16.41,16.41,0,0,1-3.36.12,13.34,13.34,0,0,1-1.67-.19,2,2,0,0,1-.8-.3.41.41,0,0,1-.18-.39c0-.14.09-.29-.07-.29a2.13,2.13,0,0,0-1.4.79,4.28,4.28,0,0,0-.83,1.45,4.16,4.16,0,0,1,.81-1.47,2.19,2.19,0,0,1,1.42-.84.16.16,0,0,1,.17.16l0,.21a.34.34,0,0,0,.15.33,1.87,1.87,0,0,0,.77.27,11.7,11.7,0,0,0,1.66.18,16.19,16.19,0,0,0,3.34-.13c1.11-.16,2.19-.42,3.29-.64a20.94,20.94,0,0,1,3.35-.37,31.21,31.21,0,0,0,3.35-.06c1.11-.09,2.21-.31,3.33-.38A7.75,7.75,0,0,1,36.26,131.57Z"
              fill="#682402"
            />
          </g>
          <polygon
            points="49.65 63.09 49.65 79.58 62.91 74.89 62.18 59.97 49.65 63.09"
            fill="#9d3818"
            opacity="0.72"
          />
          <polygon
            points="49.71 82.41 49.71 98.9 62.97 94.21 62.23 79.29 49.71 82.41"
            fill="#9d3818"
            opacity="0.72"
          />
          <g>
            <path
              d="M10.23,96.07c-2.57-.13-.26-2.32,5.15-3.74S47.58,81.9,53.64,78.42s46.1-14.17,47.78-15.33,4.25.91,3.09,6.19-2.7,8.75-2.32,10.17-8.63,1-13.91,3.09-12.75,5.93-15.84,6.7-11.08,3.35-13.27,3.09-7.47.26-13.91,2.32-9,7.47-13.13,9-15.33,8.88-17.91,5.66-.9-5.41-1.93-6.57S10.23,96.07,10.23,96.07Z"
              fill="#00c4b8"
            />
            <path
              d="M7.91,93.88c-2.57-.13-.25-2.32,5.16-3.74S45.26,79.71,51.32,76.23,97.43,62.06,99.1,60.9s6.89.33,5.73,5.61-5.34,9.34-5,10.75-8.63,1-13.91,3.09c-5,2-12.52,5.87-15.84,6.7-3.09.77-11.07,3.35-13.26,3.09S49.39,90.4,43,92.46s-9,7.47-13.14,9-15.33,8.88-17.9,5.66S11,101.73,10,100.57,7.91,93.88,7.91,93.88Z"
              fill="#c34300"
            />
            <path
              d="M10.23,96.07c-2.57-.13-.26-2.32,5.15-3.74S47.58,81.9,53.64,78.42s46.1-14.17,47.78-15.33,4.25.91,3.09,6.19-2.7,8.75-2.32,10.17-8.63,1-13.91,3.09-12.75,5.93-15.84,6.7-11.08,3.35-13.27,3.09-7.47.26-13.91,2.32-9,7.47-13.13,9-15.33,8.88-17.91,5.66-.9-5.41-1.93-6.57S10.23,96.07,10.23,96.07Z"
              fill="#2fb2a2"
            />
            <path
              d="M10.23,96.07c-2.57-.13-.26-2.32,5.15-3.74S47.58,81.9,53.64,78.42,101.29,64.25,103,63.09"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.29"
            />
            <path
              d="M9.18,98.93c0-.14.15-.17.24-.19a2.06,2.06,0,0,1,.35,0,4.05,4.05,0,0,1,.7,0,1.37,1.37,0,0,1,.35.08.11.11,0,0,1,.08.1s0,0,0,0,.09.06.13.1a3.15,3.15,0,0,0,.63.27,2.33,2.33,0,0,0,2.53-.53,4,4,0,0,1,2.42-1.36,9.67,9.67,0,0,1,2.79-.17,11.67,11.67,0,0,0-2.77.26,3.8,3.8,0,0,0-2.35,1.36,2.43,2.43,0,0,1-2.64.52,2.69,2.69,0,0,1-.65-.29s-.1-.06-.14-.11a.16.16,0,0,1-.06-.1l0,0a1.59,1.59,0,0,0-.33-.08,3.94,3.94,0,0,0-.69-.07,1.38,1.38,0,0,0-.35,0C9.33,98.78,9.15,98.79,9.18,98.93Z"
              fill="#682402"
            />
            <path
              d="M8,93.81a.9.9,0,0,1,.15-.76,1.94,1.94,0,0,1,.63-.51A7.44,7.44,0,0,1,10.27,92a29.49,29.49,0,0,0,3.11-.79c2-.66,4-1.43,6.06-2.13-2,.81-4,1.55-6,2.25a31.67,31.67,0,0,1-3.13.76,7,7,0,0,0-1.5.53C8.33,92.82,7.84,93.24,8,93.81Z"
              fill="#682402"
            />
            <path
              d="M10.49,104.82a1.5,1.5,0,0,1,.73-.37.67.67,0,0,1,.65.46,1.94,1.94,0,0,0,.43.66.76.76,0,0,0,.73,0,12.67,12.67,0,0,1,1.51-.64,2.32,2.32,0,0,1,1.62.11,2.57,2.57,0,0,0-1.6,0,11.44,11.44,0,0,0-1.48.67,1,1,0,0,1-.43.08,1.44,1.44,0,0,1-.41-.15,2.24,2.24,0,0,1-.45-.71.56.56,0,0,0-.57-.43A1.38,1.38,0,0,0,10.49,104.82Z"
              fill="#682402"
            />
            <path
              d="M102.19,79.45a5.12,5.12,0,0,1,.2-2.21,71.58,71.58,0,0,0-13.86,2.34c-5.48,1.48-9.2,3.8-15.46,6.44s-6.62,4.83-14,5.35-16.23,1.15-25,7S26,103.34,21,105.75c-2.94,1.43-5.62.86-8.36-.93a6.5,6.5,0,0,0,1.55,4.51c2.58,3.22,13.79-4.12,17.91-5.66s6.69-7,13.13-9S57,92.07,59.17,92.33,69.35,90,72.44,89.24,83,84.6,88.28,82.54,102.58,80.87,102.19,79.45Z"
              fill="#05a595"
            />
          </g>
          <g>
            <path
              d="M14.23,58.93c-2.63,1.11-4.57,11.84-3,18.24S90.89,57.22,89.89,54c-1.29-4.12-4.51-3.47-4.51-3.47s8.79-1.34,8.12-4S91.82,44,91.82,44s15.08-8,14.94-11.37S54,42.14,14.23,58.93Z"
              fill="#a93f00"
            />
            <path
              d="M15.45,61.25c-2.52,1.11-4.38,11.84-2.84,18.24s75.22-22.35,75.22-25-3.61-3.75-3.61-3.75,8.51-1.69,7.86-4.35-1.8-2.53-1.8-2.53,14-5.56,13.91-8.94S53.57,44.46,15.45,61.25Z"
              fill="#d33c80"
            />
            <path
              d="M15.67,58.9c2.06-.75,73.28-27.69,88.52-25.62"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.29"
            />
            <path
              d="M11.26,65.5a2.19,2.19,0,0,1,.94.18,1.6,1.6,0,0,1,.71.65A3.17,3.17,0,0,0,11.26,65.5Z"
              fill="#682402"
            />
            <path
              d="M10.73,69.92a1.31,1.31,0,0,1,0-.28.26.26,0,0,1,.1-.14.19.19,0,0,1,.17,0,2.4,2.4,0,0,1,.36.44.41.41,0,0,0,.43.18,1.22,1.22,0,0,0,.49-.23.87.87,0,0,1-.47.32.53.53,0,0,1-.55-.19A2,2,0,0,0,11,69.6C10.82,69.47,10.76,69.77,10.73,69.92Z"
              fill="#682402"
            />
            <path
              d="M10.73,73.45l1.33.38h0a4.55,4.55,0,0,0,3.94.41c1.33-.33,2.61-.86,3.93-1.28s2.63-.83,4-1.13a9.79,9.79,0,0,1,4.1-.24,6.2,6.2,0,0,0-2.06,0,17.58,17.58,0,0,0-2,.35c-1.34.32-2.65.73-4,1.17S17.37,74,16,74.34a7.16,7.16,0,0,1-2.06.22,3.37,3.37,0,0,1-1.93-.7h0Z"
              fill="#682402"
            />
            <path
              d="M12.42,61.37c0,.18.25.27.38.38s.32.21.48.3l.49.27a1.59,1.59,0,0,0,.49.17v0c1.49-.39,3-.83,4.47-1.17s3.07.26,4.58.26a5.27,5.27,0,0,0,2.13-.77c.68-.36,1.35-.73,2-1.1l4-2.26c-1.32.78-2.63,1.58-4,2.33-.67.38-1.34.76-2,1.12a5.33,5.33,0,0,1-2.16.8c-1.56,0-3-.53-4.58-.28s-3,.76-4.46,1.12h0c-.25.06-.38-.1-.56-.16l-.49-.27-.46-.31C12.66,61.65,12.46,61.56,12.42,61.37Z"
              fill="#682402"
            />
            <path
              d="M12.25,77.45a20.08,20.08,0,0,0,.36,2c1.55,6.4,75.22-22.35,75.22-25a2.89,2.89,0,0,0-.55-1.69c-10.7,3-33.2,12.11-44.4,17.44C32.74,75.07,20.08,76.57,12.25,77.45Z"
              fill="#b7115d"
            />
          </g>
          <path
            d="M19.05,99.61c-1-.9.52-1.16,1.81-2.06s1.29-3.48,2.57-4.12,1.29,2.19,2.19,2.31,3.87.52,3.48,1.81-2.19.25-1.29,2.06.52,4-1.41,2.45-.78-1.16-2.45.51S22,103.73,22,100.77"
            fill="#c0e9c5"
          />
          <path
            d="M89.63,125.75s1.16-7.21,4.64-8.37c.39-.26-3-1.16-4.64,0"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <path
            d="M93.5,112.75s-.26,3,.77,4.12"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <path
            d="M97.88,113.65s-3.22.38-3.61,3.22"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <path
            d="M97.88,121.25s-1.42-4.38-3.61-4.38c-2.91,0,4.64,1.28,4.64,1.28"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <path
            d="M94.27,122s2.19-4.12,0-4.64"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <path
            d="M99,116s-2.9-1-4.7.84"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.16"
          />
          <text
            transform="matrix(0.95, -0.32, 0.32, 0.95, 31.48, 70.23)"
            fontSize="17.02"
            fill="#ffde00"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="0em">W</tspan>
            <tspan x="14.32" y="0">
              h
            </tspan>
            <tspan x="23.77" y="0" letterSpacing="0em">
              a
            </tspan>
            <tspan x="31.9" y="0" letterSpacing="0.02em">
              t
            </tspan>
            <tspan x="37.9" y="0" letterSpacing="-0.07em">
              ’
            </tspan>
            <tspan x="40.19" y="0">
              s
            </tspan>
          </text>
          <text
            transform="translate(59.02 90.86) rotate(-18.29)"
            fontSize="19.33"
            fill="#c0e9c5"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            n
            <tspan x="10.73" y="0" letterSpacing="0em">
              e
            </tspan>
            <tspan x="20.35" y="0" letterSpacing="0.01em">
              x
            </tspan>
            <tspan x="29.56" y="0">
              t
            </tspan>
          </text>
          <text
            transform="translate(30.6 125.61)"
            fontSize="20.48"
            fill="#ffb0ec"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="-0.01em">r</tspan>
            <tspan x="6.49" y="0">
              oom
            </tspan>
          </text>
          <text
            transform="translate(47.13 164.96)"
            fontSize="26.78"
            fill="#ffde00"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            ?
          </text>
        </g>
      </g>
      <g
        className={`${styles.pointer} prefix__static-item`}
        onClick={() => history.push('/digital-map')}
        transform="translate(699 361)"
      >
        <defs>
          <linearGradient
            id="ee7a2a74-4801-4351-a9f8-81df3e357f7c"
            data-name="grad-28"
            x1="194.89"
            y1="302.11"
            x2="195.2"
            y2="339.58"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.08" stopColor="#f4cb76" />
            <stop offset="1" stopColor="#bf534f" />
          </linearGradient>
          <linearGradient
            id="a261df6a-34bf-49e8-9a16-76fa98554bd8"
            x1="192.49"
            y1="314.32"
            x2="192.65"
            y2="335.03"
            xlinkHref="#ee7a2a74-4801-4351-a9f8-81df3e357f7c"
          />
          <linearGradient
            id="b4ef6f9e-44c0-446c-809b-41f4d17baeaa"
            x1="194.99"
            y1="319.34"
            x2="194.26"
            y2="346.54"
            xlinkHref="#ee7a2a74-4801-4351-a9f8-81df3e357f7c"
          />
          <linearGradient
            id="fc62beb5-6f1e-44b5-894b-9e7b232a3bf4"
            x1="294.93"
            y1="291"
            x2="295.15"
            y2="318.02"
            gradientTransform="translate(-81.55 93.95) rotate(-16.28)"
            xlinkHref="#ee7a2a74-4801-4351-a9f8-81df3e357f7c"
          />
          <linearGradient
            id="b3dfe434-6cdb-4742-aba5-2b68c4f8b495"
            x1="293.2"
            y1="299.81"
            x2="293.32"
            y2="314.74"
            gradientTransform="translate(-81.55 93.95) rotate(-16.28)"
            xlinkHref="#ee7a2a74-4801-4351-a9f8-81df3e357f7c"
          />
          <linearGradient
            id="f8137d19-e490-40a8-adb4-54009b393063"
            x1="295"
            y1="303.42"
            x2="294.48"
            y2="323.04"
            gradientTransform="translate(-81.55 93.95) rotate(-16.28)"
            xlinkHref="#ee7a2a74-4801-4351-a9f8-81df3e357f7c"
          />
        </defs>
        <g id="a5e42a2a-37ef-495a-8a91-738506181725" data-name="homeroom">
          <g>
            <g>
              <line
                x1="230.62"
                y1="90.75"
                x2="230.62"
                y2="108.77"
                fill="#2a0d8d"
                stroke="#344f59"
                strokeMiterlimit="10"
                strokeWidth="1.06"
              />
              <path
                d="M229.91,75.38V97.29s3.08-.09,11.56,7.86,27.67-4.68,31.2-8.57c-8.13-.35-13.78,0-13.78,0S272.67,92,272.67,83C259.6,83.86,247.58,90.78,229.91,75.38Z"
                fill="#83e8d8"
              />
              <g>
                <path
                  d="M241.47,105.32c8.48,8,27.67-4.85,31.2-8.74-8.13-.35-13.78,0-13.78,0,3.71,1.06,4.65,3.91-.52,5.83-5.8,2.15-8.37,3.37-14.62.91-4.35-1.7-13.55-6-13.55-6l1.56.57C233.59,98.86,234.79,99.06,241.47,105.32Z"
                  fill="#83cad8"
                  opacity="0.39"
                  style={{ mixBlendMode: 'multiply' }}
                />
                <path
                  d="M272.67,83a54.28,54.28,0,0,0-6.68.85s-.74,9.31-5.42,12.11C264.25,94.36,272.67,90,272.67,83Z"
                  fill="#83cad8"
                  opacity="0.43"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </g>
              <g>
                <g>
                  <path
                    d="M243.91,92.11s7.62,7.17,12.35,6c-2.59-4.27-14.33-9.91-14.33-9.91a1,1,0,0,1-.76,1.22Z"
                    fill="#751975"
                  />
                  <path
                    d="M241.93,89.37s-2.14,1.22-2.9-.61,0-2.44-.46-3.21c1.83.16,1.07.31,2.14.77S243.15,88.3,241.93,89.37Z"
                    fill="#9a0024"
                  />
                </g>
                <path
                  d="M246.81,90.74c-2.51-1.41-4.42-2.29-4.42-2.29a1.11,1.11,0,0,1-.92,1.22l2.75,2.75s.28.27.78.69A9.47,9.47,0,0,0,246.81,90.74Z"
                  fill="#f2f2d1"
                />
                <g>
                  <path
                    d="M254.58,87.69l-7.93,8.08a1.55,1.55,0,0,0,1.68,1.53l8.08-8.09A4.86,4.86,0,0,1,254.58,87.69Z"
                    fill="#eaab71"
                  />
                  <line
                    x1="254.58"
                    y1="87.69"
                    x2="247.11"
                    y2="95.77"
                    fill="none"
                    stroke="#ebc7ae"
                    strokeLinecap="round"
                    strokeLinejoin="bevel"
                    strokeWidth="0.76"
                  />
                  <line
                    x1="256.34"
                    y1="89.29"
                    x2="248.26"
                    y2="96.92"
                    fill="none"
                    stroke="#b08b32"
                    strokeLinecap="round"
                    strokeLinejoin="bevel"
                    strokeWidth="0.76"
                  />
                  <path
                    d="M255.67,86.8l-.06,0a1.18,1.18,0,0,0-.43,2l0,0a1.18,1.18,0,0,0,2-.63v-.07A1.18,1.18,0,0,0,255.67,86.8Z"
                    fill="#f9edcd"
                  />
                  <path
                    d="M257.24,88l.25-1.2a.34.34,0,0,0-.44-.4l-1,.33A1.67,1.67,0,0,0,257.24,88Z"
                    fill="#751975"
                  />
                </g>
              </g>
              <path
                d="M232.11,77.2s6.83,5.2,11.65,6.57c-.08,2.2,7.32,14.07,13.36,13.14-9.17-.07-21.57-10.58-22.77-12.63A24.65,24.65,0,0,1,232.11,77.2Z"
                fill="#83cad8"
                opacity="0.22"
              />
            </g>
            <polygon
              points="19.3 265.26 20 315.97 60.47 315.78 19.3 265.26"
              fill="#cadfe6"
            />
            <path
              d="M82.2,312.79c0,2.47-4.8,2-12.55,2.29a35.32,35.32,0,0,1-3.35-2.29c-.67-.69-1.33-1.49-2-2.3,9.7,0,17.56,1,17.92,2.21A.15.15,0,0,1,82.2,312.79Z"
              fill="#cadfe6"
            />
            <path
              d="M238.57,168.08s28.76,3.71,37,20.67,3.77,33.8-19.09,42.35C256.35,219.73,238.57,168.08,238.57,168.08Z"
              fill="#a2c1d2"
            />
            <rect
              x="92.8"
              y="124.97"
              width="38.34"
              height="101.77"
              fill="#f5f0f0"
            />
            <g opacity="0.36">
              <path
                d="M123.32,185.41H99.74a2.82,2.82,0,0,0,.48,0V144a4.43,4.43,0,0,0-.48,0l12.43-13.15L123.85,144c-.5,0-.48,0-.48,0v41.38S123.35,185.41,123.32,185.41Z"
                fill="#480694"
              />
              <path
                d="M120.43,182.73H103s0,0,0,0V145.38s0,0,0,0l8.94-11.12,8.53,11.12a0,0,0,0,1,0,0v37.31A0,0,0,0,1,120.43,182.73Z"
                fill="#480694"
              />
              <line
                x1="111.92"
                y1="131.27"
                x2="111.68"
                y2="185.41"
                fill="#480694"
              />
              <line
                x1="101.04"
                y1="151.9"
                x2="122.72"
                y2="151.9"
                fill="#480694"
              />
              <line
                x1="100.84"
                y1="160.11"
                x2="122.52"
                y2="160.11"
                fill="#480694"
              />
              <line
                x1="101.25"
                y1="168.35"
                x2="122.93"
                y2="168.35"
                fill="#480694"
              />
              <line
                x1="101.25"
                y1="176.58"
                x2="122.93"
                y2="176.58"
                fill="#480694"
              />
            </g>
            <g opacity="0.28">
              <path
                d="M126.63,125l-4.88-.64c-.7,12.4,3.82,35.78-15.58,50.64,17.54-13.43,25-21.2,25-21.2V126.61Z"
                fill="#e1e6f0"
              />
              <path
                d="M106.17,175l-1,1C105.49,175.63,105.83,175.3,106.17,175Z"
                fill="#6786a6"
              />
            </g>
            <g>
              <path
                d="M121.9,183.45h-20a0,0,0,0,1,0,0V145a0,0,0,0,1,0,0L112,132.76,121.9,145a0,0,0,0,1,0,0v38.4A0,0,0,0,1,121.9,183.45Z"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.18"
              />
              <path
                d="M119.82,181H103.6a0,0,0,0,1,0,0V146.29a0,0,0,0,1,0,0l8.3-10.32,7.92,10.32a0,0,0,0,1,0,0v34.63S119.84,181,119.82,181Z"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="111.92"
                y1="133.2"
                x2="111.69"
                y2="183.45"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="101.82"
                y1="152.34"
                x2="121.94"
                y2="152.34"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="101.63"
                y1="159.97"
                x2="121.75"
                y2="159.97"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="102.01"
                y1="167.61"
                x2="122.13"
                y2="167.61"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="102.01"
                y1="175.26"
                x2="122.13"
                y2="175.26"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
            </g>
            <path
              d="M92.13,195.38c-7.28-5.92,6.42-20.93,21.26-30.29s18.1-16.51,17.75-29.35c5.39,3.84,7,10.13,6.54,16.72-.73,11.34-7.36,23.57-10.6,25.69-5.13,3.36-33.7,25.43-33.64,33.21C92.16,195.3,92.13,195.38,92.13,195.38Z"
              fill="#fff"
            />
            <path
              d="M131.14,173.56s-16.61,9.36-22.26,19.78c5-7,20-11.76,22.26-7.42C131.26,176.76,131.14,173.56,131.14,173.56Z"
              fill="#98a1a3"
            />
            <path
              d="M134.05,138.46l-.92,1.31c3.59,10.33-1.33,20.28-14.47,28.58-1.28.8-4.77,3.22-6,4.06,0,0-23.89,18.28-12.94,28.53l1.62-1.22a211.53,211.53,0,0,1,25.77-21.57c3.24-2.12,9.87-14.35,10.6-25.69C138,147.25,137.1,142.23,134.05,138.46Z"
              fill="#e1e6f0"
            />
            <path
              d="M145.45,175.41l2,136.14L67,311.37s-55.83-39.05-10.15-85.69C95.89,210.48,103.93,215.17,145.45,175.41Z"
              fill="#acc6d2"
            />
            <rect
              x="145.81"
              y="87.15"
              width="41.88"
              height="179.16"
              fill="#f5f0f0"
            />
            <polygon
              points="194.75 289.82 256.42 289.82 256.42 203.24 194.75 204.3 194.75 289.82"
              fill="#fff"
            />
            <polygon
              points="244.14 288.52 256.42 288.52 256.42 201.94 244.14 203 244.14 288.52"
              fill="#f5f0f0"
            />
            <rect
              x="99.34"
              y="242.11"
              width="31.8"
              height="70.15"
              fill="#f5f0f0"
            />
            <g opacity="0.36">
              <circle cx="167.41" cy="237.91" r="14.53" fill="#480694" />
              <circle cx="167.37" cy="237.95" r="11.13" fill="#480694" />
              <polygon
                points="169.97 233.44 164.76 233.44 162.15 237.96 164.76 242.47 169.97 242.47 172.58 237.96 169.97 233.44"
                fill="#480694"
              />
              <line
                x1="162.54"
                y1="227.92"
                x2="164.78"
                y2="233.43"
                fill="#480694"
              />
              <line
                x1="172.12"
                y1="227.92"
                x2="169.88"
                y2="233.43"
                fill="#480694"
              />
              <line
                x1="172.59"
                y1="237.99"
                x2="178.54"
                y2="237.91"
                fill="#480694"
              />
              <line
                x1="162.15"
                y1="237.99"
                x2="156.28"
                y2="237.99"
                fill="#480694"
              />
              <line
                x1="164.78"
                y1="242.48"
                x2="162.54"
                y2="247.98"
                fill="#480694"
              />
              <line
                x1="169.88"
                y1="242.48"
                x2="172.12"
                y2="247.98"
                fill="#480694"
              />
            </g>
            <g opacity="0.36">
              <path
                d="M126.35,304.86H104.48a0,0,0,0,1,0,0V262.9a0,0,0,0,1,0,0l11-13.32,10.83,13.32s0,0,0,0v41.92A0,0,0,0,1,126.35,304.86Z"
                fill="#6786a6"
                opacity="0.28"
              />
              <path
                d="M124.08,302.14h-17.7s0,0,0,0V264.3s0,0,0,0L115.44,253l8.64,11.26s0,0,0,0v37.8S124.1,302.14,124.08,302.14Z"
                fill="#480694"
              />
              <line
                x1="115.46"
                y1="250.01"
                x2="115.21"
                y2="304.86"
                fill="#480694"
              />
              <line
                x1="104.44"
                y1="270.91"
                x2="126.39"
                y2="270.91"
                fill="#480694"
              />
              <line
                x1="104.23"
                y1="279.23"
                x2="126.19"
                y2="279.23"
                fill="#480694"
              />
              <line
                x1="104.65"
                y1="287.57"
                x2="126.6"
                y2="287.57"
                fill="#480694"
              />
              <line
                x1="104.65"
                y1="295.91"
                x2="126.6"
                y2="295.91"
                fill="#480694"
              />
            </g>
            <path
              d="M166.83,90s16.79,15.37,0,35.34c6.54.35,15.38-.88,20.85-13.78V87.15Z"
              fill="#e1e6f0"
            />
            <g>
              <path
                d="M125.44,302.54h-20a0,0,0,0,1,0,0V264.09s0,0,0,0l10.11-12.21,9.93,12.21a0,0,0,0,1,0,0V302.5S125.46,302.54,125.44,302.54Z"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.18"
              />
              <path
                d="M123.35,300.05H107.14s0,0,0,0V265.38a0,0,0,0,1,0,0l8.3-10.32,7.91,10.32a0,0,0,0,1,0,0V300S123.37,300.05,123.35,300.05Z"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="115.45"
                y1="252.29"
                x2="115.23"
                y2="302.54"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="105.36"
                y1="271.43"
                x2="125.47"
                y2="271.43"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="105.17"
                y1="279.06"
                x2="125.28"
                y2="279.06"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="105.55"
                y1="286.7"
                x2="125.66"
                y2="286.7"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
              <line
                x1="105.55"
                y1="294.34"
                x2="125.66"
                y2="294.34"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.5"
              />
            </g>
            <g opacity="0.36">
              <path
                d="M247.72,243.31H203.41s.2-21.79,22.16-21.79C247.72,221.52,247.72,243.31,247.72,243.31Z"
                fill="#6786a6"
                opacity="0.28"
              />
              <path
                d="M239.69,242.21H211.44s.13-13.89,14.13-13.89S239.69,242.21,239.69,242.21Z"
                fill="#4b48d6"
              />
              <path
                d="M233.45,242H217.68s.08-7.75,7.89-7.75S233.45,242,233.45,242Z"
                fill="#4b48d6"
              />
              <line
                x1="225.53"
                y1="221.48"
                x2="225.53"
                y2="234.2"
                fill="#4b48d6"
              />
              <line
                x1="230.91"
                y1="236.06"
                x2="241.81"
                y2="227.84"
                fill="#4b48d6"
              />
              <path
                d="M220.26,236.06c-.29.26-9.64-8.22-9.64-8.22"
                fill="#4b48d6"
              />
            </g>
            <g>
              <path
                d="M244.58,242.82h-38s.18-18.7,19-18.7C244.58,224.12,244.58,242.82,244.58,242.82Z"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="2.01"
              />
              <path
                d="M237.69,241.88H213.44S213.55,230,225.57,230,237.69,241.88,237.69,241.88Z"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.28"
              />
              <path
                d="M232.33,241.69H218.8s.06-6.65,6.77-6.65S232.33,241.69,232.33,241.69Z"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
              <line
                x1="225.53"
                y1="224.09"
                x2="225.53"
                y2="235.01"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
              <line
                x1="230.15"
                y1="236.6"
                x2="239.5"
                y2="229.55"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
              <path
                d="M221,236.6c-.24.23-8.26-7-8.26-7"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <circle cx="166.88" cy="110.87" r="14.53" fill="#e1e6f0" />
              <circle
                cx="166.84"
                cy="110.91"
                r="11.13"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.86"
              />
              <polygon
                points="169.44 106.4 164.23 106.4 161.62 110.92 164.23 115.43 169.44 115.43 172.05 110.92 169.44 106.4"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="162.01"
                y1="100.88"
                x2="164.25"
                y2="106.39"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="171.59"
                y1="100.88"
                x2="169.35"
                y2="106.39"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="172.06"
                y1="110.95"
                x2="178.01"
                y2="110.87"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="161.62"
                y1="110.95"
                x2="155.75"
                y2="110.95"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="164.25"
                y1="115.43"
                x2="162.01"
                y2="120.94"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="169.35"
                y1="115.43"
                x2="171.59"
                y2="120.94"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <circle
                cx="166.88"
                cy="110.87"
                r="14.53"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
            </g>
            <path
              d="M145.81,215.77c-14.67-9.53,1.23-18,12-21.37s38-5.65,30-29.68c7.77,15,11.48,34.81-.18,41.52s-11.48,7.07-11.48,7.07"
              fill="#fff"
            />
            <path
              d="M148.58,215.56c8.58-2.8,51-15.49,43.7-37.76,6.18,12.54,4,28.14-5.3,33.74S175.84,225,175.84,225"
              fill="#e1e6f0"
            />
            <path
              d="M234.86,219.49c9.64-1.17,16.81-2.94,21.56-5.63V203.24H227.58l-18.87,3.36-14-3.36.18,6.89S207.3,222.85,234.86,219.49Z"
              fill="#6786a6"
              opacity="0.28"
            />
            <path
              d="M145.81,145.27c-14.67-9.53,2.8-13.24,13.58-16.59,8.45-2.64,23.35-3.77,26.4-17.81a84.46,84.46,0,0,0,1.9-16.14c7.77,15,11.65,34.3,0,41s-11.48,7.07-11.48,7.07"
              fill="#fff"
            />
            <path
              d="M140.59,166.75c-.7,6-34.1,35.69-57.6,40.29S28.4,226.12,22.74,243.26s-8.66,46.47,26.86,72.8c21.91-.71,21.91,0,21.91,0S38.2,287.87,39.09,266s3.13-35.68,37.19-46c14-4.24,64.31-26.86,68.73-37.11s1.06-16.08,1.06-16.08Z"
              fill="#fff"
            />
            <line
              x1="24.51"
              y1="287.26"
              x2="43.33"
              y2="287.33"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="21.15"
              y1="274.18"
              x2="37.67"
              y2="274.25"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="22.21"
              y1="280.54"
              x2="39.26"
              y2="280.61"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="19.92"
              y1="267.47"
              x2="36.97"
              y2="267.54"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="21.33"
              y1="254.57"
              x2="38.91"
              y2="254.64"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="134.59"
              y1="172.41"
              x2="147.4"
              y2="172.48"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M82,212.07h3V208h8.11v-3.36h9.19v-3.71h6l.18-4.42h8.3l18.38-20.14v-4.77l3.53-.18s2.83-5.3,7.07-4.77h-7.07S117.24,188,98.63,199.88c-14,8.9-21.91,8.13-21.91,8.13Z"
              fill="#acc6d2"
            />
            <line
              x1="22.92"
              y1="248.21"
              x2="39.97"
              y2="248.28"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="24.86"
              y1="242.02"
              x2="42.44"
              y2="242.1"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="28.57"
              y1="236.02"
              x2="44.56"
              y2="236.09"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="34.58"
              y1="230.18"
              x2="52.16"
              y2="230.26"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="40.06"
              y1="225.06"
              x2="57.64"
              y2="225.13"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="47.3"
              y1="219.94"
              x2="71.24"
              y2="220.01"
              fill="none"
              stroke="#93b0b8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2.65"
            />
            <line
              x1="63.38"
              y1="212.87"
              x2="90.24"
              y2="213.05"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="85.11"
              y1="208.98"
              x2="100.05"
              y2="209.06"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="93.24"
              y1="205.36"
              x2="107.11"
              y2="205.43"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="116.83"
              y1="201.63"
              x2="102.43"
              y2="201.56"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="122.84"
              y1="197.57"
              x2="108.44"
              y2="197.5"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="114.62"
              y1="191.49"
              x2="133.79"
              y2="191.56"
              fill="none"
              stroke="#93b0b8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.94"
            />
            <line
              x1="119.75"
              y1="186.72"
              x2="140.51"
              y2="186.79"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="125.58"
              y1="181.95"
              x2="144.75"
              y2="182.02"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="146.69"
              y1="177.25"
              x2="130.17"
              y2="177.18"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="20.27"
              y1="260.93"
              x2="37.32"
              y2="261"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M81.93,192.2V313.58h-.1L67.89,313c-.67-.68-3-2.19-3.71-3-3.89-4.38-8.63-8.92-12.2-13.89-3.73-5.2-6.48-9.32-6.55-9.43h0l-.07-94.44Z"
              fill="#f5f0f0"
            />
            <line
              x1="33.52"
              y1="300.51"
              x2="51.99"
              y2="300.58"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="59.23"
              y1="307.3"
              x2="39.25"
              y2="307.3"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="64.71"
              y1="313.3"
              x2="46.31"
              y2="313.3"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="28.75"
              y1="293.79"
              x2="47.48"
              y2="293.79"
              fill="none"
              stroke="#eef1f4"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M185.5,332.75s-9.94-36.22,13.87-57.95,49.4-20.73,71.09-35S293.61,208,293.61,208l.09,98.42S274.57,332.05,185.5,332.75Z"
              fill="#fff"
            />
            <g>
              <path
                d="M293.65,207.59A29.26,29.26,0,0,1,288.57,223c-16.35,24.66-52.79,31.66-81.71,48.25l-.89.51a36.67,36.67,0,0,0-11.09,9.92c-14.72,19.9-6.95,50.69-6.95,50.69h-.37c-1.52,0-7.61.08-16.15.14-19.35.15-51.31.32-71.48.09-7.11-.08-12.76-.21-15.88-.41-.38-8.15,2.49-17.42,7.64-26.67h0a.16.16,0,0,0,0-.07c.37-.65.74-1.31,1.13-2a101.62,101.62,0,0,1,7.08-10.34c.44-.56.88-1.12,1.34-1.67.64-.8,1.29-1.59,2-2.37q1.67-2,3.44-3.84h0c2.65-2.85,5.47-5.6,8.43-8.21.83-.74,1.67-1.46,2.51-2.17q2.92-2.45,6-4.69,3.3-2.42,6.72-4.58c2.27-1.43,4.58-2.76,6.91-4h0l1.3-.67,1.35-.67q2.93-1.43,5.93-2.68a168.73,168.73,0,0,1,26.72-8.49l.75-.18c4.88-1.13,9.72-2.08,14.4-2.89,2.44-.43,4.85-.82,7.19-1.17,4.17-.64,8.17-1.19,11.92-1.68,7.27-.94,13.62-1.69,18.47-2.51h.08c12.51-3,23.13-6,31.61-9.66,16.61-7.1,25-16.42,23.08-31.86-2.85-23.33-33-30-33-30l-.35-1.83L245,158.94l-.89-4.64,2.22,1.06,0,0c6,2.91,22.39,10.89,26.22,13.76a41.27,41.27,0,0,1,3.83,3.42C282.84,178.85,294.15,192.48,293.65,207.59Z"
                fill="#eef1f4"
              />
              <path
                d="M283.48,209.74l-1.25,1.95,0,3.14-2.88,2.24-.21,3-4.08,2,.21,3.18-4.7.36v4.89s-8.57,0-9.15.32c-1.48.72-1.7,1.18-1.7,1.18v2.65s-7.95.29-8.34.44c-.87.33-2.64,1-2.64,1l0,3.67s-13.79.8-15.14,1.19c-1.17.34-5.54,1.15-5.54,1.15v2.83s-13.23,1-15.19,1.5-17.14,1.5-17.14,1.5v5.48s-9.71.43-10.5.62c-2.18.51-15.3.26-15.3.26l.18,7.95-14-.35s-7.59,1.37-10.42,2.63l0,0c-1.81.81-2,1.68-3.64,2.62l.14,0-.17,7.07s-12.23.33-12.45.53a71.45,71.45,0,0,0-6,5.87c-.47.51-1,8.09-1,8.09a27.17,27.17,0,0,0-5.52.53c-2.87.83-4.73,6.89-4.73,6.89l-.35,6.36h-2.87c1.06,0-.88,1.91-1.29,2.85s-.8,1.88-1.18,2.81c-.24.59-.44,8.95-.67,9.53-1,2.73-4.12,5.07-4.62,7.18,0,.08-.24,7.66-.33,7.67-3.18.17-1.06,0-17.81-.18-.41-8.75,2.92-18.78,8.81-28.71a101.56,101.56,0,0,1,7.84-11.3q3.15-4,6.73-7.73a122.74,122.74,0,0,1,9.2-8.73l.54-.46q3.5-3,7.18-5.63,3.3-2.37,6.72-4.49a97.84,97.84,0,0,1,8.81-4.86q3.3-1.61,6.69-3a170.14,170.14,0,0,1,26.72-8.35l.75-.18c4.89-1.11,9.72-2.05,14.4-2.85q3.67-.63,7.19-1.15c4.18-.64,8.18-1.17,11.92-1.66,7-.9,13.1-1.63,17.79-2.43l.68-.16h0c12.6-3,23.25-6.12,31.7-9.82,16.1-7.06,24.17-16.33,22.31-31.54-2.85-23.32-33-30-33-30L243,166.67c.09,0,1.54.24,3.64.64,1,.19,2.14.42,3.36.68,5.07,1.09,11.37,2.77,13.32,4.68l.09.09c.92.86,3.26,2.47,6.06,4.77a61.43,61.43,0,0,1,6,5.65,38.63,38.63,0,0,1,5.25,7.07,27.33,27.33,0,0,1,2.54,6,22.74,22.74,0,0,1,.84,5.65,42.49,42.49,0,0,1-.39,4.71Z"
                fill="#fff"
              />
              <rect
                x="86.33"
                y="317.73"
                width="88.87"
                height="7.42"
                rx="3.15"
                fill="#fff"
              />
              <rect
                x="91.65"
                y="302.54"
                width="88.87"
                height="7.42"
                rx="3.15"
                fill="#fff"
              />
              <path
                d="M187.45,281.69H118.53a3.72,3.72,0,0,1-3.71-3.71h0a3.72,3.72,0,0,1,3.71-3.71h73.75c2,0-1.12,1.67-1.12,3.71h0A3.72,3.72,0,0,1,187.45,281.69Z"
                fill="#fff"
              />
              <path
                d="M207.15,268.79h-66.1a4.41,4.41,0,0,1-4.17-4.24h0c0-2,.31-2.65-.8-2.47l73.3.17c5.7-.17,4.81,1.95,4.81,1.95C214.19,266.24,209.44,268.79,207.15,268.79Z"
                fill="#fff"
              />
              <path
                d="M180,295.12H104.85c-2,0-3.71-.61-3.71-2.65h0a3.72,3.72,0,0,1,3.71-3.71H180a3.72,3.72,0,0,1,3.71,3.71h0C183.75,294.51,182.08,295.12,180,295.12Z"
                fill="#fff"
              />
              <line
                x1="248.79"
                y1="235.66"
                x2="274.14"
                y2="235.66"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="259.77"
                y1="231.07"
                x2="279.31"
                y2="231.07"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="270.25"
                y1="226.3"
                x2="284.78"
                y2="226.3"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="275.57"
                y1="221.17"
                x2="288.39"
                y2="221.17"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="278.99"
                y1="215.87"
                x2="290.09"
                y2="215.87"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="281.26"
                y1="205.62"
                x2="290.66"
                y2="205.62"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="281.71"
                y1="201.03"
                x2="290.55"
                y2="201.03"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="280.67"
                y1="192.02"
                x2="289.5"
                y2="192.02"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="278.22"
                y1="187.43"
                x2="287.62"
                y2="187.43"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="272.77"
                y1="183.01"
                x2="284.45"
                y2="183.01"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="249.55"
                y1="167.99"
                x2="265.22"
                y2="167.99"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="245.94"
                y1="163.4"
                x2="257.05"
                y2="163.4"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="281.75"
                y1="196.61"
                x2="290.01"
                y2="196.61"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="280.69"
                y1="210.75"
                x2="290.66"
                y2="210.75"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="229.23"
                y1="240.96"
                x2="263.7"
                y2="240.96"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2.3"
              />
              <line
                x1="195.81"
                y1="246.44"
                x2="250.79"
                y2="246.44"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="3"
              />
              <line
                x1="234.55"
                y1="254.57"
                x2="165.24"
                y2="254.57"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="4.42"
              />
              <path
                d="M245.43,158.89s41.4,15.55,44.25,38.87S283,231,259.1,241.76c-16.16,7.28-22.6,8.3-52.79,23s-35.51,44-34.37,67.85c16.52,1.06,16.33-.36,16.33-.36s-10.8-41.92,18.26-58.88,67-25,83.48-49.9-11.27-50.6-17.58-54.48c-4.88-3-28-14.84-28-14.84Z"
                fill="#fff"
              />
              <line
                x1="269.94"
                y1="178.94"
                x2="281.62"
                y2="178.94"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="265.17"
                y1="174.88"
                x2="276.85"
                y2="174.88"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
              <line
                x1="260.05"
                y1="171.7"
                x2="271.73"
                y2="171.7"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="1.94"
              />
            </g>
            <path
              d="M255.53,282.22c-4.24-6,1.77-16.26,3.36-16.61s6.54,9.9,4.95,13.08c6.18-7.07,15.72-4.77,15.72-4.77s-4.95,9.71-11.84,10.77c3.71,2.83,7.6,9.19,7.25,11.49s-11.66-1.24-13.43-6.89c0,4.24-1.06,12.37-6,13.78-2.83-4.59-1.06-13.78-1.06-13.78-4.42,2.12-9.54,3.88-12.54,2.12C244.4,283.81,255.53,282.22,255.53,282.22Z"
              fill="#aec3cc"
            />
            <path
              d="M255.18,280.1c-4.24-6,1.77-16.26,3.36-16.61s6.53,9.9,4.94,13.08c6.19-7.07,15.73-4.78,15.73-4.78s-4.95,9.72-11.84,10.78c3.71,2.83,7.6,9.19,7.24,11.49s-11.66-1.24-13.42-6.89c0,4.24-1.06,12.37-6,13.78-2.83-4.6-1.06-13.78-1.06-13.78-4.42,2.12-9.54,3.88-12.55,2.12C244.05,281.69,255.18,280.1,255.18,280.1Z"
              fill="#da0d46"
            />
            <path
              d="M256.16,280.5c-3.44-4.88,1.44-13.19,2.73-13.48s5.3,8,4,10.61c5-5.73,12.76-3.87,12.76-3.87s-4,7.89-9.61,8.75c3,2.29,6.17,7.45,5.88,9.31s-9.46-1-10.89-5.59c0,3.44-.86,10-4.88,11.18-2.29-3.72-.86-11.18-.86-11.18-3.58,1.72-7.74,3.16-10.18,1.72C247.13,281.79,256.16,280.5,256.16,280.5Z"
              fill="#de597f"
            />
            <line
              x1="115.64"
              y1="186.63"
              x2="115.64"
              y2="204.65"
              fill="#2a0d8d"
              stroke="#344f59"
              strokeMiterlimit="10"
              strokeWidth="1.06"
            />
            <g>
              <path
                d="M114.18,176.91v15.65s4.65,7.47,15.65,2.54S141,186.78,141,186.78s-5.5,2.25-8.46-2.12c3.24.28,6.06.85,11-10.57-1.27-1.84-6.91,4.08-14.67,2.39A32.11,32.11,0,0,0,114.18,176.91Z"
                fill="#db3669"
              />
              <path
                d="M114.18,188.33v4.23s4.65,7.47,15.65,2.54S141,186.78,141,186.78a9.37,9.37,0,0,1-2.64.56,87.15,87.15,0,0,1-13,3.74A13.88,13.88,0,0,1,114.18,188.33Z"
                fill="#c2657f"
                opacity="0.19"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M132.34,184.77c6.09,0,6.3-1.36,11.17-10.68a.75.75,0,0,0-.19-.17c-1.21,1.14-8,7.23-14.48,6.72A8.58,8.58,0,0,0,132.34,184.77Z"
                fill="#c2657f"
                opacity="0.19"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M117.57,181.17a.46.46,0,0,1,.35.15.72.72,0,0,1,.13.4c.06.6.11,1.19.16,1.75s.08,1.12.13,1.68c0,.29,0,.58,0,.86l0,.87,0,.88c0,.29,0,.59,0,.89a.87.87,0,0,1-.06.44.54.54,0,0,1-.38.2,7.82,7.82,0,0,1-1,.12.58.58,0,0,1-.45-.12.7.7,0,0,1-.16-.39c-.09-.64-.16-1.26-.22-1.85s-.1-1.19-.13-1.78,0-1.12-.07-1.69,0-1.14,0-1.75a.6.6,0,0,1,.09-.38.59.59,0,0,1,.3-.18,2.93,2.93,0,0,1,.68-.11A4,4,0,0,1,117.57,181.17Z"
                fill="#f3dc3d"
              />
              <path
                d="M125,182.65a2.17,2.17,0,0,1-.2.85,9.69,9.69,0,0,1-.58,1.17c-.24.42-.52.87-.83,1.33s-.62.92-.93,1.36l1.79-.16.19,0,.24,0,.23,0,.16,0a.56.56,0,0,1,.32.07.5.5,0,0,1,.14.25,2.41,2.41,0,0,1,.07.5,2.67,2.67,0,0,1,0,.57.46.46,0,0,1-.13.32.56.56,0,0,1-.31.12l-1.3.16c-.39,0-.81.08-1.26.11l-.9,0h-1.09a.85.85,0,0,1-.34-.09.5.5,0,0,1-.19-.32l-.06-.32a1.87,1.87,0,0,1,0-.34v-.35a1,1,0,0,1,0-.34,1.42,1.42,0,0,1,.21-.34q.72-1,1.41-1.95a24,24,0,0,0,1.29-2.13,6.54,6.54,0,0,0-1.25-.3,10.57,10.57,0,0,0-1.35-.12q-.37,0-.39-.27v-.09s0-.1,0-.21.07-.29.13-.47.13-.37.2-.56a.45.45,0,0,1,.18-.24.85.85,0,0,1,.41-.09,4.28,4.28,0,0,1,.51,0,5.74,5.74,0,0,1,.68,0l.77.13a6.57,6.57,0,0,1,.76.21,2.76,2.76,0,0,1,1,.6A1.41,1.41,0,0,1,125,182.65Z"
                fill="#a8ff61"
              />
              <path
                d="M132,185.71a1.81,1.81,0,0,1-.42,1.21,4.78,4.78,0,0,1-1.22,1.07c-.18.11-.36.21-.56.31s-.38.19-.57.27l-.53.21-.45.14-.38.11-.26.05a.68.68,0,0,1-.29-.06.84.84,0,0,1-.28-.26l-.32-.44a3,3,0,0,1-.25-.53.71.71,0,0,1-.06-.24c0-.19.13-.32.4-.38a7.63,7.63,0,0,0,.82-.21l.83-.31a6.7,6.7,0,0,0,.76-.36,3.18,3.18,0,0,0,.59-.4,1.36,1.36,0,0,0-.75-.39,5,5,0,0,0-1.06-.06l-.19,0-.3,0a.63.63,0,0,1-.34-.06.49.49,0,0,1-.22-.36,2.32,2.32,0,0,1-.06-.38v-.26c0-.08,0-.16,0-.24a.6.6,0,0,1,.16-.35.83.83,0,0,1,.35-.15,4.86,4.86,0,0,0,1.13-.43,2.43,2.43,0,0,0,.74-.64,3.11,3.11,0,0,0-.75-.14,7.3,7.3,0,0,0-.81,0,5.73,5.73,0,0,0-.71.06,3.09,3.09,0,0,1-.44,0,.3.3,0,0,1-.21,0,.26.26,0,0,1-.09-.23.6.6,0,0,1,0-.22,5.8,5.8,0,0,1,.19-.59,3.26,3.26,0,0,1,.26-.53,1,1,0,0,1,.3-.34,1.2,1.2,0,0,1,.4-.11l.26,0,.26,0a7.9,7.9,0,0,1,1.3,0,4.23,4.23,0,0,1,1.1.26,2.21,2.21,0,0,1,.77.49,1.1,1.1,0,0,1,.31.75,1.71,1.71,0,0,1-.07.59,1.74,1.74,0,0,1-.27.57,2.68,2.68,0,0,1-.46.5,2.33,2.33,0,0,1-.66.36,3.63,3.63,0,0,1,1.46.72A1.38,1.38,0,0,1,132,185.71Z"
                fill="#e8abcd"
              />
            </g>
            <line
              x1="113.12"
              y1="44.39"
              x2="113.12"
              y2="62.42"
              fill="none"
              stroke="#8fbdc9"
              strokeMiterlimit="10"
              strokeWidth="1.06"
            />
            <line
              x1="60.64"
              y1="92.28"
              x2="60.64"
              y2="114.01"
              fill="none"
              stroke="#8fbdc9"
              strokeMiterlimit="10"
              strokeWidth="1.06"
            />
            <line
              x1="166.3"
              y1="10.65"
              x2="166.3"
              y2="28.67"
              fill="none"
              stroke="#8fbdc9"
              strokeMiterlimit="10"
              strokeWidth="1.06"
            />
            <g>
              <path
                d="M112.41,28.77V50.33s37.82,13.78,38.52-16.26c-3.88,3.89-5.83,10.07-13.07,11,1.77-2.3,11.48-8.84,13.07-22.44C148.81,26.47,124.25,36.72,112.41,28.77Z"
                fill="#9ce967"
              />
              <path
                d="M128.58,35.91a6.1,6.1,0,1,0,6.1,6.1A6.1,6.1,0,0,0,128.58,35.91Zm0,10.07a4,4,0,1,1,4-4A4,4,0,0,1,128.58,46Z"
                fill="#d8fff2"
              />
              <rect
                x="125.31"
                y="34.85"
                width="6.71"
                height="1.94"
                fill="#d8fff2"
              />
              <rect
                x="130.79"
                y="38.92"
                width="6.71"
                height="1.94"
                transform="translate(118.91 -99.23) rotate(67.19)"
                fill="#d8fff2"
              />
              <rect
                x="128.67"
                y="45.63"
                width="6.71"
                height="1.94"
                transform="translate(264.04 -0.02) rotate(141.11)"
                fill="#d8fff2"
              />
              <rect
                x="121.78"
                y="45.63"
                width="6.71"
                height="1.94"
                transform="translate(196.34 159.56) rotate(-142.65)"
                fill="#d8fff2"
              />
              <rect
                x="119.66"
                y="38.92"
                width="6.71"
                height="1.94"
                transform="translate(38.93 138.14) rotate(-67.41)"
                fill="#d8fff2"
              />
            </g>
            <path
              d="M165,1.07l.86,14.7s6.38-1.39,11.33,5,23,3.5,28-8.86c-2.13,4.6-9.9,1.95-9.9,1.95S199,10.55,200.58,2c-3.41,1.89-11.69,5.84-21,.42C173.58-1.14,167,0,165,1.07Z"
              fill="#db3669"
            />
            <path
              d="M183.37,13a7.64,7.64,0,0,0,5.23,2.81s-1.27-7.21-9-13.35C177.87.82,169.94.23,165.7,1.65V7.3S178.42,6.59,183.37,13Z"
              fill="#db527a"
              opacity="0.46"
              style={{ mixBlendMode: 'multiply' }}
            />
            <g>
              <path
                d="M174.05,10.9l.87.12c.29.05.58.08.88.12-.08-.45-.16-.89-.25-1.34s-.2-.87-.33-1.27c-.21.41-.42.81-.61,1.21Zm-2.66,1.23c-.27-.08-.4-.24-.36-.46s.05-.35.07-.51a2.91,2.91,0,0,1,.1-.4.39.39,0,0,1,.17-.23.38.38,0,0,1,.26,0,3.69,3.69,0,0,1,.47.1c.32-.66.66-1.31,1-1.94s.7-1.23,1-1.8a.67.67,0,0,1,.53-.34h.59l.54,0,.26.05.21,0a.64.64,0,0,1,.45.44c.16.46.34,1.06.55,1.81s.39,1.56.57,2.46l.27,0h.23a.36.36,0,0,1,.34.36,2.28,2.28,0,0,1,0,.63l0,.18a1.21,1.21,0,0,1,0,.18.47.47,0,0,1-.17.27.5.5,0,0,1-.29.07c0,.17.05.33.07.48s0,.28,0,.4a1.36,1.36,0,0,1,0,.18v.08a.34.34,0,0,1-.3.3c-.22,0-.45.05-.67.06a5.32,5.32,0,0,1-.69,0,.49.49,0,0,1-.28-.13.59.59,0,0,1-.1-.3L176.07,13l-1.22-.15c-.26,0-.52-.07-.77-.12l-.75-.14c-.08.2-.15.39-.22.58l-.2.54a.38.38,0,0,1-.46.3,3.64,3.64,0,0,1-.64-.15,5.8,5.8,0,0,1-.62-.24.33.33,0,0,1-.21-.39.2.2,0,0,1,0-.07l0-.14.15-.4Z"
                fill="#e4982f"
              />
              <path
                d="M179.73,9.27c.05-.2.11-.32.21-.36a1.27,1.27,0,0,1,.39-.08,13.85,13.85,0,0,1,3,.16,7.51,7.51,0,0,1,1.09.23,5,5,0,0,1,.93.39,2,2,0,0,1,.63.54.93.93,0,0,1,.17.69,1.4,1.4,0,0,1-.21.57,1.91,1.91,0,0,1-.42.48,3,3,0,0,1-.58.37,4.89,4.89,0,0,1-.7.29,4,4,0,0,1,.78.28,2.34,2.34,0,0,1,.61.42,1.55,1.55,0,0,1,.37.58,1.6,1.6,0,0,1,.05.73,2,2,0,0,1-.41.95,2.6,2.6,0,0,1-.86.7,3.68,3.68,0,0,1-1.2.39,5,5,0,0,1-1.45,0c-.26,0-.55-.09-.86-.16a6.28,6.28,0,0,1-.86-.24.93.93,0,0,1-.43-.3,1.31,1.31,0,0,1-.12-.72c0-.36,0-.7,0-1s0-.64.07-.94.06-.6.1-.9.07-.6.12-.9l.09-.67a1.06,1.06,0,0,1-.31,0c-.19,0-.3-.15-.32-.39a2.29,2.29,0,0,1,0-.37,2.58,2.58,0,0,1,0-.39l0-.15Zm2.48,1.38-.09.68c0,.22-.05.45-.08.67a4.37,4.37,0,0,0,1.32-.38,2,2,0,0,0,.78-.59,2.76,2.76,0,0,0-1-.3l-.44-.05Zm1.8,3.54a.33.33,0,0,0-.07-.26.8.8,0,0,0-.26-.21,2,2,0,0,0-.41-.15,3.7,3.7,0,0,0-.48-.09,5.6,5.6,0,0,0-.89-.07l-.11,1.28.37.1.33.05a2.1,2.1,0,0,0,1.06-.06A.72.72,0,0,0,184,14.19Z"
                fill="#f3de3d"
              />
              <path
                d="M186.56,12.77a4.76,4.76,0,0,1,.13-1.77,4.33,4.33,0,0,1,2-2.6,4.28,4.28,0,0,1,1.64-.53,5.9,5.9,0,0,1,.84,0l0-.2a.36.36,0,0,1,.32-.32,2.38,2.38,0,0,1,.5,0,2.87,2.87,0,0,1,.61.15.36.36,0,0,1,.26.34.42.42,0,0,1,0,.16,6.34,6.34,0,0,1-.08.72c0,.26-.07.52-.11.79s-.09.53-.14.78-.09.49-.14.7a.56.56,0,0,1-.11.28.38.38,0,0,1-.24.11h-.22l-.34,0a3.39,3.39,0,0,1-.39-.08.45.45,0,0,1-.36-.4.13.13,0,0,1,0-.06v-.19c0-.11,0-.26,0-.46s.05-.41.08-.63h-.15l-.17,0a1.9,1.9,0,0,0-.77.26,2.48,2.48,0,0,0-.66.55,2.31,2.31,0,0,0-.44.8,2.12,2.12,0,0,0-.09,1,2,2,0,0,0,.19.69,1.67,1.67,0,0,0,1,.84,2.09,2.09,0,0,0,.76.05,4,4,0,0,0,1-.25,6.38,6.38,0,0,0,.9-.47.68.68,0,0,1,.25-.1.33.33,0,0,1,.27.14,1.65,1.65,0,0,1,.33.47,1.55,1.55,0,0,1,.16.52.8.8,0,0,1,0,.27.58.58,0,0,1-.14.24,3.81,3.81,0,0,1-.57.41,3.94,3.94,0,0,1-.71.36,5.29,5.29,0,0,1-.76.27,3.56,3.56,0,0,1-.72.15,4,4,0,0,1-1.39-.07,3.43,3.43,0,0,1-1.22-.53,3.14,3.14,0,0,1-.9-1A3.35,3.35,0,0,1,186.56,12.77Z"
                fill="#e8abcd"
              />
            </g>
            <g>
              <path
                d="M60.17,80.24V97a27.11,27.11,0,0,0,14.32,4.42c8.12,0,14.49-5.3,12.9-10.6H81s9.9-5.83,6.54-10.61C84.56,81.83,62.83,75.65,60.17,80.24Z"
                fill="#605cd4"
              />
              <circle cx="71.46" cy="89.4" r="1.57" fill="#d62e16" />
              <ellipse
                cx="71.2"
                cy="89.26"
                rx="2.79"
                ry="7.1"
                transform="translate(-36.71 51.97) rotate(-32.36)"
                fill="none"
                stroke="#a2dcfb"
                strokeMiterlimit="10"
                strokeWidth="0.35"
              />
              <ellipse
                cx="71.2"
                cy="89.26"
                rx="7.1"
                ry="2.79"
                transform="translate(-29.72 35.85) rotate(-23.53)"
                fill="none"
                stroke="#7edef6"
                strokeMiterlimit="10"
                strokeWidth="0.35"
              />
              <circle cx="75.99" cy="89.34" r="0.62" fill="#e8ff3c" />
              <circle cx="66.98" cy="85.46" r="0.62" fill="#81e536" />
            </g>
            <g>
              <path
                d="M253.23,159.6s-4.06-6.89-4.24-8.31,3.89-8.3,2.12-10.42-3,1.41-5.47,0-5.13-5-6.72-5.66-2.65-3-6.89,0-6.71-1.59-6.71-1.59a7.82,7.82,0,0,0-7.25,0c-4.24,1.95-9.54-1.23-10.6-.88s-.17,8.13,3.36,10.25c-3.71,3.18-7.07,7.6-3.71,8.3s18.2,4.63,18.2,4.63Z"
                fill="#dc46d4"
              />
              <path
                d="M267.37,195.64S257,219.49,222.84,216.31s-39.22-31.8-39.22-31.8,9-14.49,22.26-15,32.51,3,37.11,5.3S263.84,182.92,267.37,195.64Z"
                fill="#dc46d4"
              />
              <path
                d="M235.39,123.91c.35-1.24,2.12-5.31-3-5.66a48.08,48.08,0,0,0-9,0c-2.12.18-2.12,4.42,0,4.42s7.6,3.89,9,3.18A22.42,22.42,0,0,0,235.39,123.91Z"
                fill="#dc46d4"
              />
              <path
                d="M241.93,135.57s2.47-11-3-10.78-3.88.71-6.53,0-4.78-2.12-6.9-2.12-4.59,1.41-5.65,1.77-5.48,2.29-3.53,6.71,4.24,5.3,6.18,4.42,10.6.7,11.84,1.76,4.42,1.42,6.36,1.24S241.93,135.57,241.93,135.57Z"
                fill="#dc46d4"
              />
              <path
                d="M241.93,135.57s2.47-11-3-10.78-3.88.71-6.53,0-4.78-2.12-6.9-2.12,4.78,5.12,3.71,5.48-11.13.17-9.18,4.59.53,3.71,2.47,2.83,10.6.7,11.84,1.76,4.42,1.42,6.36,1.24S241.93,135.57,241.93,135.57Z"
                fill="#cd37c0"
              />
              <path
                d="M231.15,118.07c1.41-1.23,2.65-.35,1.59-4.06s-.35-8.48-1.59-8.83-2.65,3-4.42,5.3.88,4.77,0,6.18-1.59,3.53.71,3.36A5.76,5.76,0,0,0,231.15,118.07Z"
                fill="#dc46d4"
              />
              <path
                d="M231.15,118.07c1.41-1.23,1.59-.35.53-4.06s.71-6.36-.53-6.71-1.59.88-3.36,3.18.88,4.77,0,6.18-1.24,1.59,1.06,1.41S231.15,118.07,231.15,118.07Z"
                fill="#cd37c0"
              />
              <path
                d="M234.07,122.53c.27-1,1.59-4.06-2.24-4.33a35.59,35.59,0,0,0-6.74,0c-1.58.14-1.58,3.38,0,3.38s5.68,3,6.74,2.44A16.36,16.36,0,0,0,234.07,122.53Z"
                fill="#cd37c0"
              />
              <path
                d="M208.89,187.34c6.53,5.47,15.19,4.59,20.84,3.18s11-4.07,14-3,5.13,7.42,11.31,5.48,10.25,2.12,12,4.12c-2.95,5.15-14.83,21.9-43.76,19.2-31.43-2.93-38.25-27.47-39.12-31.3l-.11-.5s6.36,2.83,7.78,2.83S202.35,181.86,208.89,187.34Z"
                fill="#b529a2"
              />
              <path
                d="M249,151.29s-5.65-7.07-8.12-5.48-3.89-1.23-7.6-2.65-3,.71-5.3,1.06-5.48-1.41-9.54-2.12a14.48,14.48,0,0,0-7.6.89c-4.77-3.18-3.36-10.25-3.36-10.25s6.54,1.41,8.35,1.48,4-1.13,6-1.46,6.36,3,7.37,3.47,5.53-2.43,6.82-2.51.83.61,2.25.79,6,5.3,6.67,5.88a3.86,3.86,0,0,0,2.22.8c.42,0,2.24-1.56,4-.32s-2.12,8.89-2.12,8.89Z"
                fill="#dc46d4"
              />
              <path
                d="M251.64,140.87a3.43,3.43,0,0,0-1.44-.56,1.12,1.12,0,0,0-.33,0,.89.89,0,0,0-.29.15l-.72.41a4.73,4.73,0,0,1-3.49.55,5.73,5.73,0,0,1-1.58-1c-.44-.36-.84-.73-1.25-1.09-.79-.75-1.55-1.5-2.33-2.18a8.33,8.33,0,0,0-2.25-1.57c-.43-.12-1.16-.39-1.46-.47a1.36,1.36,0,0,0-.44,0,5.18,5.18,0,0,0-.56.1,22.94,22.94,0,0,0-2.86,1l-2.95,1.21-.45.19-.45-.16a10.56,10.56,0,0,1-2.85-1.59c-.84-.63-1.53-1.31-2.15-1.68a2.75,2.75,0,0,0-2.07-.33,17.86,17.86,0,0,0-2.69.56,7.56,7.56,0,0,1-3.17.44,26.67,26.67,0,0,1-2.93-.53c-1.91-.45-3.78-1-5.63-1.58,1.94.11,3.88.28,5.8.41,1,.06,1.93.14,2.83.12a6.75,6.75,0,0,0,2.49-.66,17.56,17.56,0,0,1,2.92-.89,5.88,5.88,0,0,1,1.77-.13,4.91,4.91,0,0,1,1.79.54,18.6,18.6,0,0,1,2.5,1.78,8.39,8.39,0,0,0,2.22,1.19l-.9,0c1-.43,2-.83,3-1.22a25.66,25.66,0,0,1,3.24-1.06,5.26,5.26,0,0,1,1-.13,4,4,0,0,1,1.15.18c.72.25,1,.39,1.57.61a6.3,6.3,0,0,1,1.66,1,13.91,13.91,0,0,1,1.23,1.19c.77.81,1.47,1.64,2.16,2.45.34.4.69.81,1,1.18a5.39,5.39,0,0,0,1,.89,3.88,3.88,0,0,0,2.77,0l.76-.25a1.7,1.7,0,0,1,.46-.12,1.41,1.41,0,0,1,.47.06A3.48,3.48,0,0,1,251.64,140.87Z"
                fill="#faf0da"
              />
              <path
                d="M209.59,149.53c3.86-.36,9.2-3.89,12.19-3.36s5.48,3.53,9.9,5.3c2.86,1.14,8.48-3.18,10.78-3.54s6.53,3.36,6.53,3.36c.18,1.42,4.24,8.31,4.24,8.31l-27.91-3.68s-14.84-3.92-18.2-4.63a3,3,0,0,1-.53-.16c-.52-.76,2.31-1.59,2.3-1.6Z"
                fill="#cd37c0"
              />
              <path
                d="M260.66,184.51c-.71-3.89-3-8.83,0-12.37s.35-9.89-7.07-12.54-11.49-5.66-12-6.54-6.18,2.83-9.18,3.36-9.19-.18-11.49-3.54-12.19-.17-15.37,0-4.24,13.43,0,15,20,5.47,26.77,6.53S260.66,184.51,260.66,184.51Z"
                fill="#dc46d4"
              />
              <path
                d="M205.53,167.9c-1.66-.62,7.95-.7,10.25,0s31.27,4.06,34.63,2.65,11-1.58,10.33,1.48a1,1,0,0,1-.08.11,5.78,5.78,0,0,0-.63.89c-2.2,4.77.63,11.48.63,11.48s-21.56-9-28.36-10.08S209.77,169.49,205.53,167.9Z"
                fill="#cd37c0"
              />
              <path
                d="M260.78,165.09a23.44,23.44,0,0,0-4.53-3.42,13.22,13.22,0,0,0-2.46-1.19,4.44,4.44,0,0,0-.6-.16l-.74-.16c-.5-.14-1-.29-1.44-.45a50.13,50.13,0,0,1-5.34-2.38c-.87-.46-1.72-.94-2.56-1.48-.42-.27-.84-.55-1.26-.88a5.94,5.94,0,0,1-1.3-1.3l1.31.54c-.59.19-1.35.49-2.07.79l-2.21.9a31.5,31.5,0,0,1-4.67,1.52,13.37,13.37,0,0,1-2.58.36,8,8,0,0,1-1.38-.05l-1.23-.19a18.27,18.27,0,0,1-4.81-1.56,7.61,7.61,0,0,1-1.17-.71,4.93,4.93,0,0,1-1-1,7.9,7.9,0,0,0-1.5-1.46,2.63,2.63,0,0,0-1.71-.55c-.74,0-1.54.06-2.33.11-3.15.2-6.31.41-9.49.5,3.09-.76,6.19-1.39,9.33-1.93.79-.13,1.56-.27,2.39-.37a4.12,4.12,0,0,1,1.47.08,5.25,5.25,0,0,1,1.33.55,9.8,9.8,0,0,1,2.05,1.68,3.44,3.44,0,0,0,.71.63,6.09,6.09,0,0,0,.88.48,16.43,16.43,0,0,0,4.26,1.16l1.12.16a6.39,6.39,0,0,0,1,0,10.73,10.73,0,0,0,2.11-.33,42.25,42.25,0,0,0,4.35-1.41l2.2-.86a22.78,22.78,0,0,1,2.39-.83l.79-.19.52.74a4.29,4.29,0,0,0,.72.72,12.83,12.83,0,0,0,1.06.81c.74.53,1.54,1,2.33,1.51a53.75,53.75,0,0,0,4.94,2.69c.42.2.84.39,1.25.55l.64.21a5.22,5.22,0,0,1,.76.29,12.56,12.56,0,0,1,2.52,1.64,20,20,0,0,1,2.15,2A12.7,12.7,0,0,1,260.78,165.09Z"
                fill="#faf0da"
              />
              <path
                d="M240.52,125.14c-1.78.26-3.56.39-5.34.48a7.74,7.74,0,0,1-2.84-.18,8.07,8.07,0,0,1-2.45-1.45,3.78,3.78,0,0,0-2.09-.94,8.28,8.28,0,0,0-2.47.24c-1.76.33-3.52.62-5.31.79,1.67-.67,3.37-1.22,5.08-1.73a8,8,0,0,1,2.79-.46,4.9,4.9,0,0,1,2.75,1.11,7.2,7.2,0,0,0,2.08,1.33,7.73,7.73,0,0,0,2.45.33C237,124.75,238.74,124.89,240.52,125.14Z"
                fill="#faf0da"
              />
              <path
                d="M266.67,197.82a5.53,5.53,0,0,0-3-3.36,6.16,6.16,0,0,0-2.19-.45,22.84,22.84,0,0,0-2.48,0,19.45,19.45,0,0,0-2.42.25,21.8,21.8,0,0,1-2.7.39,6.89,6.89,0,0,1-.78,0,3.94,3.94,0,0,1-1-.25,4.64,4.64,0,0,1-.74-.36,6.36,6.36,0,0,1-.64-.38c-.8-.52-1.5-1.06-2.19-1.6l-2-1.6a11.58,11.58,0,0,0-1.89-1.27c-.15-.09-.26-.1-.38-.17s-.09-.05-.23,0-.6.07-1,.13c-.79.15-1.62.34-2.45.53-3.33.77-6.69,1.63-10.11,2.29s-6.85,1.32-10.68.94a13.65,13.65,0,0,1-2.72-.72c-.85-.29-1.67-.62-2.49-1q-2.43-1-4.72-2.3l-2.28-1.27L206.5,187l-.94-.51a18.77,18.77,0,0,0-4.86-.7,26.57,26.57,0,0,0-9.86,1.88h0l-.15.06-.13-.05-6.72-2.84.28-.64,6.71,2.82h-.27a25.73,25.73,0,0,1,10.12-2.79,19.49,19.49,0,0,1,5.37.42,2.46,2.46,0,0,1,.29.09l.17.08.32.15.6.29,1.16.58,2.29,1.13c1.54.73,3.08,1.43,4.64,2,.79.3,1.57.58,2.36.82a12.9,12.9,0,0,0,2.28.52,23.33,23.33,0,0,0,4.81-.24c1.65-.25,3.31-.55,5-.92,3.33-.71,6.64-1.55,10-2.37.84-.2,1.69-.39,2.59-.57a9.61,9.61,0,0,1,1.58-.19,3.65,3.65,0,0,1,1,.17c.26.11.58.22.8.34a15.08,15.08,0,0,1,2.37,1.63c.7.56,1.36,1.12,2,1.67s1.28,1.09,1.9,1.54a3.51,3.51,0,0,0,.45.3,2.54,2.54,0,0,0,.41.23c.14.08.18.06.24.1l.5,0a23.34,23.34,0,0,0,2.43-.17,19.07,19.07,0,0,1,2.72-.06c.91.05,1.77.13,2.68.27a7.31,7.31,0,0,1,2.73,1,6.2,6.2,0,0,1,3,4.66Z"
                fill="#faf0da"
              />
              <path
                d="M264.19,194.67c-2.83-2.56-11.31,1-12.72-.44-5.83-4.42-7.78-6.72-11.84-3.36s-4.06,6-14.14,10.6c-3.83,1.75-11.68-2.34-17.13-1.41a76.53,76.53,0,0,1-15.57,1l-.4.22c5.76,6.89,15.28,13.62,30.81,15.06,23.22,2.17,35.46-8.19,40.9-15a14.74,14.74,0,0,1,1.07-1.41c.3-.41.57-.81.81-1.17C266.32,197.72,266.08,196.38,264.19,194.67Z"
                fill="#a629a2"
              />
            </g>
            <path
              d="M142.64,136.13l-.77-.19c-1.84,3.28-2.05,5.44,4,9.37l10.56-.86A17.37,17.37,0,0,1,142.64,136.13Z"
              fill="#e1e6f0"
            />
            <path
              d="M141.17,205l-.24-.19c-1.84,3.29-1,7,5,11l10.57-.85C146.57,214,141.17,205,141.17,205Z"
              fill="#e1e6f0"
            />
            <path
              d="M171.78,150.06s12,27.19,1.92,38.72a.37.37,0,0,0,.46.57c10.28-5.74,13.52-10.73,13.52-13.67V141S183.62,150.06,171.78,150.06Z"
              fill="#e1e6f0"
            />
            <path
              d="M187.68,211.09s-15.79,11.09-40.93,3.07c-.77-.25-1.26,2.88-1.2,3.68.57,6.73,0,21.93.26,39.64,3.34-.42,33.74-11.31,41.87-11.13Z"
              fill="#e1e6f0"
            />
            <g opacity="0.36">
              <circle cx="167.55" cy="171.52" r="11.13" fill="#480694" />
              <polygon
                points="170.15 167 164.94 167 162.33 171.52 164.94 176.04 170.15 176.04 172.76 171.52 170.15 167"
                fill="#480694"
              />
              <line
                x1="162.71"
                y1="161.49"
                x2="164.96"
                y2="167"
                fill="#480694"
              />
              <line
                x1="172.3"
                y1="161.49"
                x2="170.06"
                y2="167"
                fill="#480694"
              />
              <line
                x1="172.76"
                y1="171.56"
                x2="178.72"
                y2="171.48"
                fill="#480694"
              />
              <line
                x1="162.33"
                y1="171.56"
                x2="156.45"
                y2="171.56"
                fill="#480694"
              />
              <line
                x1="164.96"
                y1="176.04"
                x2="162.71"
                y2="181.55"
                fill="#480694"
              />
              <line
                x1="170.06"
                y1="176.04"
                x2="172.3"
                y2="181.55"
                fill="#480694"
              />
              <circle cx="167.58" cy="171.48" r="14.53" fill="#e1e6f0" />
            </g>
            <g>
              <circle
                cx="167.55"
                cy="171.52"
                r="11.13"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.86"
              />
              <polygon
                points="170.15 167 164.94 167 162.33 171.52 164.94 176.04 170.15 176.04 172.76 171.52 170.15 167"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="162.71"
                y1="161.49"
                x2="164.96"
                y2="167"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="172.3"
                y1="161.49"
                x2="170.06"
                y2="167"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="172.76"
                y1="171.56"
                x2="178.72"
                y2="171.48"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="162.33"
                y1="171.56"
                x2="156.45"
                y2="171.56"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="164.96"
                y1="176.04"
                x2="162.71"
                y2="181.55"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="170.06"
                y1="176.04"
                x2="172.3"
                y2="181.55"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <circle
                cx="167.58"
                cy="171.48"
                r="14.53"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
            </g>
            <g>
              <circle
                cx="167.37"
                cy="237.95"
                r="11.13"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="1.86"
              />
              <polygon
                points="169.97 233.44 164.76 233.44 162.15 237.96 164.76 242.47 169.97 242.47 172.58 237.96 169.97 233.44"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="162.54"
                y1="227.92"
                x2="164.78"
                y2="233.43"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="172.12"
                y1="227.92"
                x2="169.88"
                y2="233.43"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="172.59"
                y1="237.99"
                x2="178.54"
                y2="237.91"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="162.15"
                y1="237.99"
                x2="156.28"
                y2="237.99"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="164.78"
                y1="242.48"
                x2="162.54"
                y2="247.98"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <line
                x1="169.88"
                y1="242.48"
                x2="172.12"
                y2="247.98"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
              <circle
                cx="167.41"
                cy="237.91"
                r="14.53"
                fill="none"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.53"
              />
            </g>
            <path
              d="M45.45,286.46c0,.14.09.27.13.41.64.94,3.15,4.66,6.4,9.2,3.57,5,8.31,9.51,12.2,13.89.71.81,3,2.32,3.71,3l13.64.61.32-.08L81.67,192.2h-7A109.86,109.86,0,0,1,45.45,286.46Z"
              fill="#e1e6f0"
            />
            <ellipse
              cx="64.24"
              cy="284.11"
              rx="11.04"
              ry="15.02"
              fill="#6786a6"
              opacity="0.28"
            />
            <path
              d="M93.33,183.1A97,97,0,0,1,108,125H93.23l-.43,2.29v52.09C93,180.58,93.14,181.83,93.33,183.1Z"
              fill="#fff"
              opacity="0.63"
            />
            <g>
              <ellipse
                cx="64.13"
                cy="284.34"
                rx="9.67"
                ry="13.16"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <ellipse
                cx="64.13"
                cy="284.34"
                rx="6.92"
                ry="9.41"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.44"
              />
              <line
                x1="64.14"
                y1="274.92"
                x2="64.14"
                y2="293.75"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <line
                x1="57.24"
                y1="284.36"
                x2="71.05"
                y2="284.36"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
            </g>
            <g>
              <ellipse
                cx="63.18"
                cy="214.31"
                rx="11.04"
                ry="15.02"
                fill="#6786a6"
                opacity="0.28"
              />
              <ellipse
                cx="63.25"
                cy="214.55"
                rx="9.67"
                ry="13.16"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <ellipse
                cx="63.25"
                cy="214.55"
                rx="6.92"
                ry="9.41"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.44"
              />
              <line
                x1="63.26"
                y1="205.13"
                x2="63.26"
                y2="223.96"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <line
                x1="56.36"
                y1="214.57"
                x2="70.17"
                y2="214.57"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
            </g>
            <path
              d="M101.19,332.66l.24-7.75,4.62-7.18.68-7.77,7.45-7.42-.18-6.89,11.66-6.89.18-7.07,16.26-7.42.13-5.48,28-6.54v-5.56l25.62-4.24-.09-4.42,32.34-3.18v-3l20.67-2.12v-3.89l11.13-.89v-3l10.76-1.84V227.3l4.7-2v-3.19l3.89-2.12v-3.18l3-1.94v-3.18l1.24-1.94.35-3.18.17-1.93.19-2.67-.51-4.3-.62-2.32-.87-2.32-.9-1.88-1.86-3.12s3.7,13.94,1.84,19.86-6.1,14.4-15.2,19.79-27.47,11.4-31.45,11.84-13.16,3.44-17.67,3.89S170,251.12,162.15,255.1s-32.07,9.1-48.06,27-26.28,35.67-25,50.3C101.3,332.54,101.19,332.66,101.19,332.66Z"
              fill="#acc6d2"
            />
            <path
              d="M64.71,315.74l.08-3.57-5.56-.09v-6H52v-6.71H47.39v-6.89H43.33v-6.36H39.26v-6.89H37.67V273H37v-6.71s-2.48-14.49,8.39-32.16a23.93,23.93,0,0,1,0,5.79s-11.75,24.95-2,42c8.72,15.34,25,31.82,29,34.08C67.34,315.88,64.71,315.74,64.71,315.74Z"
              fill="#cadfe6"
            />
            <path
              d="M22.83,253.24v-6.36l2-.09v-6.18h3.71v-6H34.4l.18-5.83h5.48v-4.63h5.3V220.9S22,229.33,19.92,253.15C21.33,253.15,22.83,253.24,22.83,253.24Z"
              fill="#cadfe6"
            />
            <path
              d="M92.8,127.21s8.66,9.06,21.2,1.64c1.77,2,9.72,5.1,17.14,1.22,0-4.7.4-9.13.4-9.13l-40,.49Z"
              fill="#6786a6"
              opacity="0.28"
            />
            <path
              d="M293.73,221.25l0,85.18a60.24,60.24,0,0,1-18,11.83c-19.07,8.2-51.17,15.93-86,14.46-8.48-28.8.81-51.63,23.78-60.82C233.37,263.93,282.77,245.63,293.73,221.25Z"
              fill="#567ba6"
              opacity="0.29"
            />
            <path
              d="M99.34,248s5.83,6.32,16.61,1.55c5.12,2.3,11.83,3.61,15.19.13.36-4.32.36-4.37.36-4.37L99,244.76Z"
              fill="#6786a6"
              opacity="0.28"
            />
            <g>
              <path
                d="M103.12,88.18S80.4,101.86,82.31,120.56c1.92,6.91,9.72,6,11,3.6,1.33,4.34,14.43,10,20.17.74,1.91,1.76,10.89,9,20.17-.59,2.2.15,9.56,1.16,10.67-4.12,2.28-10.89-13.18-29.15-22.45-32C111,88.25,103.12,88.18,103.12,88.18Z"
                fill="#dd50d2"
              />
              <path
                d="M108.88,90s-15,8.43-15.53,34.19c0,0-.59-9.27,1.4-15.16a81.92,81.92,0,0,1,5-11.41c1-2.21,3.31-7.07,3.31-9.39C107.12,88.14,108.88,90,108.88,90Z"
                fill="#ba2dd2"
              />
              <path
                d="M113.52,88.2c1.18,0,16.49,11.67,20.17,36.26,0,0,.95-7.8-5.16-20.91,0,0-6.62-10.15-6.62-15.38h-6.62"
                fill="#ba2dd2"
              />
              <path
                d="M108.51,79.78a13.15,13.15,0,0,1,.15,3.9c-.22,2.36-3.6,2.21-5.15,3.83s.74,4.64,9.13,4.56c9-.08,9.49-3,9.2-4.27S118,85,117.27,84.27c-2.43-2.72-.59-4-.07-4.49Z"
                fill="#c941d2"
              />
              <path
                d="M107.15,89.66c2.48,6,6.09,14.62,6.23,36.26,1.11-.74-.7-18.37,1-25.47,1.84-7.87,3.31-10.75,3.53-10.79S106.24,87.46,107.15,89.66Z"
                fill="#ba2dd2"
              />
              <path
                d="M107.63,79.12a5.73,5.73,0,0,1,1,3.9c-.22,2.36-3.6,2.21-5.15,3.83s.74,4.41,9.13,4.34c9-.08,9.49-2.8,9.2-4S118,85,117.27,84.27c-2.43-2.72.3-4.71.81-5.15Z"
                fill="#da1ab7"
              />
              <path
                d="M108.59,81.42s1.32,3-2.36,3.94c-.14.48,9.09,3,12.64-.2-1.58-.89-3.73-2.07-1.5-5.56-6.16.07-9.09-.22-9.09-.22Z"
                fill="#b02dd2"
              />
              <path
                d="M106.57,79.91c.42.1,1-.21,1.73-.09a26.13,26.13,0,0,0,8.63,0c.56-.09,1.14.23,1.72.09a1.32,1.32,0,0,0,1-1c2.54-10.26-4.78-9.61-5.21-11.76a26.6,26.6,0,0,1-.1-5.52A1.3,1.3,0,0,0,113,60.3h0a1.3,1.3,0,0,0-1.26,1.27c-.07,3.59-.18,5.19-.64,5.85S102.94,70,105.64,79A1.34,1.34,0,0,0,106.57,79.91Z"
                fill="#da1ab7"
              />
              <path
                d="M112.64,60.28s-.08,6.77-.67,8-5.66,6.55-3.68,12.07"
                fill="none"
                stroke="#ba2dd2"
                strokeMiterlimit="10"
              />
              <path
                d="M113.52,60.4s-.7,6.69,0,8.08,4.27,6.78,3.46,11.78"
                fill="none"
                stroke="#ba2dd2"
                strokeMiterlimit="10"
              />
            </g>
            <g>
              <path
                d="M108,217.49S90.54,228,92,242.34c1.47,5.32,7.46,4.58,8.48,2.77,1,3.34,11.08,7.69,15.48.57,1.47,1.35,8.37,6.89,15.49-.45,1.69.11,7.34.89,8.19-3.17,1.75-8.36-10.11-22.37-17.23-24.58C114,217.54,108,217.49,108,217.49Z"
                fill="#c8d656"
              />
              <path
                d="M112.4,218.86s-11.52,6.48-11.92,26.25c0,0-.45-7.12,1.07-11.64a63.45,63.45,0,0,1,3.85-8.76c.79-1.69,2.54-5.43,2.54-7.2C111.05,217.46,112.4,218.86,112.4,218.86Z"
                fill="#ebef56"
              />
              <path
                d="M111.16,217.51s4.69,11.22,4.8,27.83c.85-.57-.53-14.1.74-19.55,1.41-6,2.54-8.26,2.71-8.28S111.16,217.51,111.16,217.51Z"
                fill="#ebef56"
              />
              <path
                d="M116,217.5c.91,0,12.66,9,15.49,27.84,0,0,.73-6-4-16.05,0,0-5.08-7.8-5.08-11.81h-5.09"
                fill="#ebef56"
              />
              <path
                d="M112.12,211a10.16,10.16,0,0,1,.11,3c-.17,1.81-2.76,1.7-4,2.94s.56,3.56,7,3.51c6.91-.06,7.28-2.32,7.06-3.28s-3-2.13-3.5-2.71c-1.87-2.09-.46-3.11-.06-3.45Z"
                fill="#468425"
                opacity="0.44"
              />
              <path
                d="M111.44,210.53a4.42,4.42,0,0,1,.79,3c-.17,1.8-2.76,1.69-4,2.93s.56,3.39,7,3.34c6.91-.06,7.28-2.15,7.06-3.11s-3-1.62-3.5-2.2c-1.87-2.09.22-3.62.62-4Z"
                fill="#ebef56"
              />
              <path
                d="M122.35,216.69l0-.1c-1.75,1.31-2.57,1.46-7.49,1.68a9.64,9.64,0,0,1-6.15-2.15,3.26,3.26,0,0,0-.4.34c-1.14,1.2.56,3.39,7,3.34C122.2,219.74,122.57,217.65,122.35,216.69Z"
                fill="#eaf9f6"
                opacity="0.5"
              />
              <path
                d="M110.63,211.14c.32.08.77-.16,1.33-.07a20.07,20.07,0,0,0,6.62,0c.44-.07.88.18,1.32.07a1,1,0,0,0,.74-.73c2-7.88-3.67-7.38-4-9a20.56,20.56,0,0,1-.08-4.24,1,1,0,0,0-1-1.06h0a1,1,0,0,0-1,1c0,2.75-.13,4-.49,4.49s-6.2,2-4.13,8.9A1,1,0,0,0,110.63,211.14Z"
                fill="#ebef56"
              />
              <g>
                <path
                  d="M112.16,206.59h0S112.18,206.57,112.16,206.59Z"
                  fill="#0606a1"
                  opacity="0.36"
                />
                <path
                  d="M119.9,211.14a1,1,0,0,0,.74-.73c.89-3.62.19-5.47-.86-6.57l-.37-.35a1.74,1.74,0,0,1-1.84,2.08c-.07-.07-2.29,2.42-5.4,1a1.8,1.8,0,0,1-2.67.43h0a9,9,0,0,0,.41,3.43,1,1,0,0,0,.72.69c.32.08.77-.16,1.33-.07a20.07,20.07,0,0,0,6.62,0C119,211,119.46,211.25,119.9,211.14Z"
                  fill="#468425"
                  opacity="0.44"
                />
              </g>
            </g>
            <path
              d="M145.81,94.36a19.72,19.72,0,0,0,21.73-1c8.3,3.71,12.9,6.89,20.14,1.59.18-5.56-.19-5.34.36-5.66l-42.59-.17Z"
              fill="#6786a6"
              opacity="0.28"
            />
            <g>
              <path
                d="M155.76,51s-24,14.47-22,34.26c2,7.32,10.28,6.3,11.68,3.81,1.4,4.6,15.26,10.59,21.34.78,2,1.87,11.52,9.5,21.33-.62,2.34.15,10.12,1.23,11.3-4.36C201.8,73.29,185.45,54,175.63,50.94,164.11,51,155.76,51,155.76,51Z"
                fill="#df6494"
              />
              <path
                d="M161.85,52.84S146,61.76,145.42,89c0,0-.63-9.81,1.48-16a85.89,85.89,0,0,1,5.29-12.07c1.09-2.34,3.51-7.49,3.51-9.94C160,50.91,161.85,52.84,161.85,52.84Z"
                fill="#d05585"
              />
              <path
                d="M160.14,51s6.46,15.47,6.62,38.36c1.16-.78-.75-19.44,1-26.94,1.95-8.34,3.5-11.38,3.74-11.41S160.14,51,160.14,51Z"
                fill="#d05585"
              />
              <path
                d="M166.75,51c1.25,0,17.45,12.35,21.34,38.36,0,0,1-8.25-5.45-22.11,0,0-7-10.75-7-16.28h-7"
                fill="#d05585"
              />
              <path
                d="M160.53,41.36a6.11,6.11,0,0,1,1.09,4.13c-.24,2.49-3.82,2.33-5.46,4s.78,4.67,9.66,4.59c9.53-.08,10.05-3,9.74-4.28s-4.11-2.23-4.83-3c-2.57-2.88.31-5,.85-5.45Z"
                fill="#dd5083"
              />
              <path
                d="M175.56,49.85a.78.78,0,0,0-.05-.14c-2.4,1.8-3.54,2-10.31,2.32-4.29.2-7.23-2.13-8.48-3a3.58,3.58,0,0,0-.56.47c-1.57,1.65.78,4.67,9.66,4.59C175.35,54.05,175.87,51.17,175.56,49.85Z"
                fill="#e98cb7"
              />
              <path
                d="M161.55,43.8S162.94,47,159,48c-.15.51,9.62,3.14,13.38-.21-1.67-.94-3.95-2.18-1.59-5.88-6.52.07-9.62-.23-9.62-.23Z"
                fill="#d05585"
              />
              <path
                d="M159.41,42.2c.44.11,1.05-.22,1.82-.09a27.6,27.6,0,0,0,9.14,0c.59-.1,1.2.25,1.82.09a1.38,1.38,0,0,0,1-1c2.69-10.85-5-10.16-5.51-12.44a28.36,28.36,0,0,1-.11-5.85,1.39,1.39,0,0,0-1.42-1.46h0a1.38,1.38,0,0,0-1.34,1.35c-.07,3.79-.18,5.48-.67,6.18s-8.55,2.7-5.69,12.27A1.4,1.4,0,0,0,159.41,42.2Z"
                fill="#dd5083"
              />
              <path
                d="M165.82,21.42s-.08,7.17-.7,8.42-6.13,5.7-4,11.54"
                fill="none"
                stroke="#d05585"
                strokeMiterlimit="10"
              />
              <path
                d="M166.75,21.56s-.73,7.07,0,8.55,4.38,5.94,3.52,11.23"
                fill="none"
                stroke="#d05585"
                strokeMiterlimit="10"
              />
              <path
                d="M199.39,84.82c.41-13.78-7.5-20.33-14.13-27.66,0,.09,7.16,8.38-2.62,10.06,0,0-1.23,13.14-16.16,8.45,0,0-9,9.73-20.32,4.69,0,0-7.24,6.73-12,2.7a8.22,8.22,0,0,1-.5,1.08c0,.36,0,.71.09,1.07,2,7.32,10.28,6.3,11.68,3.81,1.4,4.6,15.26,10.59,21.34.78,1.29,1.2,5.64,4.75,11.18,4.51l6.27-2a19.74,19.74,0,0,0,3.88-3.15,24.06,24.06,0,0,0,6.38-.08l1.95-.62C197.85,87.82,199.33,86.74,199.39,84.82Z"
                fill="#d05585"
              />
              <path
                d="M157.88,38.65a14.91,14.91,0,0,0,.54,2.6,1.4,1.4,0,0,0,1,1c.44.11,1.05-.22,1.82-.09a27.6,27.6,0,0,0,9.14,0c.59-.1,1.2.25,1.82.09a1.38,1.38,0,0,0,1-1c1.11-4.51.43-7-.78-8.59h0s.67,3.67-2.9,3.31c0,0-3.14,5.48-8.3.89C161.22,36.8,160.11,39.35,157.88,38.65Z"
                fill="#d05585"
              />
            </g>
            <path
              d="M133.86,124.49c2.21.14,9.95,1.23,10.67-4.13,1.28-9.44-7.89-22.63-15.84-28.29,1.33,5.61,2.25,8.29-1.44,9.4,1.28,2.08-1,12.18-13.31,11.21-.58.36-9.76,9.33-20.4,5,0,0-3.09,6.28-9.5,6.1,3,3.5,8.41,2.51,9.49.58,1.32,4.34,14.43,10,20.17.74C115.61,126.84,124.59,134.05,133.86,124.49Z"
              fill="#ba2dd2"
            />
            <path
              d="M115.86,73c.17.37-2.54,3.95-7.5,2.33a8.56,8.56,0,0,1-2.82,2.8c.08.34.17.69.28,1a1.29,1.29,0,0,0,.93.89c.41.11,1-.2,1.73-.08a26.13,26.13,0,0,0,8.63,0c.56-.1,1.14.23,1.72.08a1.28,1.28,0,0,0,1-.94c1-4.24.42-6.62-.72-8.1C118.9,71.83,118.26,73.27,115.86,73Z"
              fill="#ba2dd2"
            />
            <path
              d="M238,175.92s7.58,6.47,6.57,10.09c2.71,1.5,8.71,5.92,8.71,5.92a11.58,11.58,0,0,0-1.59-11.05C240.16,176.48,238,175.92,238,175.92Z"
              fill="#cd37c0"
            />
            <path
              d="M218.42,171.48s-10.77,6.14-13.95,13V184a56.1,56.1,0,0,0,6.89,3.36c3.71,1.41,6.36,3,8.3,2.82s3.6-17.31,2.68-17.75A23,23,0,0,0,218.42,171.48Z"
              fill="#cd37c0"
            />
            <path
              d="M121.05,332.65l.7-7.49s19.29-1.42,19.46-7.43V310s10.07-.71,11.66-7.77c-.88.35,0,.35,0,.35v-7.42s18.73-1.77,9.28-6.36h-.09l.09-7.07s14.58-.88,14.58-6.89v-6s22.61-2,15.55-6.58v-5.08s21.91,1.24,25.44-4.77v-4.42s24.21,0,20-3v-3s28.44-1.41,21.38-2.29v-3s11.13-1.06,7.06-1.59v-2.65s12.19-.53,9-2.29v-3s8.49-.53,6.19-1.76v-3.19s5.65-.7,4.42-1.94c0-.18.17-3.36.17-3.36s3.71-.53,2.48-1.94c.17-1.59.17-3.18.17-3.18s1.68-1.33,1.37-2c0,0,6.23,22.12-48,39.35s-73.15,46-70.15,83.5Z"
              fill="#6786a6"
              opacity="0.06"
            />
            <path
              d="M45.41,260.25l0,.11c-.89-53,16.08-67,16.08-67l-15.1-1.14H45.36Z"
              fill="#fff"
            />
            <g>
              <path
                d="M42.87,153.76s3.12-5.29,3.26-6.38-3-6.38-1.63-8,2.31,1.09,4.21,0,3.93-3.79,5.15-4.34,2-2.3,5.3,0,5.15-1.22,5.15-1.22a6,6,0,0,1,5.56,0c3.26,1.49,7.33-.95,8.15-.68s.13,6.24-2.58,7.87c2.85,2.45,5.43,5.84,2.85,6.38s-14,3.55-14,3.55Z"
                fill="#ffc22d"
              />
              <path
                d="M32,181.44s8,18.32,34.19,15.87,30.12-24.42,30.12-24.42-6.92-11.13-17.09-11.53-25,2.3-28.5,4.07S34.73,171.67,32,181.44Z"
                fill="#ffc22d"
              />
              <path
                d="M56.58,126.35c-.27-.95-1.63-4.07,2.3-4.34a36.56,36.56,0,0,1,6.92,0c1.63.13,1.63,3.39,0,3.39s-5.83,3-6.92,2.44A16.7,16.7,0,0,1,56.58,126.35Z"
                fill="#ffc22d"
              />
              <path
                d="M51.56,135.3s-1.9-8.41,2.3-8.27,3,.54,5,0,3.67-1.63,5.3-1.63,3.52,1.08,4.34,1.36,4.2,1.76,2.71,5.15S68,136,66.48,135.3s-8.14.55-9.09,1.36-3.39,1.09-4.88,1S51.56,135.3,51.56,135.3Z"
                fill="#ffc22d"
              />
              <path
                d="M51.73,135.13s2.41-4.47,6.62-4.33,3.44-2.82,5.47-3.36-1.1-2.22.53-2.22,3.53,1.09,4.34,1.36,4.21,1.76,2.72,5.16-3.26,4.07-4.75,3.39-8.14.54-9.09,1.35-3.39,1.09-4.89,1S51.73,135.13,51.73,135.13Z"
                fill="#ffa42d"
              />
              <path
                d="M59.83,121.87c-1.08-1-2-.27-1.22-3.12s.27-6.51,1.22-6.78,2,2.3,3.4,4.07-.68,3.66,0,4.75,1.22,2.71-.55,2.57A4.39,4.39,0,0,1,59.83,121.87Z"
                fill="#ffc22d"
              />
              <path
                d="M57.59,125.29c-.2-.72-1.22-3.11,1.72-3.32a27,27,0,0,1,5.17,0c1.22.1,1.22,2.6,0,2.6s-4.36,2.28-5.17,1.86A12,12,0,0,1,57.59,125.29Z"
                fill="#ffa42d"
              />
              <path
                d="M76.93,175.06c-5,4.21-11.67,3.53-16,2.44s-8.41-3.12-10.72-2.3-3.93,5.69-8.68,4.2-7.87,1.63-9.18,3.17c2.26,4,11.38,16.81,33.6,14.74,24.13-2.25,29.37-21.09,30-24l.08-.39s-4.88,2.17-6,2.17S82,170.85,76.93,175.06Z"
                fill="#ffa42d"
              />
              <path
                d="M96,173.2c-2.72,3-5.48,3.54-10.42,2.12-4-1.15-11.43,11.35-15.91,11.49S59.2,181,55.52,183.1s-5.24,6.4-7.07,4.94-12-.36-12-.36a1.57,1.57,0,0,1-.07.2c4.86,5,14,10.78,29.55,9.43C85.2,195.64,94.21,182.74,96,173.2Z"
                fill="#6f2b25"
                opacity="0.17"
              />
              <path
                d="M57.26,165.52s-3.33,9.45-7.4,9.8c0-.17,13.43,4.07,18.56,2.65.17-5.48-5-13.68-5-13.68Z"
                fill="#ffa42d"
              />
              <path
                d="M46.13,147.38a24.22,24.22,0,0,1,2.76-3,8.51,8.51,0,0,1,1.66-1.19,2.77,2.77,0,0,1,1-.34,1.6,1.6,0,0,1,1.05.24,1.77,1.77,0,0,0,1.78,0A19.93,19.93,0,0,0,56.05,142a12,12,0,0,1,1.8-1,5.34,5.34,0,0,1,2.06-.51A1.85,1.85,0,0,1,61,141a3.34,3.34,0,0,0,.77.55,3,3,0,0,0,1.81.11c1.28-.24,2.55-.75,3.86-1.12a13.25,13.25,0,0,1,4.08-.65,11.4,11.4,0,0,1,4.09.83l-.36,0a5.56,5.56,0,0,0,2.25-3.33,9,9,0,0,0,.29-2.07,10.35,10.35,0,0,0-.15-2.09l.48.31c-1.82.4-3.62.77-5.48,1a6.4,6.4,0,0,1-1.47.08,7.41,7.41,0,0,1-1.43-.3c-.91-.27-1.76-.62-2.62-.79a4.11,4.11,0,0,0-2.38.68c-.8.42-1.57.9-2.35,1.4l-.61.37a1.28,1.28,0,0,1-.42.19,1.21,1.21,0,0,1-.47,0,6.31,6.31,0,0,1-1.39-.48c-.86-.38-1.68-.82-2.5-1.19a5.91,5.91,0,0,0-.61-.24,1,1,0,0,0-.26-.06,1.4,1.4,0,0,0-.29,0c-.17,0-.22.07-.46.26a1.85,1.85,0,0,1-.77.3,2.37,2.37,0,0,0-1.09.56c-.35.28-.7.58-1,.88-.67.62-1.33,1.27-2,1.92-.33.33-.64.66-1,1a2.94,2.94,0,0,1-1.34.65,1.31,1.31,0,0,1-.81,0l-.62-.31a2.64,2.64,0,0,0-1.25-.27,1.84,1.84,0,0,0-.61.16c-.2.11-.38.19-.45.37a2.38,2.38,0,0,0-.08,1.28,21.22,21.22,0,0,0,1.82,5.19h0c.08.1,0,.2,0,.3v.88Zm0,0v-.88c0-.1,0-.2,0-.3h0a21.53,21.53,0,0,1-2-5.17,2.66,2.66,0,0,1,0-1.45.93.93,0,0,1,.26-.33l.32-.2a2.18,2.18,0,0,1,.71-.22,3,3,0,0,1,1.45.25c.22.09.44.21.63.3s.35,0,.54,0a2.67,2.67,0,0,0,1.13-.56l1-1c.64-.67,1.28-1.33,2-2,.34-.32.69-.63,1.06-.93a3,3,0,0,1,1.33-.71A1.07,1.07,0,0,0,55,134a1.4,1.4,0,0,1,.74-.38,1.94,1.94,0,0,1,.41,0,1.74,1.74,0,0,1,.42.08,6.82,6.82,0,0,1,.68.25c.87.37,1.69.8,2.52,1.16a5.83,5.83,0,0,0,1.23.43.81.81,0,0,0,.21,0l.2-.11L62,135c.78-.5,1.56-1,2.4-1.45a11.15,11.15,0,0,1,1.31-.6,2.89,2.89,0,0,1,1.56-.17c1.91.38,3.51,1.4,5.26,1,1.8-.28,3.62-.66,5.42-1l.41-.08.07.4a11.54,11.54,0,0,1,.14,2.26,10.09,10.09,0,0,1-.32,2.25,7.35,7.35,0,0,1-.94,2.1,5.86,5.86,0,0,1-1.65,1.64l-.16.11-.19-.08a10.94,10.94,0,0,0-3.81-.79,13,13,0,0,0-3.88.59c-1.29.34-2.56.82-3.94,1.06a3.6,3.6,0,0,1-2.16-.2,4.18,4.18,0,0,1-.86-.64,1.27,1.27,0,0,0-.77-.33,4.67,4.67,0,0,0-1.84.44,10.09,10.09,0,0,0-1.75.92,13.92,13.92,0,0,1-1.76,1.06,2.09,2.09,0,0,1-2.08-.07,1.68,1.68,0,0,0-1.79,0A8.9,8.9,0,0,0,49,144.52,24.14,24.14,0,0,0,46.13,147.38Z"
                fill="#d6ac64"
              />
              <path
                d="M46.13,147.38s4.34-5.43,6.24-4.21,3-.95,5.84-2,2.3.54,4.07.81,4.2-1.08,7.32-1.63a11.14,11.14,0,0,1,5.84.68c3.66-2.44,2.58-7.87,2.58-7.87s-5,1.09-6.41,1.14-3.09-.87-4.58-1.12-4.89,2.29-5.66,2.66-4.25-1.86-5.24-1.92-.64.46-1.72.6-4.62,4.07-5.13,4.52a3,3,0,0,1-1.71.62c-.32,0-1.71-1.21-3.07-.26s1.63,6.83,1.63,6.83Z"
                fill="#ffc22d"
              />
              <path
                d="M46.13,147.38s4.34-5.43,6.24-4.21,3-.95,5.84-2,2.3.54,4.07.81,4.2-1.08,7.32-1.63a11.14,11.14,0,0,1,5.84.68c3.66-2.44,2.58-7.87,2.58-7.87s-5,1.09-6.41,1.14-3.09-.87-4.58-1.12-4.84,4.52-5.68,4.36c-6.91-1.31-8.72,3.29-10.07,4.24s-5.15,4.45-5.15,4.45Z"
                fill="#ffa42d"
              />
              <path
                d="M44.09,139.37a2.85,2.85,0,0,1,1.06-.72,1.08,1.08,0,0,1,.71,0l.59.19a2.92,2.92,0,0,0,2.12,0,3.81,3.81,0,0,0,.78-.69c.27-.28.53-.59.79-.9.53-.62,1.07-1.26,1.66-1.88A6.67,6.67,0,0,1,54,133.72c.45-.17.66-.28,1.2-.47a2.91,2.91,0,0,1,.89-.14,4.6,4.6,0,0,1,.79.1,19.13,19.13,0,0,1,2.49.82q1.17.43,2.31.93l-.69,0a6.23,6.23,0,0,0,1.7-.91,14,14,0,0,1,1.92-1.36,3.88,3.88,0,0,1,2.73-.32,13.28,13.28,0,0,1,2.25.68,5.09,5.09,0,0,0,1.91.51c.69,0,1.44,0,2.17-.09l4.46-.32c-1.42.48-2.86.87-4.32,1.21a22.61,22.61,0,0,1-2.26.42,6,6,0,0,1-2.43-.34,14.66,14.66,0,0,0-2.07-.44,2.13,2.13,0,0,0-1.58.26c-.48.28-1,.81-1.66,1.29a7.78,7.78,0,0,1-2.19,1.22l-.33.12-.35-.14c-1.51-.59-3.07-1.33-4.46-1.71a1.63,1.63,0,0,0-.77-.05l-1.13.37a6.39,6.39,0,0,0-1.73,1.2c-.59.53-1.18,1.1-1.78,1.68-.31.28-.63.56-1,.83a4.19,4.19,0,0,1-1.22.77,3.63,3.63,0,0,1-2.68-.42l-.55-.32a.68.68,0,0,0-.47-.13A2.7,2.7,0,0,0,44.09,139.37Z"
                fill="#faf0da"
              />
              <path
                d="M79.35,146.3S69.33,143,67,143.45s-4.21,2.71-7.6,4.07c-2.2.88-6.52-2.45-8.28-2.72s-5,2.58-5,2.58c-.14,1.09-3.26,6.38-3.26,6.38l21.44-2.83s11.4-3,14-3.55a1.88,1.88,0,0,0,.4-.13l.66-.95Z"
                fill="#ffa42d"
              />
              <path
                d="M37.17,172.89c.55-3,2.31-6.79,0-9.5s-.27-7.6,5.43-9.63,8.82-4.34,9.23-5,4.75,2.17,7.05,2.58,7.06-.14,8.82-2.72,9.37-.13,11.81,0,3.26,10.31,0,11.53a172.42,172.42,0,0,1-20.56,5C53.73,166,37.17,172.89,37.17,172.89Z"
                fill="#ffc22d"
              />
              <path
                d="M79.51,160.13c1.27-.47,1.92-2.31,2.1-4.39a3.83,3.83,0,0,1,0-.47s-.86-5.52-.85-5.57c-4.07,5.66-9-1.41-15.38,6.72-1.13,1.45-12.9-2.65-20.37,5.75-2.44,2.75-7.87,10.72-7.87,10.72S53.73,166,59,165.15A172.42,172.42,0,0,0,79.51,160.13Z"
                fill="#ffa42d"
              />
              <path
                d="M37.08,158a14.2,14.2,0,0,1,3.05-3.24,9.55,9.55,0,0,1,1.93-1.25,3.43,3.43,0,0,1,.59-.22l.49-.17c.32-.12.64-.27,1-.42a41,41,0,0,0,3.79-2.07c.61-.37,1.22-.75,1.79-1.16a8.8,8.8,0,0,0,.82-.62,3.28,3.28,0,0,0,.54-.55l.4-.57.61.15a15.09,15.09,0,0,1,1.84.64l1.69.65a29.43,29.43,0,0,0,3.34,1.08,8.66,8.66,0,0,0,1.62.26,4.66,4.66,0,0,0,.75,0c.29,0,.58-.07.86-.12a12.82,12.82,0,0,0,3.27-.89,4,4,0,0,0,.68-.37,2.51,2.51,0,0,0,.55-.49,7.23,7.23,0,0,1,1.57-1.28,3.43,3.43,0,0,1,2.15-.49c.64.08,1.23.18,1.84.28,2.4.42,4.79.91,7.16,1.49-2.44-.07-4.87-.23-7.29-.38-.6,0-1.22-.08-1.79-.09a2,2,0,0,0-1.31.42,6.05,6.05,0,0,0-1.15,1.12,3.7,3.7,0,0,1-.77.76,6.22,6.22,0,0,1-.9.55,14.09,14.09,0,0,1-3.69,1.2l-.95.14a6.27,6.27,0,0,1-1.06,0,11.39,11.39,0,0,1-2-.27,25.55,25.55,0,0,1-3.59-1.17c-1.12-.44-2.32-1-3.28-1.3l1-.41a4.47,4.47,0,0,1-1,1c-.32.25-.64.46-1,.67-.65.41-1.3.78-2,1.13a33.46,33.46,0,0,1-4.1,1.83c-.36.13-.72.24-1.1.35l-.57.12a2.64,2.64,0,0,0-.46.13,9.62,9.62,0,0,0-1.89.91A18,18,0,0,0,37.08,158Z"
                fill="#faf0da"
              />
              <path
                d="M52.64,127.3c1.36-.18,2.74-.31,4.11-.37a6.07,6.07,0,0,0,1.88-.25,5.45,5.45,0,0,0,1.59-1,3.89,3.89,0,0,1,2.11-.85,5.92,5.92,0,0,1,2.15.36q2,.57,3.9,1.32c-1.37-.14-2.73-.34-4.07-.6a6.42,6.42,0,0,0-1.9-.19,3,3,0,0,0-1.61.72,6.21,6.21,0,0,1-1.88,1.12,6.13,6.13,0,0,1-2.19.14C55.37,127.61,54,127.48,52.64,127.3Z"
                fill="#faf0da"
              />
              <path
                d="M79.24,161.36c-1.54-.07-3.19-.06-4.88,0l-4.09,1.35s7.16,11.54,9.1,11,10.43,1.77,11,1.59c.33-.11,3.47-1.73,5.7-2.89C94.59,170.33,88.17,161.71,79.24,161.36Z"
                fill="#ffa42d"
              />
              <path
                d="M32,183a4.76,4.76,0,0,1,2.28-3.57,5.5,5.5,0,0,1,2.1-.74c.7-.1,1.35-.17,2.05-.21a16.21,16.21,0,0,1,2.09.05,17.15,17.15,0,0,0,1.86.13c.69.1,1.72-.88,2.7-1.69a21.33,21.33,0,0,1,3.36-2.53,6.06,6.06,0,0,1,.62-.27,2.51,2.51,0,0,1,.8-.12,6.22,6.22,0,0,1,1.22.14c.68.13,1.34.29,2,.44,2.58.63,5.12,1.27,7.68,1.82a28.39,28.39,0,0,0,7.51.89A9.06,9.06,0,0,0,70,177c.61-.17,1.21-.39,1.82-.62,1.2-.46,2.39-1,3.56-1.55l1.76-.88.89-.45.46-.22.25-.12.12-.05.23-.08a14.71,14.71,0,0,1,4.12-.32A19.63,19.63,0,0,1,91,174.81H90.8L96,172.64l.22.5L91,175.31l-.1,0-.11,0h0a20.53,20.53,0,0,0-7.57-1.45,15,15,0,0,0-3.74.54l-3.33,1.84c-1.18.63-2.38,1.24-3.62,1.77-.63.27-1.26.53-1.91.75a10.77,10.77,0,0,1-2.09.56,29,29,0,0,1-8.2-.72c-2.62-.5-5.2-1.16-7.76-1.76-.64-.14-1.27-.28-1.89-.4a6.73,6.73,0,0,0-.74-.1c-.1,0-.1,0-.17,0a1.38,1.38,0,0,0-.29.12,21.55,21.55,0,0,0-3,2.2c-.53.42-1.07.84-1.69,1.24a5,5,0,0,1-1.06.56,2.89,2.89,0,0,1-.76.2c-.22,0-.4,0-.6,0a15.06,15.06,0,0,1-2.07-.3,16.68,16.68,0,0,0-1.87-.19c-.62,0-1.29,0-1.9,0a4.71,4.71,0,0,0-1.68.35,4.21,4.21,0,0,0-2.31,2.58Z"
                fill="#faf0da"
              />
            </g>
            <g>
              <ellipse
                cx="64.24"
                cy="249.11"
                rx="11.04"
                ry="15.02"
                fill="#6786a6"
                opacity="0.28"
              />
              <ellipse
                cx="64.31"
                cy="249.18"
                rx="9.67"
                ry="13.16"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <ellipse
                cx="64.31"
                cy="249.18"
                rx="6.92"
                ry="9.41"
                fill="#7db8de"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.44"
              />
              <line
                x1="64.32"
                y1="239.76"
                x2="64.32"
                y2="258.59"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
              <line
                x1="57.42"
                y1="249.2"
                x2="71.23"
                y2="249.2"
                fill="#fff"
                stroke="#fafaf8"
                strokeMiterlimit="10"
                strokeWidth="0.61"
              />
            </g>
            <path
              d="M145.45,89.1s6,6.52,10.25,6c-6.54,14.13-9.89,36.82-9.89,36.82Z"
              fill="#fff"
            />
            <path
              d="M145.81,152.34a19.55,19.55,0,0,0,9.89,0c-3,4.6-9.87,37.94-10.15,47.69A348.71,348.71,0,0,0,145.81,152.34Z"
              fill="#fff"
            />
            <path
              d="M105.06,97.73c-1.16.3-9.45,14.45-4.65,16.28s5.8-3.28,5.64-5S109.84,96.52,105.06,97.73Z"
              fill="#e7a0d7"
            />
            <path
              d="M157.63,60.37c-1.17.3-9.46,14.45-4.65,16.28s5.79-3.28,5.63-5S162.41,59.16,157.63,60.37Z"
              fill="#e98cb7"
            />
            <path
              d="M109.89,225.21c-.58.14-4.7,7.18-2.31,8.09s2.88-1.63,2.8-2.47S112.27,224.61,109.89,225.21Z"
              fill="#ebef56"
            />
            <path
              d="M112.6,69.32c.34-.06,2,4,.6,4.31-2.76.59-1.88-1.33-1.83-1.68S112,69.43,112.6,69.32Z"
              fill="#e7a0d7"
            />
            <path
              d="M165.85,32.64c.34,0,2,4,.6,4.31-2.76.59-1.87-1.33-1.83-1.68S165.22,32.75,165.85,32.64Z"
              fill="#f3cbf7"
              opacity="0.5"
            />
            <path
              d="M108.68,69.36c-.34.09-3.78,4.61-2.38,5.14s1.34-1.87,1.54-2.33C108.33,71,110.07,69,108.68,69.36Z"
              fill="#e7a0d7"
            />
            <path
              d="M161.23,31.43c-.34.09-3.78,4.61-2.38,5.14s1.34-1.87,1.54-2.33C160.88,33.1,162.62,31.08,161.23,31.43Z"
              fill="#f3cbf7"
              opacity="0.5"
            />
            <path
              d="M92.45,101c-.77,0-7.66,8-4.83,9.75s4-1.4,4.14-2.49S95.62,100.79,92.45,101Z"
              fill="#e7a0d7"
            />
            <path
              d="M103.81,222.57c-.78.05-8.93,8.05-6.1,9.77s2.61-3.43,3.27-4.3C102.43,226.12,107,222.36,103.81,222.57Z"
              fill="#ebef56"
            />
            <path
              d="M147.93,58.56c-.77,0-7.66,8-4.83,9.75s4-1.4,4.14-2.49S151.1,58.35,147.93,58.56Z"
              fill="#e98cb7"
            />
            <path
              d="M118.35,96.34c.77,0,7.65,8,4.83,9.75s-4.05-1.4-4.15-2.49S115.18,96.13,118.35,96.34Z"
              fill="#e7a0d7"
            />
            <path
              d="M171.64,60.41c.77.05,7.66,8,4.83,9.76s-4-1.41-4.14-2.5S168.47,60.2,171.64,60.41Z"
              fill="#e98cb7"
            />
            <path
              d="M88.38,80.26c-.86.46-3.27.27-6.32-.11-.45,4.35-2.17,16.31-7.84,21.28.36,0,.72,0,1.09,0,8.13,0,14.49-5.31,12.9-10.61H81.85S91.74,85,88.38,80.26Z"
              fill="#6043d4"
            />
            <path
              d="M69,78.59s-5.57-.36-6.77.66a75.45,75.45,0,0,1,1.1,13C64.43,92,64.76,79.18,69,78.59Z"
              fill="#7ac0ea"
              opacity="0.39"
            />
            <path
              d="M116.18,180.45s-.73-1.77,0-2.47,5.76-1.14,6.75-.77S116.35,179.08,116.18,180.45Z"
              fill="#f4d0db"
              opacity="0.58"
            />
            <path
              d="M171.78,150.06s5.73,1.17,15-4.43,11.67-25.79,5.49-38.33c7.31,22.28-25,34.05-33.6,36.86"
              fill="#e1e6f0"
            />
          </g>
        </g>
        <g id="e7af9f09-4b38-4f4e-88e0-88266ca91075" data-name="decor12">
          <g id="b77cecb5-99b3-4d92-8aa3-7f0b1e23cd4c" data-name="decor">
            <path
              d="M310.66,305.18c-2.73-6.73-8.4-20-6.51-31.1s4-25,1.26-29.2"
              fill="none"
              stroke="#720d56"
              strokeMiterlimit="10"
              strokeWidth="2.1"
            />
            <path
              d="M316.76,228.07c2.1,6.94,3.36,7.57,0,15.76s-9.67,30.67-9.46,35.29S313,302,313,302"
              fill="none"
              stroke="#720d56"
              strokeMiterlimit="10"
              strokeWidth="2.1"
            />
            <path
              d="M318.86,262.53c1.47,2.52-1.47,9.87-5.89,16.59s-5.67,26.06-5.67,26.06"
              fill="none"
              stroke="#720d56"
              strokeMiterlimit="10"
              strokeWidth="2.1"
            />
            <path
              d="M303.73,218.2c-.84-3.78-4-2.94-3.57,0s1,4.62,0,4.83-3.57,0-2.52,5l1.05,5s-5.67-2.73.42,5.68c-1.05,1.05-4,1.47.84,5.25-.42.84-3.57.84-1.47,3.78s8.74,6.52,8.74,6.52,6-11.56,3.44-13.45-3.36,1.26-3.36,1.26,5.25-13,0-8.61c.21-1.48,5-9.46,0-6.94.63-2.31,2.1-9.87-2.1-4A8,8,0,0,0,303.73,218.2Z"
              fill="#720d56"
            />
            <path
              d="M307,254.34c.62-1.44,1.22-2.89,1.77-4.36s1-2.95,1.43-4.45a13.81,13.81,0,0,0,.4-2.25,2.78,2.78,0,0,0-.35-1.9,1.93,1.93,0,0,0-.36-.25,2.58,2.58,0,0,0-.44-.22,1.17,1.17,0,0,0-.78,0,2.1,2.1,0,0,0-1,1.42l-1.08-.36a54.06,54.06,0,0,0,1.85-5.7,9,9,0,0,0,.36-2.76c0-.18-.09-.31,0-.24s0,0-.15.06a4.63,4.63,0,0,0-1.08.71l0,0a.6.6,0,0,1-.85-.1.58.58,0,0,1-.12-.49,6.92,6.92,0,0,1,.46-1.32l.5-1.14c.33-.75.67-1.49.95-2.24a8.26,8.26,0,0,0,.34-1.11,2,2,0,0,0,.06-.9c0-.08,0-.05-.06-.07a.78.78,0,0,0-.37,0,5.21,5.21,0,0,0-1,.37h0a.49.49,0,0,1-.65-.25.5.5,0,0,1,0-.34c.22-.76.41-1.54.57-2.32a14.67,14.67,0,0,0,.3-2.35,2.14,2.14,0,0,0-.14-1c0-.07,0-.07-.15,0a1.69,1.69,0,0,0-.42.24,10.62,10.62,0,0,0-1.6,1.73h0a.21.21,0,0,1-.3,0,.22.22,0,0,1-.09-.16,9.89,9.89,0,0,0-.33-2.29,7,7,0,0,0-.92-2.14,8.36,8.36,0,0,1,1.69,4.39l-.4-.11a11,11,0,0,1,1.56-2,1.92,1.92,0,0,1,.63-.38.79.79,0,0,1,.49,0,.72.72,0,0,1,.42.31,2.66,2.66,0,0,1,.33,1.38,15.91,15.91,0,0,1-.19,2.5c-.13.81-.28,1.62-.48,2.43l-.7-.58a6.26,6.26,0,0,1,1.26-.51,1.88,1.88,0,0,1,.86,0,1.14,1.14,0,0,1,.82.71,2.89,2.89,0,0,1,0,1.54,11.77,11.77,0,0,1-.36,1.27c-.28.8-.6,1.58-.93,2.34l-.49,1.13a7,7,0,0,0-.36,1l-1-.56a5.59,5.59,0,0,1,1.44-.93,1.38,1.38,0,0,1,1.31.09,1.36,1.36,0,0,1,.44.57,2.2,2.2,0,0,1,.13.52,9.48,9.48,0,0,1-.41,3.23,44.83,44.83,0,0,1-2,5.82v0a.57.57,0,0,1-.74.31.58.58,0,0,1-.33-.7,4,4,0,0,1,.61-1.23,2.46,2.46,0,0,1,1.18-.92,2.22,2.22,0,0,1,1.51.1,2.89,2.89,0,0,1,.6.33,2.08,2.08,0,0,1,1.06,1.81,6,6,0,0,1,0,1.28,15.54,15.54,0,0,1-.54,2.36,31.26,31.26,0,0,1-1.75,4.42C308.51,251.57,307.8,253,307,254.34Z"
              fill="#932b79"
            />
            <path
              d="M307.09,254.33c.2-1.49.38-3,.49-4.49s.19-3,.15-4.49a14.38,14.38,0,0,0-.23-2.19,3.46,3.46,0,0,0-.77-1.81,5.52,5.52,0,0,0-1.78-1,2.29,2.29,0,0,0-1.78.07h0a.48.48,0,0,1-.66-.16.5.5,0,0,1,0-.46,43.4,43.4,0,0,0,1.92-4.38,7.21,7.21,0,0,0,.51-2.12c0-.06,0-.12,0-.11s.06.06.08.06-.09,0-.22.07a5.33,5.33,0,0,0-.92.58l0,0a.49.49,0,0,1-.67-.11.5.5,0,0,1-.08-.39,16,16,0,0,1,.73-2.16c.26-.67.51-1.35.71-2a5.41,5.41,0,0,0,.32-1.95c-.05-.29-.11-.39-.29-.45a1.84,1.84,0,0,0-.86.1h0a.41.41,0,0,1-.5-.27.56.56,0,0,1,0-.18,9.72,9.72,0,0,0,.13-1.66c0-.57,0-1.14-.05-1.7a6.46,6.46,0,0,0-.31-1.62.91.91,0,0,0-.36-.52c-.13-.05-.37.07-.56.25h0a.19.19,0,0,1-.28,0,.24.24,0,0,1-.05-.14,25.6,25.6,0,0,1,.2-4.63,32.27,32.27,0,0,0,.2,4.61l-.34-.13a1,1,0,0,1,1-.42,1.23,1.23,0,0,1,.73.76,6.65,6.65,0,0,1,.43,1.76,17.58,17.58,0,0,1,.14,1.77,12.38,12.38,0,0,1,0,1.81l-.51-.45a2.49,2.49,0,0,1,1.28-.16,1.18,1.18,0,0,1,.71.43,1.5,1.5,0,0,1,.27.7,6.07,6.07,0,0,1-.3,2.34c-.21.72-.45,1.41-.7,2.1a15,15,0,0,0-.65,2l-.79-.47a6.35,6.35,0,0,1,1.12-.72,1.36,1.36,0,0,1,1-.11.91.91,0,0,1,.51.45,1.24,1.24,0,0,1,.13.48,6.94,6.94,0,0,1-.57,2.57,42.78,42.78,0,0,1-2.05,4.46l-.7-.61a3.17,3.17,0,0,1,2.61-.17,6,6,0,0,1,1.12.5c.17.11.35.21.5.33a2.47,2.47,0,0,1,.51.4,4.18,4.18,0,0,1,.91,2.31,15.11,15.11,0,0,1,.13,2.32,32.46,32.46,0,0,1-.42,4.53C307.74,251.38,307.46,252.87,307.09,254.33Z"
              fill="#932b79"
            />
            <path
              d="M303.73,218.2a5.07,5.07,0,0,0-.65-1.32,2.09,2.09,0,0,0-1-.84c-.84-.27-1.43.53-1.42,1.34a5.24,5.24,0,0,0,.2,1.33l.32,1.45a15.51,15.51,0,0,1,.31,1.54,3,3,0,0,1,0,1,1.41,1.41,0,0,1-.32.67,1.45,1.45,0,0,1-.7.44c-1.29.24-1.66.37-1.9.93a5.12,5.12,0,0,0,0,2.39l1.29,5.77a1.12,1.12,0,0,1-.85,1.33,1.15,1.15,0,0,1-.69-.07l-.05,0a3.51,3.51,0,0,0-.81-.27,1.21,1.21,0,0,0-.29,0c-.06,0,0,0,.14-.08a.45.45,0,0,0,.19-.29,1.46,1.46,0,0,0,0,.2,4.19,4.19,0,0,0,.3.82,24.07,24.07,0,0,0,2.24,3.65l.05.06a1.06,1.06,0,0,1-.16,1.39c-.67.6-1.2.84-1.44,1.08s-.12.13-.12.09a.7.7,0,0,0,.08.26,4.52,4.52,0,0,0,.88,1.13c.38.39.82.76,1.25,1.13l.08.06a.92.92,0,0,1,.19,1.15,1.94,1.94,0,0,1-.71.71c-.21.13-.38.19-.53.27a5.35,5.35,0,0,0-.73.37c-.16.12-.19.17-.21.25s0,.13,0,.2a2.85,2.85,0,0,0,.1.32,8.92,8.92,0,0,0,2.23,2.85,39.4,39.4,0,0,0,3,2.53c1.06.81,2.14,1.59,3.24,2.36a37.92,37.92,0,0,1-3.63-1.76,30.48,30.48,0,0,1-3.44-2.17,15.48,15.48,0,0,1-1.59-1.36,6.27,6.27,0,0,1-1.36-1.8,5,5,0,0,1-.23-.62,2.62,2.62,0,0,1,0-.8,2.2,2.2,0,0,1,.8-1.41,7,7,0,0,1,1-.64,2.9,2.9,0,0,0,.35-.21c.11-.06.06-.1,0,0l.28,1.21a18.22,18.22,0,0,1-1.46-1.2,6.32,6.32,0,0,1-1.36-1.64,2.58,2.58,0,0,1-.34-1.45,2.39,2.39,0,0,1,.73-1.44c.62-.58,1.19-.86,1.4-1.08l-.12,1.44a26.82,26.82,0,0,1-2.52-4,6,6,0,0,1-.46-1.3,2.87,2.87,0,0,1-.06-.92,1.86,1.86,0,0,1,.67-1.27,2,2,0,0,1,1.2-.4,3.49,3.49,0,0,1,.83.08,7.36,7.36,0,0,1,1.32.46l-1.59,1.24c-.19-1-.4-2-.58-2.93s-.37-1.9-.52-3a6.1,6.1,0,0,1,.36-3.49,2.89,2.89,0,0,1,1.58-1.4,7.12,7.12,0,0,1,1.57-.3s-.15.18-.08.09a1.55,1.55,0,0,0,.05-.5c0-.43-.07-.93-.13-1.42l-.17-1.49a5.53,5.53,0,0,1,0-1.63,2.51,2.51,0,0,1,.85-1.56,1.6,1.6,0,0,1,1.76-.18,2.38,2.38,0,0,1,1.07,1.2A5.52,5.52,0,0,1,303.73,218.2Z"
              fill="#510a40"
            />
            <path
              d="M314.66,195.72c-.85-3.78-4-2.94-3.58,0s1.05,4.62,0,4.83-3.57,0-2.52,5l1.05,5s-5.67-2.74.42,5.67c-1,1.05-4,1.47.84,5.25-.42.84-3.57.84-1.47,3.78s8.74,6.52,8.74,6.52,6-11.56,3.45-13.45-3.36,1.26-3.36,1.26,5.25-13,0-8.61c.21-1.48,5-9.46,0-6.94.63-2.31,2.1-9.87-2.1-4A8,8,0,0,0,314.66,195.72Z"
              fill="#720d56"
            />
            <path
              d="M317.93,231.86c.63-1.44,1.23-2.89,1.78-4.36s1-2.95,1.42-4.45a13.81,13.81,0,0,0,.4-2.25,2.74,2.74,0,0,0-.34-1.89,2.12,2.12,0,0,0-.36-.26,3.61,3.61,0,0,0-.44-.22,1.2,1.2,0,0,0-.79,0,2.09,2.09,0,0,0-1,1.42l-1.08-.36a55.61,55.61,0,0,0,1.84-5.7,9,9,0,0,0,.37-2.76c0-.18-.1-.31-.05-.24s0,0-.15.06a4.67,4.67,0,0,0-1.09.71l0,0a.61.61,0,0,1-.85-.1.58.58,0,0,1-.11-.49,7,7,0,0,1,.45-1.32l.51-1.14c.33-.75.67-1.49.94-2.24a10.11,10.11,0,0,0,.35-1.11,2.11,2.11,0,0,0,.06-.9c0-.08,0,0-.07-.07a.78.78,0,0,0-.37,0,5.44,5.44,0,0,0-1,.37h0a.5.5,0,0,1-.66-.25.57.57,0,0,1,0-.34,23.09,23.09,0,0,0,.57-2.32,13.65,13.65,0,0,0,.31-2.35,2.28,2.28,0,0,0-.14-1c-.06-.07,0-.07-.15-.05a1.53,1.53,0,0,0-.42.24,10.67,10.67,0,0,0-1.61,1.73h0a.21.21,0,0,1-.38-.12,10.46,10.46,0,0,0-.33-2.29,7,7,0,0,0-.93-2.14,8.2,8.2,0,0,1,1.69,4.4l-.39-.12a10.17,10.17,0,0,1,1.56-2,2,2,0,0,1,.62-.38.8.8,0,0,1,.49,0,.78.78,0,0,1,.43.31,2.64,2.64,0,0,1,.32,1.38,14.8,14.8,0,0,1-.19,2.5c-.12.82-.27,1.62-.47,2.43l-.71-.58a6.6,6.6,0,0,1,1.27-.51,1.84,1.84,0,0,1,.85,0,1.17,1.17,0,0,1,.83.71,2.88,2.88,0,0,1,0,1.54,11.77,11.77,0,0,1-.35,1.27c-.28.8-.6,1.58-.93,2.34l-.49,1.13a6,6,0,0,0-.36,1l-1-.56a5.84,5.84,0,0,1,1.45-.93,1.36,1.36,0,0,1,1.3.09,1.31,1.31,0,0,1,.45.57,2.76,2.76,0,0,1,.12.52,9.48,9.48,0,0,1-.41,3.23,46.35,46.35,0,0,1-2,5.82v0a.57.57,0,0,1-1.07-.39,4.26,4.26,0,0,1,.6-1.23,2.51,2.51,0,0,1,1.18-.92,2.21,2.21,0,0,1,1.51.1,2.89,2.89,0,0,1,.6.33,2.44,2.44,0,0,1,.57.46,2.41,2.41,0,0,1,.49,1.35,6,6,0,0,1,0,1.28,15.54,15.54,0,0,1-.54,2.36,32.46,32.46,0,0,1-1.74,4.42C319.44,229.1,318.73,230.5,317.93,231.86Z"
              fill="#932b79"
            />
            <path
              d="M318,231.85c.19-1.49.37-3,.48-4.49a42.19,42.19,0,0,0,.15-4.49,13.22,13.22,0,0,0-.22-2.19,3.47,3.47,0,0,0-.78-1.81,5.32,5.32,0,0,0-1.78-1,2.29,2.29,0,0,0-1.78.07h0a.48.48,0,0,1-.68-.62,41.26,41.26,0,0,0,1.92-4.38,7.59,7.59,0,0,0,.52-2.12s0-.12,0-.11.05.06.08.06-.09,0-.22.07a4.67,4.67,0,0,0-.92.58l-.05,0a.49.49,0,0,1-.67-.11A.53.53,0,0,1,314,211a15.68,15.68,0,0,1,.74-2.17c.25-.67.5-1.35.71-2a5.39,5.39,0,0,0,.31-2c0-.29-.11-.39-.29-.45a1.79,1.79,0,0,0-.85.1h0a.4.4,0,0,1-.49-.27.37.37,0,0,1,0-.18,10.89,10.89,0,0,0,.12-1.66,16,16,0,0,0-.05-1.7,6.46,6.46,0,0,0-.31-1.62c-.09-.25-.22-.47-.36-.52s-.36.07-.55.25h0a.19.19,0,0,1-.28,0,.2.2,0,0,1-.06-.14,26.55,26.55,0,0,1,.2-4.63,32.27,32.27,0,0,0,.21,4.61l-.35-.13a1.07,1.07,0,0,1,1-.42,1.26,1.26,0,0,1,.73.76,7.53,7.53,0,0,1,.43,1.76c.07.59.12,1.18.14,1.77a11.17,11.17,0,0,1-.06,1.81l-.51-.45a2.54,2.54,0,0,1,1.29-.16,1.16,1.16,0,0,1,.7.43,1.64,1.64,0,0,1,.28.7,6.07,6.07,0,0,1-.31,2.34c-.2.72-.45,1.41-.7,2.1a16.55,16.55,0,0,0-.64,2l-.8-.47a6.74,6.74,0,0,1,1.12-.72,1.36,1.36,0,0,1,.95-.11.85.85,0,0,1,.51.45,1.24,1.24,0,0,1,.13.48,6.75,6.75,0,0,1-.57,2.57,44.88,44.88,0,0,1-2,4.46l-.7-.61a3.15,3.15,0,0,1,2.6-.17,5.69,5.69,0,0,1,1.12.5c.18.11.35.21.51.33a2.73,2.73,0,0,1,.5.4,4.27,4.27,0,0,1,.92,2.31,15.1,15.1,0,0,1,.12,2.32,31.27,31.27,0,0,1-.41,4.54C318.66,228.9,318.39,230.39,318,231.85Z"
              fill="#932b79"
            />
            <path
              d="M314.66,195.72a5.41,5.41,0,0,0-.65-1.32,2.07,2.07,0,0,0-1-.84c-.83-.27-1.42.53-1.42,1.34a5.24,5.24,0,0,0,.2,1.33l.33,1.45a15.58,15.58,0,0,1,.3,1.54,2.75,2.75,0,0,1,0,1,1.35,1.35,0,0,1-.33.67,1.37,1.37,0,0,1-.7.44c-1.28.24-1.66.37-1.89.93a5,5,0,0,0,0,2.39l1.28,5.77a1.11,1.11,0,0,1-.84,1.33,1.18,1.18,0,0,1-.7-.07l0,0a3.58,3.58,0,0,0-.82-.27,1.17,1.17,0,0,0-.29,0s0,0,.15-.08a.51.51,0,0,0,.19-.29.84.84,0,0,0,0,.2,5.09,5.09,0,0,0,.31.82,24.07,24.07,0,0,0,2.24,3.65l0,.06a1,1,0,0,1-.16,1.39c-.66.6-1.2.84-1.44,1.08s-.11.13-.11.1a.52.52,0,0,0,.08.25,4.52,4.52,0,0,0,.88,1.13c.38.39.81.76,1.25,1.13l.07.06a.92.92,0,0,1,.2,1.15,2,2,0,0,1-.72.71,5.36,5.36,0,0,1-.53.27,5.13,5.13,0,0,0-.72.37c-.16.12-.19.17-.22.25s0,.13,0,.2,0,.2.09.32a8.82,8.82,0,0,0,2.24,2.85,39.4,39.4,0,0,0,3,2.53c1,.81,2.13,1.59,3.23,2.36-1.23-.52-2.44-1.11-3.63-1.76a29.49,29.49,0,0,1-3.43-2.17,16.82,16.82,0,0,1-1.6-1.35,6.44,6.44,0,0,1-1.35-1.81,3.79,3.79,0,0,1-.23-.62,2.33,2.33,0,0,1,0-.8,2.24,2.24,0,0,1,.8-1.41,7,7,0,0,1,1-.64,2.9,2.9,0,0,0,.35-.21c.1-.06.06-.1,0,0l.27,1.21c-.49-.38-1-.76-1.46-1.2a6.74,6.74,0,0,1-1.36-1.64,2.66,2.66,0,0,1-.33-1.45,2.44,2.44,0,0,1,.72-1.44c.63-.58,1.2-.86,1.4-1.08l-.11,1.44a26.07,26.07,0,0,1-2.53-4,6,6,0,0,1-.45-1.3,2.84,2.84,0,0,1-.07-.92,1.86,1.86,0,0,1,.67-1.27,2,2,0,0,1,1.2-.4,3,3,0,0,1,.83.09,6.42,6.42,0,0,1,1.32.45l-1.59,1.24c-.19-1-.4-1.94-.57-2.93s-.37-1.9-.53-3a6.2,6.2,0,0,1,.37-3.49,2.84,2.84,0,0,1,1.57-1.4,7.34,7.34,0,0,1,1.57-.3s-.14.18-.07.09a1.59,1.59,0,0,0,0-.5,12.36,12.36,0,0,0-.12-1.42l-.18-1.49a5.9,5.9,0,0,1,0-1.63,2.53,2.53,0,0,1,.86-1.56,1.59,1.59,0,0,1,1.75-.18,2.34,2.34,0,0,1,1.07,1.2A5.19,5.19,0,0,1,314.66,195.72Z"
              fill="#510a40"
            />
            <path
              d="M329.05,229.08c.51-3.84-2.74-4.14-3.36-1.23s-.6,4.7-1.66,4.54-3.35-1.23-4.1,3.87l-.74,5.09s-4.39-4.51-1.56,5.47c-1.35.63-4.25,0-1,5.23-.69.64-3.65-.44-2.68,3s6,9.13,6,9.13,9.58-8.81,7.86-11.45-3.59,0-3.59,0,9.41-10.43,3-8.09c.7-1.31,8-7.15,2.38-6.51,1.39-2,5.37-8.56-.6-4.47A8,8,0,0,0,329.05,229.08Z"
              fill="#720d56"
            />
            <path
              d="M319.71,264.14c1.08-1.14,2.14-2.29,3.16-3.48s2-2.42,2.87-3.69a14.13,14.13,0,0,0,1.15-2,2.78,2.78,0,0,0,.33-1.89,1.83,1.83,0,0,0-.26-.37,2.26,2.26,0,0,0-.34-.35,1.2,1.2,0,0,0-.72-.31,2.17,2.17,0,0,0-1.46,1l-.89-.71a53.42,53.42,0,0,0,3.69-4.71,8.77,8.77,0,0,0,1.29-2.47c.05-.18,0-.32,0-.24s0,0-.16,0a4.86,4.86,0,0,0-1.27.29l-.05,0a.6.6,0,0,1-.7-.89,7,7,0,0,1,.88-1.08l.87-.9c.57-.59,1.14-1.17,1.66-1.77a11.31,11.31,0,0,0,.7-.93,2.15,2.15,0,0,0,.37-.83c0-.08,0,0,0-.08a.87.87,0,0,0-.35-.12,5.83,5.83,0,0,0-1.11,0h0a.49.49,0,0,1-.53-.46.48.48,0,0,1,.1-.33c.47-.63.92-1.3,1.33-2a14,14,0,0,0,1.09-2.1,2.21,2.21,0,0,0,.21-1c0-.08,0-.07-.13-.1a1.49,1.49,0,0,0-.47.08,10.67,10.67,0,0,0-2.1,1.07h0a.2.2,0,0,1-.29-.07.23.23,0,0,1,0-.18,9.68,9.68,0,0,0,.48-2.26,7,7,0,0,0-.13-2.33,8.29,8.29,0,0,1,.07,4.71l-.33-.24a11.12,11.12,0,0,1,2.14-1.31,2,2,0,0,1,.72-.14.76.76,0,0,1,.47.15.76.76,0,0,1,.29.43A2.63,2.63,0,0,1,332,234a14.73,14.73,0,0,1-1,2.28,24.35,24.35,0,0,1-1.28,2.12l-.46-.78a6.08,6.08,0,0,1,1.36,0,1.86,1.86,0,0,1,.82.28,1.12,1.12,0,0,1,.52.95,2.86,2.86,0,0,1-.5,1.45,9.62,9.62,0,0,1-.77,1.06c-.54.67-1.11,1.29-1.68,1.88l-.84.9a5.45,5.45,0,0,0-.69.83l-.76-.87a5.91,5.91,0,0,1,1.69-.39,1.39,1.39,0,0,1,1.19.54,1.3,1.3,0,0,1,.22.69,2.66,2.66,0,0,1-.06.52,9.24,9.24,0,0,1-1.5,2.9,45.93,45.93,0,0,1-3.86,4.79h0a.57.57,0,0,1-.87-.72,4.06,4.06,0,0,1,1-1,2.46,2.46,0,0,1,1.42-.46,2.2,2.2,0,0,1,1.39.61,3.5,3.5,0,0,1,.45.51,2.7,2.7,0,0,1,.37.64,2.43,2.43,0,0,1,0,1.44,5.59,5.59,0,0,1-.47,1.18,14.67,14.67,0,0,1-1.31,2,32.42,32.42,0,0,1-3.16,3.55C322.07,262.06,320.92,263.14,319.71,264.14Z"
              fill="#932b79"
            />
            <path
              d="M319.79,264.17c.7-1.34,1.38-2.69,2-4.06s1.21-2.75,1.68-4.16a13.69,13.69,0,0,0,.54-2.14,3.48,3.48,0,0,0-.1-2,5.54,5.54,0,0,0-1.34-1.53,2.33,2.33,0,0,0-1.69-.54h0a.48.48,0,0,1-.56-.38.46.46,0,0,1,.14-.44,44.73,44.73,0,0,0,3.31-3.44,7.55,7.55,0,0,0,1.21-1.82c0-.05,0-.12,0-.11s0,.07,0,.08-.09,0-.23,0a5.63,5.63,0,0,0-1.06.23h-.05a.46.46,0,0,1-.59-.33.48.48,0,0,1,.05-.39,17.33,17.33,0,0,1,1.43-1.78c.48-.54.94-1.09,1.37-1.65a5.63,5.63,0,0,0,1-1.72c.06-.29,0-.41-.12-.52a1.87,1.87,0,0,0-.83-.21h0a.39.39,0,0,1-.37-.42.48.48,0,0,1,.06-.18,11.08,11.08,0,0,0,.68-1.51c.2-.53.39-1.07.54-1.61a6.82,6.82,0,0,0,.26-1.64.88.88,0,0,0-.16-.6.65.65,0,0,0-.6,0h0a.2.2,0,0,1-.26-.1.26.26,0,0,1,0-.15,26,26,0,0,1,1.79-4.28,32.59,32.59,0,0,0-1.4,4.4l-.28-.24a1.08,1.08,0,0,1,1.06-.07,1.26,1.26,0,0,1,.42,1,7,7,0,0,1-.2,1.8,16.66,16.66,0,0,1-.48,1.71,10.13,10.13,0,0,1-.67,1.68l-.33-.6a2.69,2.69,0,0,1,1.27.29,1.23,1.23,0,0,1,.51.66,1.6,1.6,0,0,1,0,.75,6.38,6.38,0,0,1-1.09,2.09c-.44.6-.91,1.17-1.38,1.73a15,15,0,0,0-1.28,1.62l-.59-.71a6.9,6.9,0,0,1,1.3-.29,1.36,1.36,0,0,1,.93.23.89.89,0,0,1,.33.59,1.21,1.21,0,0,1-.05.49,6.62,6.62,0,0,1-1.41,2.22,43.84,43.84,0,0,1-3.46,3.49l-.45-.81a3.15,3.15,0,0,1,2.51.73,6,6,0,0,1,.88.86c.12.16.25.31.36.48a3.3,3.3,0,0,1,.34.55,4.3,4.3,0,0,1,.06,2.48,13.61,13.61,0,0,1-.68,2.22,31.69,31.69,0,0,1-1.95,4.12C321.41,261.62,320.64,262.92,319.79,264.17Z"
              fill="#932b79"
            />
            <path
              d="M329.05,229.08a5.41,5.41,0,0,0-.16-1.46,2.11,2.11,0,0,0-.67-1.15c-.7-.53-1.52,0-1.8.78a5.21,5.21,0,0,0-.27,1.32L326,230c-.06.5-.12,1-.24,1.55a3.14,3.14,0,0,1-.35.92,1.43,1.43,0,0,1-.54.52,1.54,1.54,0,0,1-.81.18c-1.29-.22-1.69-.23-2.1.22a5.1,5.1,0,0,0-.85,2.23l-.77,5.86a1.11,1.11,0,0,1-1.25.95,1.07,1.07,0,0,1-.63-.3l0,0a3.72,3.72,0,0,0-.67-.53,1,1,0,0,0-.26-.13c-.05,0,0,0,.16,0a.55.55,0,0,0,.28-.2.82.82,0,0,0,0,.2,4.27,4.27,0,0,0,0,.87,24.45,24.45,0,0,0,.85,4.2l0,.07a1.06,1.06,0,0,1-.63,1.25c-.83.33-1.41.37-1.72.52-.14.06-.15.08-.14,0a.5.5,0,0,0,0,.27,4.52,4.52,0,0,0,.44,1.36c.23.5.51,1,.79,1.49l0,.09a.9.9,0,0,1-.2,1.14,2,2,0,0,1-.92.42,5.42,5.42,0,0,1-.59.07,5.91,5.91,0,0,0-.81.1c-.19.06-.23.09-.29.16s0,.12-.08.18,0,.21,0,.34a8.83,8.83,0,0,0,1.12,3.44,35.63,35.63,0,0,0,2,3.42q1.06,1.68,2.22,3.33c-1-.92-1.91-1.89-2.8-2.9a31.61,31.61,0,0,1-2.48-3.22,15.3,15.3,0,0,1-1-1.82,6.35,6.35,0,0,1-.66-2.16c0-.2,0-.45,0-.67a2.63,2.63,0,0,1,.23-.76,2.21,2.21,0,0,1,1.24-1.05,6.68,6.68,0,0,1,1.15-.26,2.14,2.14,0,0,0,.4-.08c.12,0,.1-.07,0,0l-.16,1.23c-.33-.53-.67-1.05-1-1.63a6.27,6.27,0,0,1-.71-2,2.59,2.59,0,0,1,.18-1.48,2.35,2.35,0,0,1,1.17-1.1c.79-.34,1.42-.4,1.69-.54l-.6,1.32a26.42,26.42,0,0,1-1-4.62,5.36,5.36,0,0,1,0-1.38,2.53,2.53,0,0,1,.25-.88,1.82,1.82,0,0,1,1.06-1,2,2,0,0,1,1.27,0,2.91,2.91,0,0,1,.75.37,5.77,5.77,0,0,1,1.08.88l-1.92.62c.16-1,.3-2,.47-2.95s.31-1.92.54-3a6.19,6.19,0,0,1,1.54-3.15,2.85,2.85,0,0,1,2-.77,6.47,6.47,0,0,1,1.58.25s-.2.12-.1.05a1.28,1.28,0,0,0,.21-.44,12,12,0,0,0,.37-1.38l.35-1.46a5.85,5.85,0,0,1,.55-1.54,2.48,2.48,0,0,1,1.34-1.16,1.59,1.59,0,0,1,1.71.43,2.36,2.36,0,0,1,.59,1.49A5.49,5.49,0,0,1,329.05,229.08Z"
              fill="#510a40"
            />
          </g>
          <g>
            <path
              d="M220.64,336.13a3.47,3.47,0,0,0,1.07-6.52A12.52,12.52,0,0,0,211.4,329c10.16-4.35,15.35-9.67,8.7-14.51-5.32-3.87-13.54,10.16-15.47,10.16s1-5.81,5.32-11.13,3.87-9.67.48-11.12-9.19,1-10.64,16c0-2.42,1-17.41-2.9-16s-6.77,9.67-.49,18.38c-3.86,1.45-3.38-2.42-3.38-2.42s-1.94-14.51-8.71-11.61-4.83,10.64,0,15.48,4.84,7.74-1.45,4.84-9.19-9.68-15-2.91,10.16,15,19.34,15.48C193.88,340,211.47,337.51,220.64,336.13Z"
              fill="url(#ee7a2a74-4801-4351-a9f8-81df3e357f7c)"
            />
            <path
              d="M214.79,334.83c.34-2.75-4.81-5.5-8.93-2.07,6.18-5.49,7.56-10,4.46-10s-10,5.84-11.33,5.84,3-2.67,6.12-6.45,1.44-6.71-1-7.74c-2.25-1-9.09,1.2-10.85,10.19a1.56,1.56,0,0,1-1.07,1.19c-.53.18-1.14-1.22-1.14-1.22s-3.09-11.77-7.9-9.71-3.43,7.56,0,11,3.44,5.5-1,3.44-6.53-6.87-10.65-2.06,4.81,7.21,11.34,7.56S214.79,334.83,214.79,334.83Z"
              fill="url(#a261df6a-34bf-49e8-9a16-76fa98554bd8)"
            />
            <path
              d="M202.79,338.68c-1.3-.47,3.76-1.49,8-4s3.62-5.82,1.71-7.61-9-1.94-13.66,5.92a1.57,1.57,0,0,1-1.42.75c-.56,0-.65-1.53-.65-1.53s1.08-12.12-4.15-11.81-5.79,5.94-3.72,10.34,1.37,6.34-2.14,2.88-3.81-8.67-9.32-5.54,2.08,8.41,8.11,10.95S204.08,339.15,202.79,338.68Z"
              fill="url(#b4ef6f9e-44c0-446c-809b-41f4d17baeaa)"
            />
          </g>
          <g>
            <path
              d="M307.84,308.94a2.5,2.5,0,0,0-.58-4.73,9,9,0,0,0-7.27,1.63c6.15-5.06,8.67-9.8,3.09-11.8-4.46-1.6-7.32,9.77-8.66,10.16s-.5-4.21,1.44-8.78.72-7.47-1.92-7.79-6.16,2.52-4.13,13.19c-.49-1.67-2.86-12.24-5.24-10.46s-2.73,8.07,3.38,12.82c-2.38,1.79-2.83-1-2.83-1s-4.27-9.65-8.37-6.27-1.2,8.34,3.13,10.71,4.91,4.38,0,3.64-8.32-4.84-11,1,10.07,8.33,16.52,6.81C290.09,317,301.77,311.74,307.84,308.94Z"
              fill="url(#fc62beb5-6f1e-44b5-894b-9e7b232a3bf4)"
            />
            <path
              d="M303.52,309.22c-.31-2-4.44-2.84-6.6.38,3.17-5.06,3.22-8.43,1.08-7.8s-5.71,6.05-6.66,6.33,1.55-2.46,2.93-5.7-.36-4.94-2.23-5.16-6.06,2.67-5.45,9.25a1.13,1.13,0,0,1-.51,1c-.33.23-1-.61-1-.61s-4.52-7.53-7.43-5.13-.85,5.93,2.22,7.61,3.49,3.11,0,2.59-5.91-3.44-7.79.73,4.79,4,9.38,2.94S303.52,309.22,303.52,309.22Z"
              fill="url(#b3dfe434-6cdb-4742-aba5-2b68c4f8b495)"
            />
            <path
              d="M296,314.31c-1-.06,2.3-1.79,4.69-4.37s1.33-4.77-.36-5.62-6.59.47-8.25,6.86a1.17,1.17,0,0,1-.83.81c-.39.1-.76-.93-.76-.93s-1.71-8.61-5.26-7.34-2.81,5.29-.49,7.91,2.23,4.11-.89,2.43-4.4-5.23-7.58-1.95,3.15,5.4,7.83,5.94S297,314.37,296,314.31Z"
              fill="url(#f8137d19-e490-40a8-adb4-54009b393063)"
            />
          </g>
          <path
            d="M11,208.89c-5.3,5-12.72,14-5.3,21.91s10.07,24.92,5.3,34.46-8.13,22.61-3,30.92S18.06,311,13.47,316"
            fill="none"
            stroke="#78cd38"
            strokeMiterlimit="10"
            strokeWidth="5.12"
          />
          <path
            d="M19.51,265.41a44.82,44.82,0,0,1-2.61,6.72A28.54,28.54,0,0,0,15.83,275a18.34,18.34,0,0,0-.47,2.64,9.48,9.48,0,0,0,1.39,6.15A22,22,0,0,0,21.67,289a19.55,19.55,0,0,1,5.12,5.77A11.68,11.68,0,0,1,28.22,299a10.05,10.05,0,0,1,0,2.45,10.36,10.36,0,0,1-.3,1.19,5.26,5.26,0,0,1-.42,1.13,24.06,24.06,0,0,1-2,3.23c-.63.93-1.24,1.87-1.85,2.83A50.51,50.51,0,0,0,20.26,316h-.51a11.29,11.29,0,0,1-.42-3.86,19.53,19.53,0,0,1,.53-3.81,22.82,22.82,0,0,1,1.2-3.64,18.25,18.25,0,0,1,.8-1.74c.34-.65.4-.92.59-1.31a2.47,2.47,0,0,0,.17-.55c0-.18.12-.36.15-.54a6.6,6.6,0,0,0,.09-1.12,7.6,7.6,0,0,0-.46-2.6c-.74-1.86-1.81-3.9-2.9-6a32,32,0,0,0-4.09-6c-.76-.95-1.68-1.82-2.48-2.92A9,9,0,0,1,11.1,278a8,8,0,0,1,.4-4.41,13.69,13.69,0,0,1,2-3.55,20.85,20.85,0,0,1,5.61-5Z"
            fill="#97d729"
          />
          <path
            d="M29.92,318.07A5.8,5.8,0,0,1,26,316.74a10.71,10.71,0,0,1-2.72-3.14,14.71,14.71,0,0,1-1.57-3.73,11.81,11.81,0,0,1-.45-4c.16-2.69,1.23-5.19,2.06-7.55.43-1.19.87-2.36,1.39-3.53.12-.3.26-.59.4-.88a7.85,7.85,0,0,1,.42-.88c.15-.29.3-.59.47-.87s.36-.62.45-.83a8.83,8.83,0,0,0,.79-2.89,19.12,19.12,0,0,0,.1-3A44.76,44.76,0,0,0,26.17,279c-.94-4.41-2.22-8.94-3.12-13.91l.44-.26a26,26,0,0,1,4.84,5.85,29.71,29.71,0,0,1,3.14,7,21.07,21.07,0,0,1,.71,7.92,13,13,0,0,1-1,4.1,9.63,9.63,0,0,1-2.57,3.47c-.28.27-.46.4-.69.59a4.76,4.76,0,0,0-.61.58,7.24,7.24,0,0,0-1.08,1.32,8.91,8.91,0,0,0-1.32,3.18c-.49,2.29.14,4.67.62,6.8.24,1.08.43,2.14.62,3.2s.45,2.1.76,3.12a18,18,0,0,0,1.14,3,8,8,0,0,0,2,2.67Z"
            fill="#97d729"
          />
        </g>
        <g className="text" transform="translate(155 342)">
          <rect width="140" height="20" fill="transparent" />
          <path
            fill="#f9f9f9"
            d="M13.1,4.6c0-0.9,0-1.6,0-2.2c0-0.6,0-1,0-1.2c0-0.2,0.1-0.5,0.2-0.6c0.1-0.2,0.4-0.3,0.9-0.4
            c0.3,0,0.6-0.1,1-0.1c0.3,0,0.7,0,1,0c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0c0.5,0,0.7,0.2,0.9,0.4C18,0.7,18,1.1,18,1.7v1.8
            c0,0.8,0,1.6,0,2.4c0,0.8,0,1.6,0,2.4c0.5,0,0.9,0.1,1.1,0.2c0.2,0.1,0.4,0.3,0.5,0.7c0.1,0.4,0.2,0.9,0.2,1.4c0,0.1,0,0.3,0,0.4
            c0,0.2,0,0.3-0.1,0.5c0,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.6,0.3-1.1,0.3l-0.5,0c-0.1,0.8-0.1,1.6-0.2,2.5c-0.1,0.8-0.2,1.7-0.3,2.6
            c-0.1,0.4-0.2,0.7-0.4,0.9c-0.2,0.2-0.5,0.4-0.8,0.4c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0c-0.3,0-0.6,0-0.8,0c-0.3,0-0.5,0-0.8-0.1
            c-0.4-0.1-0.7-0.2-0.8-0.3c-0.2-0.2-0.3-0.4-0.3-0.8c0,0,0-0.2,0-0.4c0-0.2,0-0.5,0.1-0.7c0-0.3,0-0.6,0.1-0.9
            c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0.1-0.6,0.1-1c0-0.3,0.1-0.7,0.1-1.1c-0.5,0-1,0-1.6,0c-0.5,0-1.1,0-1.6,0c-0.5,0-1.1,0-1.6,0
            c-0.5,0-1.1,0-1.6,0c0,0.8,0.1,1.5,0.1,2.2c0,0.7,0.1,1.2,0.1,1.8c0,0.2,0,0.4,0.1,0.6c0,0.2,0,0.3,0,0.4c0,0.7-0.3,1-0.9,1.1
            c-0.4,0.1-0.7,0.1-1.1,0.2c-0.4,0-0.8,0.1-1.2,0.1H3.3c-0.5,0-0.8-0.1-1-0.3C2.1,18.3,2,18,1.9,17.7c-0.1-0.9-0.2-1.8-0.3-2.6
            c-0.1-0.8-0.2-1.7-0.2-2.5c-0.5,0-0.8-0.1-1-0.2c-0.2-0.1-0.3-0.4-0.4-0.7C0,11.4,0,11.2,0,11.1c0-0.1,0-0.2,0-0.3
            c0-0.2,0-0.5,0-0.7c0-0.2,0-0.4,0.1-0.7c0.1-0.4,0.2-0.7,0.4-0.7c0.2-0.1,0.4-0.1,0.8-0.2c0-1.1-0.1-2.2-0.1-3.4c0-1.1,0-2.3,0-3.5
            c0-0.6,0.1-1,0.2-1.2c0.1-0.2,0.4-0.3,0.8-0.4c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0C4,0,4.7,0.1,5.4,0.2c0.2,0,0.3,0.1,0.4,0.1
            c0.1,0,0.2,0.1,0.3,0.2C6.1,0.6,6.2,0.8,6.2,1c0,0.2,0,0.5,0,0.8c0,1.1,0,2.2,0,3.3c0,1.1,0,2.2,0.1,3.3c1.8-0.1,3.6-0.1,5.5-0.1
            h1.2c0-0.6,0-1.2,0-1.8C13.1,5.8,13.1,5.2,13.1,4.6z"
          />
          <path
            fill="#f9f9f9"
            d="M30.5,5.8C30.7,5.9,30.9,6,31,6.1c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.4
            c1.4,0.3,2.4,1,3.2,2c0.8,1,1.2,2.2,1.2,3.7c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1,1.4-1.6,2c-0.7,0.5-1.4,0.9-2.3,1.2
            c-0.8,0.3-1.7,0.4-2.5,0.4c-1.1,0-2.2-0.1-3.1-0.4c-0.9-0.3-1.7-0.7-2.4-1.3c-0.7-0.6-1.2-1.2-1.5-2.1c-0.4-0.8-0.5-1.8-0.5-2.8
            c0-1.1,0.2-2.1,0.7-2.9c0.4-0.9,1-1.6,1.7-2.3c0.7-0.6,1.5-1.1,2.4-1.4s1.8-0.5,2.7-0.5c0.3,0,0.6,0,1,0.1
            C29.8,5.7,30.1,5.8,30.5,5.8z M29.6,10.9c-0.2-0.1-0.4-0.1-0.5-0.2s-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.4
            c0-0.2-0.1-0.4-0.1-0.6c-0.9,0.1-1.6,0.4-2.2,1.1c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.4,0.6,0.6,0.8
            c0.3,0.2,0.6,0.4,0.9,0.5s0.7,0.2,1.1,0.2c0.4,0,0.7-0.1,1.1-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.2,0.5-0.5,0.7-0.8
            c0.2-0.3,0.3-0.7,0.3-1c0-0.5-0.1-0.9-0.4-1.3C30.5,11.3,30.1,11,29.6,10.9z"
          />
          <path
            fill="#f9f9f9"
            d="M48.5,7.5c0.6-0.6,1.2-1.1,1.9-1.4c0.7-0.3,1.4-0.5,2.1-0.5c0.5,0,1,0.1,1.5,0.2s0.9,0.4,1.3,0.7
            c0.4,0.3,0.7,0.7,0.9,1.2c0.2,0.5,0.3,1.1,0.3,1.7c0,0.5,0,1,0,1.7s-0.1,1.3-0.1,2c0,0.7-0.1,1.5-0.2,2.3c-0.1,0.8-0.2,1.6-0.3,2.3
            c0,0.3-0.1,0.6-0.3,0.8c-0.1,0.3-0.4,0.4-0.9,0.4c-0.2,0-0.6,0-1-0.1c-0.4,0-0.9-0.1-1.2-0.2c-0.6-0.1-0.8-0.5-0.8-1.2
            c0-0.2,0-0.9,0.1-2c0.1-1.1,0.1-2.6,0.1-4.5c0-0.4-0.1-0.8-0.2-1s-0.3-0.4-0.6-0.4c-0.7,0-1.5,0.3-2.3,0.9c0,0.3,0,0.6,0,1
            c0,0.3,0,0.7,0,1.1c0,0.8,0,1.6,0,2.5c0,0.9,0,1.7-0.1,2.4c0,0.5-0.1,0.8-0.3,1c-0.2,0.2-0.5,0.3-0.9,0.3h-0.6c-0.3,0-0.5,0-0.8,0
            c-0.3,0-0.5,0-0.8-0.1c-0.3,0-0.6-0.2-0.7-0.4s-0.2-0.5-0.3-0.9c0-1.1,0-2.1,0-3.1s0-2.1-0.1-3.2c0-0.4-0.1-0.7-0.2-1
            c-0.1-0.2-0.3-0.4-0.5-0.4c-0.4,0-0.7,0.1-1.1,0.3c-0.4,0.2-0.7,0.4-1,0.6c0,1.1,0.1,2.2,0.1,3.3s0.1,2.2,0.2,3.3
            c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.6,0.3-1.1,0.3c-0.1,0-0.3,0-0.4,0s-0.3,0-0.5,0
            s-0.3,0-0.4,0s-0.3,0-0.4,0c-0.5,0-0.9-0.2-1.1-0.4c-0.2-0.2-0.3-0.5-0.3-0.9c-0.1-1.3-0.3-2.7-0.3-4c-0.1-1.4-0.1-2.7-0.1-4.1
            c0-0.3,0-0.6,0-1c0-0.3,0-0.6,0-1c0-0.4,0.1-0.7,0.1-1c0.1-0.3,0.3-0.5,0.6-0.5c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1
            c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6,0,0.8,0c0.3,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.4
            c0.4-0.4,0.9-0.6,1.5-0.9c0.6-0.2,1.1-0.3,1.6-0.3c0.8,0,1.5,0.1,2.1,0.3C47.5,6.3,48,6.8,48.5,7.5z"
          />
          <path
            fill="#f9f9f9"
            d="M70.6,12.6c-0.4,0.2-1,0.3-1.6,0.4c-0.6,0.1-1.3,0.3-2,0.4c-0.7,0.1-1.4,0.2-2.2,0.3c-0.8,0.1-1.5,0.1-2.2,0.2
            c0.4,0.4,0.8,0.7,1.4,1c0.6,0.2,1.1,0.4,1.8,0.4c0.5,0,1-0.1,1.6-0.2c0.6-0.1,1.2-0.3,1.7-0.6c0.3-0.1,0.5-0.2,0.6-0.2
            c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0.1,0.2,0.1,0.3
            c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.6-0.4,0.9c-0.5,0.5-1.3,0.9-2.2,1.2c-1,0.3-2,0.5-3.2,0.5c-0.9,0-1.7-0.2-2.5-0.5
            c-0.8-0.3-1.5-0.8-2.1-1.3c-0.6-0.6-1.1-1.3-1.5-2.1c-0.4-0.8-0.6-1.7-0.6-2.7c0-1,0.2-1.9,0.6-2.8c0.4-0.8,0.9-1.6,1.5-2.2
            c0.6-0.6,1.4-1.1,2.2-1.4c0.8-0.3,1.7-0.5,2.6-0.5c1.2,0,2.2,0.2,3.1,0.7c0.8,0.4,1.5,1,2,1.6c0.5,0.6,0.9,1.3,1.1,2
            c0.2,0.7,0.3,1.3,0.3,1.7c0,0.2,0,0.4-0.1,0.6C71,12.4,70.8,12.5,70.6,12.6z M64.8,9.3c-0.6,0-1.2,0.2-1.7,0.6
            c-0.5,0.4-0.9,0.8-1.1,1.4c0.8,0,1.6-0.1,2.5-0.2c0.9-0.1,1.7-0.2,2.4-0.4c-0.2-0.5-0.5-0.9-0.9-1.1C65.6,9.4,65.2,9.3,64.8,9.3z"
          />
          <path
            fill="#f9f9f9"
            d="M72.6,7.4c0-0.4,0.1-0.7,0.1-1C72.8,6.1,73,6,73.3,5.9c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1
            c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6,0,0.8,0c0.3,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0,0.4c0,0.2,0,0.3,0,0.4
            c0.5-0.4,1-0.8,1.6-1.1c0.6-0.3,1.3-0.4,2-0.4c0.5,0,0.8,0.2,1.1,0.6c0.3,0.4,0.4,0.8,0.5,1.2c0.1,0.4,0.1,0.8,0.2,1.3
            c0,0.5,0,0.9,0,1.3c0,0.4-0.1,0.7-0.3,1s-0.5,0.6-1,0.9c-0.2,0.1-0.5,0.3-0.9,0.4c-0.4,0.1-0.6,0.2-0.8,0.2c-0.3,0-0.5-0.1-0.7-0.4
            c-0.2-0.3-0.2-0.5-0.2-0.8c0-0.2,0-0.4,0-0.8c0-0.3-0.1-0.6-0.1-0.8c-0.2,0.1-0.5,0.2-0.7,0.4c-0.2,0.1-0.5,0.3-0.8,0.6
            c0,0.9,0,1.8,0.1,2.7c0,0.8,0.1,1.6,0.1,2.2c0,0.6,0.1,1.2,0.1,1.6c0,0.4,0.1,0.7,0.1,0.9c0,0.3-0.1,0.5-0.3,0.7
            c-0.2,0.2-0.6,0.3-1.1,0.3c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.5,0-0.9-0.2-1.1-0.4
            c-0.2-0.2-0.3-0.5-0.3-0.9c-0.1-1.3-0.3-2.7-0.3-4.1s-0.1-2.8-0.1-4.1c0-0.3,0-0.6,0-0.9S72.6,7.7,72.6,7.4z"
          />
          <path
            fill="#f9f9f9"
            d="M92.9,5.8c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.4
            c1.4,0.3,2.4,1,3.2,2c0.8,1,1.2,2.2,1.2,3.7c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1,1.4-1.6,2c-0.7,0.5-1.4,0.9-2.3,1.2
            c-0.8,0.3-1.7,0.4-2.5,0.4c-1.1,0-2.2-0.1-3.1-0.4c-0.9-0.3-1.7-0.7-2.4-1.3c-0.7-0.6-1.2-1.2-1.5-2.1c-0.4-0.8-0.5-1.8-0.5-2.8
            c0-1.1,0.2-2.1,0.7-2.9c0.4-0.9,1-1.6,1.7-2.3c0.7-0.6,1.5-1.1,2.4-1.4s1.8-0.5,2.7-0.5c0.3,0,0.6,0,1,0.1
            C92.2,5.7,92.5,5.8,92.9,5.8z M92,10.9c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.4
            c0-0.2-0.1-0.4-0.1-0.6c-0.9,0.1-1.6,0.4-2.2,1.1c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.4,0.6,0.6,0.8
            c0.3,0.2,0.6,0.4,0.9,0.5c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.7-0.1,1.1-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.2,0.5-0.5,0.7-0.8
            c0.2-0.3,0.3-0.7,0.3-1c0-0.5-0.1-0.9-0.4-1.3C92.9,11.3,92.5,11,92,10.9z"
          />
          <path
            fill="#f9f9f9"
            d="M108.4,5.8c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.4
            c1.4,0.3,2.4,1,3.2,2c0.8,1,1.2,2.2,1.2,3.7c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1,1.4-1.6,2c-0.7,0.5-1.4,0.9-2.3,1.2
            c-0.8,0.3-1.7,0.4-2.5,0.4c-1.1,0-2.2-0.1-3.1-0.4c-0.9-0.3-1.7-0.7-2.4-1.3c-0.7-0.6-1.2-1.2-1.5-2.1c-0.4-0.8-0.5-1.8-0.5-2.8
            c0-1.1,0.2-2.1,0.7-2.9c0.4-0.9,1-1.6,1.7-2.3c0.7-0.6,1.5-1.1,2.4-1.4c0.9-0.3,1.8-0.5,2.7-0.5c0.3,0,0.6,0,1,0.1
            C107.8,5.7,108.1,5.8,108.4,5.8z M107.6,10.9c-0.2-0.1-0.4-0.1-0.5-0.2s-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.4
            c0-0.2-0.1-0.4-0.1-0.6c-0.9,0.1-1.6,0.4-2.2,1.1c-0.6,0.6-0.9,1.4-0.9,2.3c0,0.4,0.1,0.7,0.2,1c0.1,0.3,0.4,0.6,0.6,0.8
            c0.3,0.2,0.6,0.4,0.9,0.5c0.3,0.1,0.7,0.2,1.1,0.2c0.4,0,0.7-0.1,1.1-0.2c0.4-0.1,0.7-0.3,1-0.5c0.3-0.2,0.5-0.5,0.7-0.8
            c0.2-0.3,0.3-0.7,0.3-1c0-0.5-0.1-0.9-0.4-1.3C108.5,11.3,108.1,11,107.6,10.9z"
          />
          <path
            fill="#f9f9f9"
            d="M126.5,7.5c0.6-0.6,1.2-1.1,1.9-1.4c0.7-0.3,1.4-0.5,2.1-0.5c0.5,0,1,0.1,1.5,0.2s0.9,0.4,1.3,0.7
            c0.4,0.3,0.7,0.7,0.9,1.2c0.2,0.5,0.3,1.1,0.3,1.7c0,0.5,0,1,0,1.7c0,0.6-0.1,1.3-0.1,2c0,0.7-0.1,1.5-0.2,2.3
            c-0.1,0.8-0.2,1.6-0.3,2.3c0,0.3-0.1,0.6-0.3,0.8c-0.1,0.3-0.4,0.4-0.9,0.4c-0.2,0-0.6,0-1-0.1c-0.4,0-0.9-0.1-1.2-0.2
            c-0.6-0.1-0.8-0.5-0.8-1.2c0-0.2,0-0.9,0.1-2c0.1-1.1,0.1-2.6,0.1-4.5c0-0.4-0.1-0.8-0.2-1c-0.1-0.3-0.3-0.4-0.6-0.4
            c-0.7,0-1.5,0.3-2.3,0.9c0,0.3,0,0.6,0,1c0,0.3,0,0.7,0,1.1c0,0.8,0,1.6,0,2.5c0,0.9,0,1.7-0.1,2.4c0,0.5-0.1,0.8-0.3,1
            c-0.2,0.2-0.5,0.3-0.9,0.3h-0.6c-0.3,0-0.5,0-0.8,0c-0.3,0-0.5,0-0.8-0.1c-0.3,0-0.6-0.2-0.7-0.4c-0.1-0.2-0.2-0.5-0.3-0.9
            c0-1.1,0-2.1,0-3.1s0-2.1-0.1-3.2c0-0.4-0.1-0.7-0.2-1c-0.1-0.2-0.3-0.4-0.5-0.4c-0.4,0-0.7,0.1-1.1,0.3c-0.4,0.2-0.7,0.4-1,0.6
            c0,1.1,0.1,2.2,0.1,3.3c0.1,1.1,0.1,2.2,0.2,3.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.3,0.7
            c-0.2,0.2-0.6,0.3-1.1,0.3c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.5,0-0.9-0.2-1.1-0.4
            c-0.2-0.2-0.3-0.5-0.3-0.9c-0.1-1.3-0.3-2.7-0.3-4c-0.1-1.4-0.1-2.7-0.1-4.1c0-0.3,0-0.6,0-1c0-0.3,0-0.6,0-1c0-0.4,0.1-0.7,0.1-1
            c0.1-0.3,0.3-0.5,0.6-0.5c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6,0,0.8,0
            c0.3,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.4c0.4-0.4,0.9-0.6,1.5-0.9
            c0.6-0.2,1.1-0.3,1.6-0.3c0.8,0,1.5,0.1,2.1,0.3C125.5,6.3,126,6.8,126.5,7.5z"
          />
        </g>
      </g>
      <g
        className="prefix__static-item"
        onClick={() => literacyCheck('/process-steps-admin')}
        style={{ cursor: 'pointer' }}
        transform="translate(35 430)"
      >
        <g id="affe68e0-09bb-4bce-b784-7bac5c76e05a" data-name="admin corner">
          <path
            d="M62.47,167.78A33,33,0,0,1,80.8,151.17c12.41-4.77,30.93-9.73,37.42-16s12.41-9.54,18.14-18.52,8-6.3,11.65-12c3.25-5.15,13.93-38.76-24.82-37-3.63,2.29-7.45,17.94-19.48,22.33s-28.26,12.41-38,19.29-14.51,22.15-10.7,42S62.47,167.78,62.47,167.78Z"
            fill="#ffecbf"
          />
          <path
            d="M119.18,117.76c-17.3,0-36.54,14.34-52.32,31.5C64,152.38,56,136.77,53.69,140.67c2.1,28.45,8.78,27.11,8.78,27.11A33,33,0,0,1,80.8,151.17c12.41-4.77,30.93-9.73,37.42-16s12.41-9.54,18.14-18.52,8-6.3,11.65-12c1.56-2.48,4.84-11.52,3.52-20.06C145.73,97.74,130.35,117.76,119.18,117.76Z"
            fill="#dcb4b5"
            opacity="0.61"
          />
          <path
            d="M54.93,266.49c.19-9.16-5.54-59.18,21.76-72s64-12.41,82.1-30.74,32.65-21.57,44.68-21,41.43,20.81,45.44,51.74-29.69,47.74-34.46,49.84c-4.23,1.86-28.16,10.69-54.51,6.11s-55.75-4.4-72.55,1.52-24.82,14.51-28.64,14.51Z"
            fill="#ffecbf"
          />
          <path
            d="M61.13,211.7c3.44-6.11,19.1-25.59,42-26.73s36.27-6.11,47.16-14.13,28.83-20.62,30-25.2,5.73-19.86-5-30.55-26.35-16.81-38.19,0-24.82,19.85-33.6,20.81-37,17.37-42.39,34.94-7.25,24.44-4.2,35.51S61.13,211.7,61.13,211.7Z"
            fill="#ffecbf"
          />
          <path
            d="M199.56,238.05c-10.28.82-60.34-9.17-81.72-7.45s-49.06,15.46-62.91,35.47v.42h3.82c3.82,0,11.83-8.59,28.64-14.51s46.2-6.11,72.55-1.52,50.27-4.29,54.51-6.11c4-1.72,29.53-12.62,34.07-36.68C233.9,224.89,211.39,237.09,199.56,238.05Z"
            fill="#be969c"
          />
          <g opacity="0.35">
            <path
              d="M86.15,169.88a4.94,4.94,0,0,1,.26,1.74,6.77,6.77,0,0,1-.19,1.62,6.92,6.92,0,0,1-.57,1.53,4.94,4.94,0,0,1-1,1.41,4.69,4.69,0,0,1-.27-1.73,6.25,6.25,0,0,1,.2-1.62,6.71,6.71,0,0,1,.56-1.53A4.83,4.83,0,0,1,86.15,169.88Z"
              fill="#192c3e"
            />
            <path
              d="M151.25,248.93c-.68-1.51-2.17-1.83-3.57-1.89a22.38,22.38,0,0,0-4.36.36c-2.93.51-5.87,1.2-8.83,1.91L130,250.37l-2.25.51a3.43,3.43,0,0,0-1.38.54,1.24,1.24,0,0,0-.33,1.16,6.16,6.16,0,0,0,.57,1.93,28.48,28.48,0,0,0,2.27,4,14.13,14.13,0,0,1-3.62-3.13,7.64,7.64,0,0,1-1.3-2.28,3.92,3.92,0,0,1-.19-1.56,3.56,3.56,0,0,1,.63-1.67,5,5,0,0,1,2.59-1.71c.73-.25,1.47-.48,2.21-.72,1.48-.46,3-.88,4.5-1.24a41.91,41.91,0,0,1,9.39-1.28,16.21,16.21,0,0,1,4.86.61,6.31,6.31,0,0,1,2.25,1.21A2.86,2.86,0,0,1,151.25,248.93Z"
              fill="#85c9e7"
            />
            <path
              d="M94.55,150.79a13,13,0,0,0-8.17,4.05,12.06,12.06,0,0,0,0,16.34,13.08,13.08,0,0,0,8.17,4,11.59,11.59,0,0,1-9.12-3.11A12.28,12.28,0,0,1,82.51,168a12.78,12.78,0,0,1-1-5,13,13,0,0,1,1-5,12.38,12.38,0,0,1,2.92-4.12A11.63,11.63,0,0,1,94.55,150.79Z"
              fill="#192c3e"
            />
            <path
              d="M94.55,158.62a4.07,4.07,0,0,1,3.71.87A4.84,4.84,0,0,1,100,163.2a4.78,4.78,0,0,1-1.73,3.71,4,4,0,0,1-3.71.87,4.68,4.68,0,0,0,0-9.16Z"
              fill="#192c3e"
            />
          </g>
          <path
            d="M75.64,234.42c-8-18.9-3.24-20,0-32.27a43.67,43.67,0,0,0-8.5-.37c-16.27,18.62-12,56.82-12.21,64.71h3.82c3.82,0,11.83-8.59,28.64-14.51,1.21-.43,2.5-.82,3.84-1.19C86.41,247.51,79.26,242.94,75.64,234.42Z"
            fill="#ff70ac"
            opacity="0.32"
          />
          <path
            d="M141.13,110.37a50,50,0,0,1-17,19.56,49.24,49.24,0,0,1-12,6,38.84,38.84,0,0,1-6.73,1.59l-.42.06-.27.05a3.34,3.34,0,0,0-.57.11c-.4.08-.83.21-1.27.34-.87.27-1.78.6-2.68,1-1.82.73-3.65,1.58-5.44,2.51s-3.59,1.9-5.36,2.93a121.61,121.61,0,0,0-10.26,6.74,83.66,83.66,0,0,0-9.37,8,41.17,41.17,0,0,0-7.5,9.94A23.94,23.94,0,0,1,64,162.86a36,36,0,0,1,3.11-5.8,57.4,57.4,0,0,1,8.53-10A77.51,77.51,0,0,1,86,139a67.36,67.36,0,0,1,11.68-6.28c1.06-.42,2.15-.81,3.29-1.15.58-.17,1.17-.33,1.81-.46a9.06,9.06,0,0,1,1-.17l.52-.07.37,0a37.12,37.12,0,0,0,5.66-1.09,56.47,56.47,0,0,0,11.11-4.37A78.36,78.36,0,0,0,141.13,110.37Z"
            fill="#be969c"
          />
          <path
            d="M57.12,114.51c4.18,3.85,20.82-12.22,29.22-13.93s29-15.09,33.6-29.22-8-23.67-17.37-20.62S93,63.15,82.14,67,53.5,79.38,52.35,90.27,52.16,109.93,57.12,114.51Z"
            fill="#ffecbf"
          />
          <path
            d="M53.31,82.44c4.71,1,11.07-13.37,18.9-13s27.11-11.26,28.06-21.38S92.06,25.92,85.19,28.21,77.55,39.86,69.34,43.68s-20.81,9.93-22,17.76S45.29,80.72,53.31,82.44Z"
            fill="#ffecbf"
          />
          <path
            d="M119.94,71.36a17,17,0,0,0,0-11.46c-3.1,8.74-12.27,20-21.06,24.54-8.59,4.45-26.95,10-38.66,22.82-1.75,1.91-8-11.42-9.36-9,1.15,11.08,5,15.06,6.3,16.23,4.18,3.85,20.82-12.22,29.22-13.93S115.36,85.49,119.94,71.36Z"
            fill="#dcb4b5"
            opacity="0.61"
          />
          <path
            d="M50.82,55.71c2.68-6.3,13.56-6.49,20.81-10.31s9.74-14.51,3.63-25.78S77,1.29,71.63.15,68.2,4.54,61.71,16.76,54.45,27.26,50.82,37A28.25,28.25,0,0,0,50.82,55.71Z"
            fill="#ffecbf"
          />
          <path
            d="M184.09,251.41s-13.55-82.1,19.67-81.53S232,234.23,232,234.23,210.82,250.46,184.09,251.41Z"
            fill="#ff70ac"
          />
          <path
            d="M183.52,251.41a151.25,151.25,0,0,1-3.72-22.89c-.38-3.86-.54-7.73-.64-11.62s.05-7.77.3-11.67c.65-7.75,1.85-15.64,5.21-22.91a24.47,24.47,0,0,1,7.27-9.48,15.9,15.9,0,0,1,5.41-2.59,16.43,16.43,0,0,1,5.83-.37,18.73,18.73,0,0,0-5.54,1.28,15.47,15.47,0,0,0-4.63,3,24.64,24.64,0,0,0-5.88,9.23,57,57,0,0,0-2.89,10.84,103.16,103.16,0,0,0-1.35,11.27c-.32,3.78-.43,7.59-.48,11.41s0,7.64.06,11.47C182.66,236,183.05,243.7,183.52,251.41Z"
            fill="#fff"
          />
          <path
            d="M230.87,234.42A60.17,60.17,0,0,1,220.3,242a78.64,78.64,0,0,1-11.8,5.51c-2,.77-4.13,1.38-6.21,2-1,.27-2.12.5-3.18.76l-1.59.36-1.61.26c-1.07.16-2.14.36-3.22.5l-3.25.25c-.54,0-1.08.08-1.62.1h-1.63q-1.63,0-3.24-.09c4.26-.75,8.48-1.37,12.59-2.5a109.87,109.87,0,0,0,12.17-3.79c4-1.45,7.91-3.11,11.76-4.94S227.12,236.56,230.87,234.42Z"
            fill="#c9417f"
          />
          <path
            d="M231.63,234.42c-.51-6.52-1-12.94-1.83-19.31a143.14,143.14,0,0,0-3.44-18.73,64.74,64.74,0,0,0-3-8.88,39.64,39.64,0,0,0-4.43-8.06,23.71,23.71,0,0,0-6.68-6.17,25.4,25.4,0,0,0-8.89-3.2,20.68,20.68,0,0,1,9.85,1.27,22.89,22.89,0,0,1,8.36,5.92,34.15,34.15,0,0,1,5.59,8.53,53.25,53.25,0,0,1,3.42,9.46,83.36,83.36,0,0,1,2.61,19.62A88.31,88.31,0,0,1,231.63,234.42Z"
            fill="#c9417f"
          />
          <path
            d="M195.74,154.42s18.71-15.28,36.18,15.37c-5.73,6.49-12.7-7.35-20.72-5.83S195.17,160.91,195.74,154.42Z"
            fill="#fff"
          />
          <circle
            cx="143.38"
            cy="210.6"
            r="15.99"
            fill="#d4e5f4"
            stroke="#db4fcb"
            strokeMiterlimit="10"
            strokeWidth="3.82"
            opacity="0.72"
          />
          <path
            d="M75.74,195.28a90.46,90.46,0,0,1,15.84-7.68c5.5-2.09,11.11-3.82,16.7-5.45,11.16-3.26,22.42-6,32.59-10.49a51.14,51.14,0,0,0,13.77-8.58c.94-.83,2.12-1.94,3.19-2.94s2.23-2,3.38-2.94a77.73,77.73,0,0,1,7.22-5.38,55.81,55.81,0,0,1,16.38-7.54,41.64,41.64,0,0,1,17.71-.74,57.49,57.49,0,0,0-8.57,1.3,51.35,51.35,0,0,0-8.06,2.64,62.84,62.84,0,0,0-14.3,8.73c-1.09.89-2.2,1.73-3.24,2.7s-2.12,1.83-3.13,2.83-2,1.94-3,3-1.91,2-3.08,3.12a47.26,47.26,0,0,1-7.34,5.8,63.8,63.8,0,0,1-8.11,4.31,108.61,108.61,0,0,1-17,5.7c-5.72,1.45-11.44,2.63-17.14,3.75C98.16,189.63,86.87,191.67,75.74,195.28Z"
            fill="#be969c"
          />
          <path
            d="M150.3,170.84c10.88-8,28.83-20.62,30-25.2,1-3.92,1.91-6.69,1.15-19.86-4.77,23.48-26.34,32.36-38,33.22-13.14,1-59,14.51-79.8,36.28-3.55,3.7-2.56-19.78-4.78-14.9.12.47-5.15,14.13-1.91,26,3,11.08,4.2,5.35,4.2,5.35,3.44-6.11,19.29-22.53,42-26.73C125.7,180.8,139.41,178.86,150.3,170.84Z"
            fill="#dcb4b5"
            opacity="0.61"
          />
          <path
            d="M152.06,116.45c.68-6.82,15.67.64,18.59,4.65s4.8,11.29,3.13,13.3-3.95,0-10.52-9.07C160.33,121.28,151.43,122.73,152.06,116.45Z"
            fill="#fff"
          />
          <path
            d="M122,68.69a8.61,8.61,0,0,0-1.75,3.16c-.45,1.13-.85,2.3-1.26,3.47a54.31,54.31,0,0,1-2.93,7,27.27,27.27,0,0,1-4.52,6.47,20.27,20.27,0,0,1-6.81,4.77c-8.89,3.83-17.59,8.16-26,12.81-2.12,1.15-4.21,2.35-6.25,3.59-1,.61-2,1.25-3,1.88l-1.47,1c-.52.34-.89.6-1.33.93a25.87,25.87,0,0,0-7.77,10.42,48.14,48.14,0,0,0-3.44,13.57A92.1,92.1,0,0,0,55,152.32a54.32,54.32,0,0,1-3-14.71,42.91,42.91,0,0,1,1.75-15.35,29,29,0,0,1,8.73-13.61c.52-.44,1.13-.92,1.64-1.27l1.56-1.11c1-.71,2.1-1.43,3.17-2.1,2.13-1.36,4.31-2.61,6.49-3.84S79.81,98,82,96.85s4.51-2.15,6.8-3.14a141,141,0,0,1,14-5.27c4-1.19,7.51-4.2,10.35-8,1.46-1.87,2.75-3.92,4.08-6,.68-1,1.34-2.09,2.07-3.12a16.75,16.75,0,0,1,1.19-1.48A4.68,4.68,0,0,1,122,68.69Z"
            fill="#be969c"
          />
          <path
            d="M103,50.74a17.58,17.58,0,0,0-4.37,3.49,33.49,33.49,0,0,0-3.22,4.47,45,45,0,0,1-3.42,4.86,21.92,21.92,0,0,1-4.78,4.25l-1.41.83c-.47.26-1,.48-1.45.71l-.74.34-.65.28-1.28.54c-1.69.75-3.37,1.5-5,2.31A94,94,0,0,0,67,78.09a46.9,46.9,0,0,0-4.35,3,30.2,30.2,0,0,0-3.75,3.43,15.88,15.88,0,0,0-2.64,3.84,10.23,10.23,0,0,0-.66,2c-.15.83-.31,1.8-.43,2.7a60.16,60.16,0,0,0-.75,10.93c.15,3.61.79,7.26,3.07,10.44a12.68,12.68,0,0,1-4.09-4.3,22,22,0,0,1-2.32-5.6,44.75,44.75,0,0,1-1.3-11.87c0-1,0-1.93.1-3a14.71,14.71,0,0,1,.72-3.5,20,20,0,0,1,3.31-5.87,38.73,38.73,0,0,1,9.41-8.09A68.88,68.88,0,0,1,74,66.88c1.83-.74,3.67-1.43,5.55-2l1.4-.44.7-.21.58-.2c.39-.13.8-.24,1.18-.39l1.13-.49a19.79,19.79,0,0,0,4.24-2.72c1.34-1.11,2.63-2.45,4-3.82a26.11,26.11,0,0,1,4.63-3.81A13.91,13.91,0,0,1,103,50.74Z"
            fill="#be969c"
          />
          <path
            d="M78.26,27.7C68.87,37.54,61,40.46,56.55,40.62c-2.69.1-4.13-3-4.43-6.91-.4.94-.82,2-1.3,3.29a28.25,28.25,0,0,0,0,18.71c2.68-6.3,13.56-6.49,20.81-10.31C77.11,42.51,79.87,35.71,78.26,27.7Z"
            fill="#dcb4b5"
            opacity="0.61"
          />
          <path
            d="M83.66,59.91C78,62.19,64.19,65,55.76,73c-4.55-4.22-.32-12.92,1.77-22.23,0,0-1.52.69-3.8,1.77-3.35,2.65-5.86,5.63-6.34,8.93a59.86,59.86,0,0,0-.76,8.91,15.15,15.15,0,0,0,.86,6.39c.92,2.86,2.68,5,5.82,5.7a2.31,2.31,0,0,0,.46,0h.16l.31,0,.2,0,.29-.08.21-.08.28-.13.23-.11.28-.16.23-.15.29-.19.24-.18.28-.23.25-.2.29-.26.25-.22.3-.28.26-.25.29-.29.27-.28L59,79l.29-.3.25-.27c.11-.12.23-.24.34-.37l0,0c.77-.83,1.55-1.7,2.37-2.57,3-3.17,6.31-6.19,10-6,7.83.39,27.11-11.26,28.06-21.38,0-.22,0-.45,0-.67C94.3,53.59,89.06,57.72,83.66,59.91Z"
            fill="#dcb4b5"
            opacity="0.61"
          />
          <path
            d="M85.38,29a13.47,13.47,0,0,0-3.76,4.89c-.9,1.83-1.71,3.8-2.83,5.82a19.91,19.91,0,0,1-4.62,5.74c-.52.4-1,.8-1.59,1.16l-1.71,1L68,49c-3.79,1.84-7.57,3.55-11.14,5.49a39.93,39.93,0,0,0-5.13,3.17,14.13,14.13,0,0,0-4.17,4.58,10.24,10.24,0,0,1,1.61-6.79,23.49,23.49,0,0,1,4.54-5.35A48,48,0,0,1,65,42.77c1-.46,2-.92,3-1.36l1.16-.54c.37-.2.71-.44,1.09-.64a22,22,0,0,0,4.15-3.68A62.65,62.65,0,0,1,79,31.78,10,10,0,0,1,85.38,29Z"
            fill="#be969c"
          />
          <path
            d="M130.63,72.89c2.3-3.19,16.23,2.87,16.23,11.65s-3.82-.19-8.21,3S127.2,108,122,100.58c-3.59-5.19,4-4.2,7.64-13C131.54,83.08,127.2,77.66,130.63,72.89Z"
            fill="#fff"
          />
          <path
            d="M105.05,53.23c1.73-1.82,9.73,1.9,12,7.63s-5.92,1.91-7.64,4,2.1,9.55-9.17,13c-1.14-4.78,0-5.16,2.49-10.31S100.66,57.81,105.05,53.23Z"
            fill="#fff"
          />
          <path
            d="M88.63,33c1.58-2.64,10.12,8.4,7.83,14.32-2.87,1.91-8.6,9.35-14.32,8.4s6.3-5.54,7.44-8.4S86.34,36.81,88.63,33Z"
            fill="#fff"
          />
          <path
            d="M68,20.58C64.57,22.1,65,15,68,9.12s2.1,3.06,2.67,5.92,4,4.77,2.86,5.54S68,20.58,68,20.58Z"
            fill="#fff"
          />
          <line
            x1="134.35"
            y1="202.25"
            x2="154.21"
            y2="216.95"
            fill="none"
            stroke="#f9f9f9"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2.86"
          />
          <line
            x1="131.68"
            y1="206.45"
            x2="150.97"
            y2="220.58"
            fill="none"
            stroke="#f9f9f9"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2.86"
          />
          <line
            x1="143.33"
            y1="194.61"
            x2="143.33"
            y2="226.69"
            fill="none"
            stroke="#db4fcb"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3.82"
          />
          <line
            x1="127.39"
            y1="210.55"
            x2="159.27"
            y2="210.55"
            fill="none"
            stroke="#db4fcb"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3.82"
          />
          <g>
            <circle
              cx="149.1"
              cy="138.63"
              r="11.52"
              fill="#d4e5f4"
              stroke="#db4fcb"
              strokeMiterlimit="10"
              strokeWidth="2.75"
              opacity="0.72"
            />
            <line
              x1="142.61"
              y1="132.62"
              x2="156.91"
              y2="143.2"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2.06"
            />
            <line
              x1="140.68"
              y1="135.64"
              x2="154.57"
              y2="145.82"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2.06"
            />
            <line
              x1="149.07"
              y1="127.12"
              x2="149.07"
              y2="150.22"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2.75"
            />
            <line
              x1="137.59"
              y1="138.6"
              x2="160.55"
              y2="138.6"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2.75"
            />
          </g>
          <circle
            cx="86.48"
            cy="120.52"
            r="10.07"
            fill="#d4e5f4"
            stroke="#db4fcb"
            strokeMiterlimit="10"
            strokeWidth="1.72"
            opacity="0.72"
          />
          <line
            x1="80.8"
            y1="115.25"
            x2="93.3"
            y2="124.51"
            fill="none"
            stroke="#f9f9f9"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.15"
          />
          <line
            x1="79.11"
            y1="117.9"
            x2="91.26"
            y2="126.8"
            fill="none"
            stroke="#f9f9f9"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.15"
          />
          <line
            x1="86.45"
            y1="110.44"
            x2="86.45"
            y2="130.65"
            fill="none"
            stroke="#db4fcb"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.72"
          />
          <line
            x1="76.41"
            y1="120.49"
            x2="96.49"
            y2="120.49"
            fill="none"
            stroke="#db4fcb"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.72"
          />
          <path
            d="M54.93,266.49h3.82c1.8,0,4.55-1.92,8.71-4.57-7.53-11.78-9.31-29.28-9.48-41.85C52.82,238.74,55.05,260.72,54.93,266.49Z"
            fill="#beaa83"
          />
          <g>
            <path
              d="M80.42,172.17c-11.08-1.71-22.72-4.58-24.06,0s-5.54,12.61,17.76,15.47c-2.87,14.13-6.88,39.9-13.18,46.2s-13.36,9.55-19.09,8.79S26,235,22.57,222.39C32.69,218,35.17,215.9,26,211.51s-15.84-11.65-17.94-9S.61,226.21,0,228.69,9.2,227,13.21,225.25c2.29,5.92,10.12,25,23.68,32.27s20.23,25,18.71,29.59c4.2-1.14,11.83-15.84,32.84-15.84s34-.38,41.81-9.36c3.44,2.48,7.64,5.54,9.16,4.58s9-16.23,7.83-22.14-17.56-1.15-23.86.57,1.52,9,1.52,9-6.3,5.35-14.32,5.92-33.6.76-27.87-23.48,13-45.25,13-45.25S111,197.19,118,192.6c4.08-2.64,2.86-11.64-5.15-13.17S93.59,175,93.59,175l1-5.35-12.61-3.82Z"
              fill="#0e6c8b"
            />
            <path
              d="M23.14,222.39c1.37-1,2.8-1.86,4.16-2.79.68-.45,1.35-.91,2-1.4a7.35,7.35,0,0,0,1.48-1.47.62.62,0,0,0,.15-.49,1,1,0,0,0-.17-.3,5.76,5.76,0,0,0-1.43-1.17,22.42,22.42,0,0,0-2-1.12l-2.21-1.07A50.37,50.37,0,0,1,16.6,207c-1.31-1-2.57-2.11-3.86-3.09a13.89,13.89,0,0,0-2-1.34,1.85,1.85,0,0,0-2.15-.05,1.52,1.52,0,0,1,1-.81,3.56,3.56,0,0,1,1.38,0,11.27,11.27,0,0,1,2.5.82A47.26,47.26,0,0,1,18,204.91c2.88,1.64,5.65,3.33,8.51,4.77.69.35,1.49.73,2.25,1.14A20.71,20.71,0,0,1,31,212.25a7.31,7.31,0,0,1,2.13,2.24,3.16,3.16,0,0,1,.42,2.06,3.33,3.33,0,0,1-.87,1.74,8.18,8.18,0,0,1-2.33,1.7A25.8,25.8,0,0,1,28,221,36,36,0,0,1,23.14,222.39Z"
              fill="#85c9e7"
            />
            <path
              d="M56.93,171.6c-.15,2.45-.64,4.88.16,6.69s2.47,3,4.42,4a30.74,30.74,0,0,0,3.08,1.34l3.29,1.13c1.13.32,2.24.75,3.38,1.09s2.29.73,3.43,1.22c-1.22.14-2.44.15-3.66.17s-2.44-.15-3.65-.28-2.42-.46-3.63-.74a22.88,22.88,0,0,1-3.54-1.37l-.86-.44c-.28-.17-.56-.37-.83-.56l-.81-.58a9.88,9.88,0,0,1-.74-.71,7.17,7.17,0,0,1-2-3.66,7.45,7.45,0,0,1,.35-4A17.72,17.72,0,0,1,56.93,171.6Z"
              fill="#192c3e"
            />
            <path
              d="M81.94,165.87a4.74,4.74,0,0,1,.27,1.74,6.77,6.77,0,0,1-.19,1.62,6.92,6.92,0,0,1-.57,1.53,4.94,4.94,0,0,1-1,1.41,4.66,4.66,0,0,1-.27-1.73,6.25,6.25,0,0,1,.2-1.62,6.71,6.71,0,0,1,.56-1.53A5.12,5.12,0,0,1,81.94,165.87Z"
              fill="#192c3e"
            />
            <path
              d="M117.27,192.8a5.65,5.65,0,0,0,1.44-4.05,8.05,8.05,0,0,0-1.21-3.87,7.94,7.94,0,0,0-2.82-2.65,9.26,9.26,0,0,0-1.8-.76l-1-.24c-.34-.08-.76-.14-1.14-.22a83.5,83.5,0,0,1-9.12-2.34,60.08,60.08,0,0,1-8.82-3.44,80.7,80.7,0,0,1,9.39,1c3.09.45,6.14,1,9.18,1.63.39.08.74.14,1.15.24l1.3.35a10.44,10.44,0,0,1,2.44,1.2,9.12,9.12,0,0,1,3.46,4.12,8.53,8.53,0,0,1,.53,5.19A5.43,5.43,0,0,1,117.27,192.8Z"
              fill="#85c9e7"
            />
            <path
              d="M94.93,191.08c4,.28,7.64,1,11.32,1.5a50.7,50.7,0,0,0,5.45.52,18.51,18.51,0,0,0,5.57-.5,9.26,9.26,0,0,1-5.38,2.75,18.5,18.5,0,0,1-6,.06,25,25,0,0,1-5.74-1.49A20.36,20.36,0,0,1,94.93,191.08Z"
              fill="#192c3e"
            />
            <path
              d="M109.25,260A35.39,35.39,0,0,1,98,261a24.89,24.89,0,0,1-11.19-3.33,15.71,15.71,0,0,1-4.5-4.14,14.17,14.17,0,0,1-2.4-5.61,19.75,19.75,0,0,1,1.51-11.35c-.16,3.76-.13,7.45.95,10.72a14,14,0,0,0,6.15,7.62,31,31,0,0,0,9.83,3.59C101.84,259.18,105.5,259.59,109.25,260Z"
              fill="#85c9e7"
            />
            <path
              d="M147.05,244.92c-.68-1.51-2.17-1.83-3.57-1.89a22.38,22.38,0,0,0-4.36.36c-2.93.51-5.88,1.2-8.83,1.91l-4.46,1.06-2.26.51a3.44,3.44,0,0,0-1.37.54,1.24,1.24,0,0,0-.33,1.16,6.16,6.16,0,0,0,.57,1.93,29.16,29.16,0,0,0,2.27,4,14.58,14.58,0,0,1-3.63-3.14,7.84,7.84,0,0,1-1.29-2.28,3.92,3.92,0,0,1-.19-1.56,3.56,3.56,0,0,1,.63-1.67,5,5,0,0,1,2.59-1.71c.73-.25,1.47-.48,2.21-.72,1.48-.46,3-.87,4.5-1.24a41.91,41.91,0,0,1,9.39-1.28,16.25,16.25,0,0,1,4.86.61,6.31,6.31,0,0,1,2.25,1.21A2.86,2.86,0,0,1,147.05,244.92Z"
              fill="#85c9e7"
            />
            <path
              d="M130.25,262.68c1.35.58,2.62,1.27,3.91,1.88a20.16,20.16,0,0,0,3.74,1.58,2.45,2.45,0,0,0,.41.08,1.26,1.26,0,0,0,.33,0c.11,0,.11,0,.15,0s0,0,0-.06l.39-.6.49-.87c.64-1.21,1.26-2.48,1.86-3.74,1.19-2.54,2.34-5.12,3.39-7.72a28.59,28.59,0,0,0,2.35-8.1,10.9,10.9,0,0,1,.5,4.41,27.83,27.83,0,0,1-.7,4.37,43.68,43.68,0,0,1-2.95,8.26A42,42,0,0,1,142,266a10.19,10.19,0,0,1-1.6,2,1.79,1.79,0,0,1-.4.29,4.87,4.87,0,0,1-.53.21,2.89,2.89,0,0,1-.91.05,3,3,0,0,1-.74-.14,4.48,4.48,0,0,1-.62-.22,16,16,0,0,1-3.8-2.53A36,36,0,0,1,130.25,262.68Z"
              fill="#192c3e"
            />
            <path
              d="M56.93,287.11a6.6,6.6,0,0,0,2-1.47c.59-.59,1.16-1.2,1.73-1.81,1.14-1.24,2.31-2.46,3.53-3.64a38.1,38.1,0,0,1,8.28-6.1,34.76,34.76,0,0,1,9.78-3.51,39.25,39.25,0,0,1,5.17-.64c.86-.05,1.74-.06,2.59-.08l2.51,0c3.35,0,6.69,0,10-.17s6.63-.32,9.9-.72A39.31,39.31,0,0,0,122,266.6a25.48,25.48,0,0,0,8.29-5.37,22.4,22.4,0,0,1-7.69,6.66,35.31,35.31,0,0,1-9.76,3.27c-6.74,1.3-13.54,1.45-20.27,1.53H90c-.83,0-1.63,0-2.45.05a46,46,0,0,0-4.83.5,36.41,36.41,0,0,0-9.27,2.83,43.23,43.23,0,0,0-8.37,5.17c-1.32,1-2.59,2.1-3.89,3.16-.66.54-1.31,1.07-2,1.57A6.67,6.67,0,0,1,56.93,287.11Z"
              fill="#192c3e"
            />
            <path
              d="M0,228.69a.5.5,0,0,0,.41.63,2.49,2.49,0,0,0,.86,0A13.24,13.24,0,0,0,3,228.84c1.13-.37,2.23-.85,3.33-1.32,2.2-.94,4.35-2,6.53-3l.73-.35L14,225a105.72,105.72,0,0,0,9,16.83,62.86,62.86,0,0,0,5.79,7.45,39.9,39.9,0,0,0,7.05,6L40,257.82a36.12,36.12,0,0,1,3.9,3.16,39.52,39.52,0,0,1,6.33,7.65,40.94,40.94,0,0,1,4.29,8.86,29.14,29.14,0,0,1,1.21,4.76,10.1,10.1,0,0,1-.12,4.86,10.62,10.62,0,0,0-.55-4.71,35.15,35.15,0,0,0-1.67-4.46,46.2,46.2,0,0,0-4.83-8.17,42.51,42.51,0,0,0-6.34-6.91,33.39,33.39,0,0,0-3.71-2.8l-2-1.16-2.15-1.28a37.77,37.77,0,0,1-7.66-6.46,59.06,59.06,0,0,1-5.95-7.91,83.75,83.75,0,0,1-8.31-17.7l1.09.46c-2.24.87-4.52,1.69-6.84,2.42-1.16.35-2.33.67-3.53.92a10.17,10.17,0,0,1-1.82.22,2.68,2.68,0,0,1-.93-.12.61.61,0,0,1-.36-.31A.59.59,0,0,1,0,228.69Z"
              fill="#192c3e"
            />
            <path
              d="M90.35,147a12.22,12.22,0,1,0,12.22,12.22A12.22,12.22,0,0,0,90.35,147Zm0,16.8a4.58,4.58,0,1,1,4.58-4.58A4.59,4.59,0,0,1,90.35,163.77Z"
              fill="#0e6c8b"
            />
            <path
              d="M102.18,160.15a23.79,23.79,0,0,0-1.89-4.28,16.53,16.53,0,0,0-6.05-6,23.41,23.41,0,0,0-4.28-1.9,8.46,8.46,0,0,1,5.08,0,10.45,10.45,0,0,1,4.51,2.67,10.61,10.61,0,0,1,2.67,4.51A8.54,8.54,0,0,1,102.18,160.15Z"
              fill="#85c9e7"
            />
            <path
              d="M90.35,146.78a13,13,0,0,0-8.17,4.05,12,12,0,0,0,0,16.34,13.06,13.06,0,0,0,8.17,4.05,11.61,11.61,0,0,1-9.12-3.1A12.42,12.42,0,0,1,78.31,164a12.78,12.78,0,0,1-1-5,13,13,0,0,1,1-5,12.38,12.38,0,0,1,2.92-4.12A11.63,11.63,0,0,1,90.35,146.78Z"
              fill="#192c3e"
            />
            <path
              d="M90.35,154.61a4.07,4.07,0,0,1,3.71.87,4.87,4.87,0,0,1,1.73,3.71,4.81,4.81,0,0,1-1.73,3.72,4.07,4.07,0,0,1-3.71.86,4.68,4.68,0,0,0,0-9.16Z"
              fill="#192c3e"
            />
          </g>
          <ellipse cx="221.51" cy="206.62" rx="3.5" ry="6.5" fill="#c9417f" />
        </g>
        <g transform="translate(110 280)">
          <rect width="150" height="20" fill="transparent" />
          <path
            fill="#f9f9f9"
            d="M0.9,14.2C0.3,14.1,0,13.8,0,13.3c0-0.4,0-0.8,0-1.1c0-0.3,0-0.6,0.1-0.9s0.1-0.4,0.3-0.5
      c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.5,0,1,0.1c0.5-1.5,1-3,1.6-4.5c0.6-1.5,1.1-2.8,1.6-4.1c0.2-0.5,0.6-0.8,1-0.9
      C6.6,1.1,7,1.1,7.4,1c0.4,0,0.8-0.1,1.2-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.5,0c0.5,0,0.8,0.3,1.1,0.8c0.5,0.9,1,2.2,1.7,3.7
      c0.7,1.5,1.3,3.2,2,5.1c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.4,0,0.7,0.2,0.8,0.7
      c0.1,0.4,0.2,0.8,0.2,1.4c0,0.1,0,0.2,0,0.4c0,0.1,0,0.3,0,0.4c0,0.3-0.1,0.5-0.3,0.6c-0.1,0.1-0.3,0.2-0.6,0.2
      c0.1,0.4,0.2,0.7,0.3,1c0.1,0.3,0.2,0.6,0.2,0.8c0,0.2,0.1,0.3,0.1,0.4c0,0.1,0,0.1,0,0.2c0,0.4-0.2,0.6-0.6,0.7
      c-0.5,0.1-0.9,0.2-1.4,0.3c-0.5,0.1-1,0.1-1.5,0.1c-0.3,0-0.5-0.1-0.6-0.2s-0.2-0.3-0.3-0.6l-0.6-2.4c-0.9,0-1.8,0.1-2.6,0.1
      c-0.6,0-1.1,0-1.7,0c-0.6,0-1.1,0-1.6-0.1C5.1,15,5,15.4,4.9,15.8c-0.1,0.4-0.2,0.8-0.3,1.2c-0.1,0.5-0.4,0.8-0.9,0.8
      c-0.4,0-0.9,0-1.4-0.1c-0.5-0.1-1-0.2-1.4-0.3c-0.4-0.1-0.6-0.4-0.6-0.8c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3
      c0-0.2,0.1-0.5,0.2-0.9C0.7,14.9,0.8,14.6,0.9,14.2z M6.2,10.7c0.6,0,1.3,0,1.9,0c0.6,0,1.3,0,1.9,0C9.7,9.8,9.4,8.9,9.1,7.9
      C8.7,7,8.4,6.1,8,5.3c-0.3,1-0.7,1.9-0.9,2.8C6.8,9,6.5,9.9,6.2,10.7z"
          />
          <path
            fill="#f9f9f9"
            d="M26.3,17.5c-0.2,0-0.4-0.1-0.5-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.3,0-0.5
      c-1,0.8-2.1,1.3-3.4,1.3c-0.8,0-1.4-0.1-2-0.4c-0.6-0.3-1.1-0.6-1.5-1.1c-0.4-0.5-0.7-1-1-1.7c-0.2-0.6-0.3-1.3-0.3-2.1
      c0-1,0.2-1.8,0.5-2.6c0.4-0.8,0.8-1.5,1.4-2c0.6-0.6,1.3-1,2.1-1.3C21.9,6.1,22.7,6,23.6,6c0.4,0,0.7,0,1.1,0.1
      c0.4,0.1,0.8,0.2,1.1,0.3c0-0.8,0-1.6,0.1-2.3s0-1.3,0-1.8c0-0.3,0-0.5,0-0.7c0-0.2,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.2
      C26.5,1,26.6,1,26.8,1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.7,0c0.2,0,0.4,0,0.6,0.1c0.4,0,0.7,0.1,0.8,0.3
      c0.2,0.1,0.3,0.5,0.3,1c0,0.7,0,1.6,0,2.7c0,1.1-0.1,2.3-0.1,3.6c0,1.3-0.1,2.6-0.2,3.9c-0.1,1.3-0.2,2.5-0.3,3.7
      c0,0.4-0.2,0.8-0.3,1c-0.2,0.2-0.5,0.3-0.9,0.4c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0
      C26.5,17.5,26.4,17.5,26.3,17.5z M25.7,9.4c-0.2-0.1-0.4-0.1-0.7-0.2c-0.2-0.1-0.5-0.1-0.8-0.1c-0.5,0-0.9,0.1-1.2,0.3
      c-0.4,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.4,0.6-0.6,0.9c-0.1,0.3-0.2,0.7-0.2,1c0,0.7,0.2,1.2,0.5,1.6c0.3,0.4,0.8,0.6,1.5,0.6
      c0.8,0,1.6-0.4,2.4-1.1L25.7,9.4z"
          />
          <path
            fill="#f9f9f9"
            d="M41.6,7.5c0.5-0.6,1.1-1,1.7-1.2c0.6-0.3,1.2-0.4,1.9-0.4c0.5,0,0.9,0.1,1.3,0.2c0.4,0.1,0.8,0.3,1.1,0.6
      c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.5c0,0.4,0,0.9,0,1.4c0,0.6-0.1,1.1-0.1,1.8c0,0.6-0.1,1.3-0.2,2
      c-0.1,0.7-0.1,1.4-0.2,2c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.8,0.3c-0.2,0-0.5,0-0.9-0.1c-0.4,0-0.7-0.1-1.1-0.2
      c-0.5-0.1-0.7-0.4-0.7-1c0-0.2,0-0.8,0.1-1.7c0.1-1,0.1-2.3,0.1-3.9c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.3-0.3-0.5-0.3
      c-0.6,0-1.3,0.3-2,0.8c0,0.3,0,0.6,0,0.9c0,0.3,0,0.6,0,1c0,0.7,0,1.4,0,2.1c0,0.8,0,1.5-0.1,2.1c0,0.4-0.1,0.7-0.2,0.9
      c-0.1,0.2-0.4,0.3-0.8,0.3h-0.5c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8
      c0-0.9,0-1.8,0-2.7c0-0.9,0-1.8-0.1-2.8c0-0.4-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.3c-0.3,0-0.6,0.1-0.9,0.2
      c-0.3,0.2-0.6,0.3-0.9,0.6c0,1,0,1.9,0.1,2.9c0,0.9,0.1,1.9,0.2,2.8c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.3-0.1,0.5-0.2,0.6
      c-0.2,0.1-0.5,0.2-1,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.5,0-0.8-0.1-0.9-0.3
      c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-1.2-0.2-2.3-0.3-3.5c-0.1-1.2-0.1-2.4-0.1-3.6c0-0.3,0-0.6,0-0.8c0-0.3,0-0.6,0-0.8
      c0-0.4,0-0.6,0.1-0.9c0.1-0.2,0.2-0.4,0.5-0.5C32.6,6,32.8,6,33,6c0.2,0,0.5-0.1,0.8-0.1c0.3,0,0.5,0,0.8-0.1s0.5,0,0.7,0
      c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.4-0.3,0.8-0.6,1.3-0.7
      C37.5,6.1,38,6,38.4,6c0.7,0,1.3,0.1,1.8,0.3C40.8,6.5,41.2,6.9,41.6,7.5z"
          />
          <path
            fill="#f9f9f9"
            d="M52.5,0.7c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.3,0.1,0.7,0.1,1.2
      c0,0.3,0,0.6-0.1,0.8c-0.1,0.3-0.2,0.5-0.4,0.7C54.3,4.7,54,4.9,53.7,5c-0.3,0.1-0.7,0.1-1.2,0.1c-0.4,0-0.8,0-1.1-0.1
      c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-1.1c0-0.7,0.2-1.3,0.5-1.6C51.1,0.9,51.7,0.7,52.5,0.7z
      M50.6,7.6c0-0.4,0.1-0.6,0.1-0.9c0.1-0.2,0.3-0.4,0.6-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.7,0,1,0c0.1,0,0.3,0,0.4,0
      c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0.1,0.4,0.2c0.1,0.1,0.1,0.4,0.1,0.7c0,1.6,0,3.2-0.1,4.6c0,1.4-0.1,2.9-0.2,4.4c0,0.2,0,0.4-0.1,0.6
      c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0-0.4,0.1-0.7,0.1c-0.4,0-0.9,0-1.3-0.1c-0.5,0-0.8-0.2-0.9-0.4
      c-0.1-0.2-0.2-0.5-0.2-0.9c0-0.6-0.1-1.1-0.1-1.6c0-0.5,0-1.1,0-1.6c0-0.9,0-1.7,0-2.6C50.5,9.4,50.6,8.5,50.6,7.6z"
          />
          <path
            fill="#f9f9f9"
            d="M56.6,7.5c0-0.4,0-0.6,0.1-0.9s0.2-0.4,0.5-0.5C57.4,6,57.6,6,57.9,6c0.2,0,0.5-0.1,0.8-0.1
      c0.3,0,0.5,0,0.8-0.1s0.5,0,0.7,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3
      c0.6-0.4,1.2-0.7,1.8-0.9c0.6-0.2,1.3-0.3,2-0.3c0.3,0,0.7,0,1.1,0.1c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.2,0.7,0.6,0.9,1
      c0.3,0.4,0.4,1,0.4,1.8c0,0.4,0,0.9,0,1.4c0,0.6-0.1,1.1-0.1,1.8c0,0.6-0.1,1.3-0.2,2c-0.1,0.7-0.1,1.4-0.2,2
      c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.8,0.3c-0.2,0-0.5,0-0.9-0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.5-0.1-0.7-0.4-0.7-1
      c0-0.2,0-0.4,0-0.6s0.1-0.6,0.1-1c0-0.4,0.1-1,0.1-1.6c0-0.6,0-1.4,0-2.4c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.4-0.3-0.7-0.3
      c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.9,0.4-1.3,0.7c0,1,0,2,0.1,2.9c0.1,1,0.1,1.9,0.2,2.9c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2
      c0,0.3-0.1,0.5-0.2,0.6c-0.2,0.1-0.5,0.2-1,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0
      c-0.5,0-0.8-0.1-0.9-0.3c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-1.2-0.2-2.3-0.3-3.6c-0.1-1.2-0.1-2.4-0.1-3.6c0-0.3,0-0.6,0-0.8
      S56.6,7.7,56.6,7.5z"
          />
          <path
            fill="#f9f9f9"
            d="M74.6,10.5c0-1.3,0.2-2.6,0.7-3.8c0.5-1.2,1.1-2.2,2-3c0.8-0.9,1.8-1.5,3-2c1.1-0.5,2.3-0.7,3.7-0.7
      c0.6,0,1.2,0,1.8,0.1l0.1-0.4C86,0.2,86.2,0,86.6,0c0.3,0,0.6,0.1,1.1,0.2c0.5,0.1,0.9,0.3,1.3,0.5c0.3,0.2,0.5,0.4,0.5,0.8
      c0,0.1,0,0.2,0,0.3c-0.1,0.5-0.2,1-0.3,1.5c-0.1,0.5-0.3,1.1-0.4,1.7c-0.2,0.6-0.3,1.1-0.5,1.6c-0.2,0.5-0.3,1-0.5,1.5
      c-0.1,0.3-0.2,0.4-0.3,0.6c-0.1,0.1-0.3,0.2-0.5,0.2c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5-0.1-0.7-0.1
      c-0.3-0.1-0.5-0.1-0.8-0.3c-0.3-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4-0.1-0.5c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.4
      c0-0.2,0.1-0.6,0.2-1s0.2-0.9,0.3-1.3c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.4,0c-0.6,0-1.1,0.1-1.7,0.4c-0.6,0.2-1.1,0.6-1.6,1
      c-0.5,0.4-0.8,1-1.1,1.6c-0.3,0.6-0.4,1.3-0.4,2.1c0,0.5,0.1,1,0.3,1.5c0.2,0.5,0.4,0.9,0.7,1.2c0.3,0.3,0.7,0.6,1.2,0.8
      c0.5,0.2,1,0.3,1.6,0.3c0.7,0,1.4-0.1,2.1-0.3c0.7-0.2,1.4-0.5,2.1-0.8c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.4
      c0.2,0.3,0.4,0.7,0.6,1.1c0.1,0.4,0.2,0.8,0.2,1.2c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.4,0.5c-0.4,0.3-0.8,0.5-1.3,0.8
      c-0.5,0.2-1,0.4-1.6,0.6c-0.6,0.2-1.1,0.3-1.7,0.4c-0.6,0.1-1.1,0.1-1.6,0.1c-1,0-2-0.2-3-0.5c-0.9-0.3-1.8-0.8-2.5-1.4
      c-0.7-0.6-1.3-1.4-1.7-2.3C74.8,12.6,74.6,11.6,74.6,10.5z"
          />
          <path
            fill="#f9f9f9"
            d="M98.4,6.1c0.2,0.1,0.4,0.2,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.5c0,0,0,0.1,0,0.2c0,0.1,0,0.2-0.1,0.4
      c1.2,0.3,2.1,0.9,2.8,1.7c0.7,0.9,1,1.9,1,3.2c0,0.9-0.2,1.7-0.5,2.4c-0.4,0.7-0.8,1.3-1.4,1.7c-0.6,0.5-1.2,0.8-2,1
      c-0.7,0.2-1.5,0.4-2.2,0.4c-1,0-1.9-0.1-2.7-0.4c-0.8-0.2-1.5-0.6-2.1-1.1c-0.6-0.5-1-1.1-1.3-1.8c-0.3-0.7-0.5-1.5-0.5-2.4
      c0-0.9,0.2-1.8,0.6-2.6c0.4-0.8,0.9-1.4,1.5-2s1.3-1,2.1-1.3c0.8-0.3,1.6-0.4,2.4-0.4c0.3,0,0.5,0,0.9,0.1
      C97.9,5.9,98.2,6,98.4,6.1z M97.7,10.5c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.2-0.3
      c0-0.1-0.1-0.3-0.1-0.6c-0.8,0.1-1.4,0.4-2,0.9c-0.5,0.5-0.8,1.2-0.8,2c0,0.3,0.1,0.6,0.2,0.9c0.1,0.3,0.3,0.5,0.5,0.7
      c0.2,0.2,0.5,0.3,0.8,0.4c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.6,0,1-0.1c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.2,0.5-0.4,0.6-0.7
      c0.2-0.3,0.2-0.6,0.2-0.9c0-0.4-0.1-0.8-0.4-1.1C98.5,10.8,98.2,10.6,97.7,10.5z"
          />
          <path
            fill="#f9f9f9"
            d="M104.3,7.5c0-0.4,0-0.6,0.1-0.9c0.1-0.2,0.2-0.4,0.5-0.5c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.5-0.1,0.8-0.1
      c0.3,0,0.5,0,0.8-0.1s0.5,0,0.7,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.4
      c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.4,0,0.7,0.2,1,0.5c0.2,0.3,0.4,0.7,0.5,1.1c0.1,0.4,0.1,0.7,0.1,1.2
      c0,0.4,0,0.8,0,1.1c0,0.3-0.1,0.6-0.2,0.8c-0.2,0.3-0.5,0.5-0.9,0.7c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-0.7,0.2
      c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.2,0-0.4,0-0.7c0-0.3,0-0.5-0.1-0.7c-0.2,0.1-0.4,0.2-0.6,0.3
      c-0.2,0.1-0.4,0.3-0.7,0.5c0,0.8,0,1.6,0.1,2.3c0,0.7,0.1,1.4,0.1,1.9c0,0.6,0.1,1,0.1,1.4c0,0.4,0.1,0.6,0.1,0.7
      c0,0.3-0.1,0.5-0.2,0.6c-0.2,0.1-0.5,0.2-1,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0
      c-0.5,0-0.8-0.1-0.9-0.3c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-1.2-0.2-2.3-0.3-3.6c-0.1-1.2-0.1-2.4-0.1-3.6c0-0.3,0-0.6,0-0.8
      S104.3,7.7,104.3,7.5z"
          />
          <path
            fill="#f9f9f9"
            d="M114.3,7.5c0-0.4,0-0.6,0.1-0.9c0.1-0.2,0.2-0.4,0.5-0.5c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.5-0.1,0.8-0.1
      c0.3,0,0.5,0,0.8-0.1c0.3,0,0.5,0,0.7,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3
      c0.6-0.4,1.2-0.7,1.8-0.9c0.6-0.2,1.3-0.3,2-0.3c0.3,0,0.7,0,1.1,0.1c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.2,0.7,0.6,0.9,1
      c0.3,0.4,0.4,1,0.4,1.8c0,0.4,0,0.9,0,1.4c0,0.6-0.1,1.1-0.1,1.8c0,0.6-0.1,1.3-0.2,2c-0.1,0.7-0.1,1.4-0.2,2
      c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.8,0.3c-0.2,0-0.5,0-0.9-0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.5-0.1-0.7-0.4-0.7-1
      c0-0.2,0-0.4,0-0.6s0.1-0.6,0.1-1c0-0.4,0.1-1,0.1-1.6c0-0.6,0-1.4,0-2.4c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.2-0.4-0.3-0.7-0.3
      c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.9,0.4-1.3,0.7c0,1,0,2,0.1,2.9c0.1,1,0.1,1.9,0.2,2.9c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2
      c0,0.3-0.1,0.5-0.2,0.6c-0.2,0.1-0.5,0.2-1,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0
      c-0.5,0-0.8-0.1-0.9-0.3c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-1.2-0.2-2.3-0.3-3.6c-0.1-1.2-0.1-2.4-0.1-3.6c0-0.3,0-0.6,0-0.8
      S114.3,7.7,114.3,7.5z"
          />
          <path
            fill="#f9f9f9"
            d="M137.8,12c-0.4,0.1-0.9,0.3-1.4,0.4c-0.6,0.1-1.1,0.2-1.8,0.3c-0.6,0.1-1.3,0.2-1.9,0.2
      c-0.7,0.1-1.3,0.1-1.9,0.1c0.3,0.4,0.7,0.6,1.2,0.8c0.5,0.2,1,0.3,1.5,0.3c0.4,0,0.9-0.1,1.4-0.2c0.5-0.1,1-0.3,1.5-0.5
      c0.2-0.1,0.4-0.2,0.5-0.2c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2,0.1,0.3,0.1,0.5
      c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.6-0.4,0.8c-0.5,0.4-1.1,0.8-1.9,1.1c-0.8,0.3-1.8,0.4-2.8,0.4
      c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.3-0.7-1.8-1.2c-0.5-0.5-1-1.1-1.3-1.8c-0.3-0.7-0.5-1.5-0.5-2.4s0.2-1.7,0.5-2.4
      c0.3-0.7,0.8-1.4,1.3-1.9c0.6-0.5,1.2-0.9,1.9-1.2c0.7-0.3,1.5-0.4,2.3-0.4c1.1,0,2,0.2,2.7,0.6c0.7,0.4,1.3,0.9,1.7,1.4
      s0.8,1.1,0.9,1.7c0.2,0.6,0.3,1.1,0.3,1.5c0,0.2,0,0.4-0.1,0.5C138.2,11.8,138.1,11.9,137.8,12z M132.8,9.1c-0.5,0-1,0.2-1.5,0.5
      c-0.5,0.3-0.8,0.7-0.9,1.2c0.7,0,1.4-0.1,2.2-0.1c0.8-0.1,1.5-0.2,2.1-0.3c-0.2-0.4-0.4-0.8-0.8-1C133.5,9.2,133.2,9.1,132.8,9.1z"
          />
          <path
            fill="#f9f9f9"
            d="M139.6,7.5c0-0.4,0-0.6,0.1-0.9s0.2-0.4,0.5-0.5c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.5-0.1,0.8-0.1
      c0.3,0,0.5,0,0.8-0.1s0.5,0,0.7,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.2,0,0.3s0,0.2,0,0.4
      c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.4,0,0.7,0.2,1,0.5c0.2,0.3,0.4,0.7,0.5,1.1c0.1,0.4,0.1,0.7,0.1,1.2
      c0,0.4,0,0.8,0,1.1c0,0.3-0.1,0.6-0.2,0.8c-0.2,0.3-0.5,0.5-0.9,0.7c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.2-0.7,0.2
      c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.2,0-0.4,0-0.7s0-0.5-0.1-0.7c-0.2,0.1-0.4,0.2-0.6,0.3
      c-0.2,0.1-0.4,0.3-0.7,0.5c0,0.8,0,1.6,0.1,2.3c0,0.7,0.1,1.4,0.1,1.9c0,0.6,0.1,1,0.1,1.4c0,0.4,0.1,0.6,0.1,0.7
      c0,0.3-0.1,0.5-0.2,0.6c-0.2,0.1-0.5,0.2-1,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0
      c-0.5,0-0.8-0.1-0.9-0.3c-0.1-0.2-0.2-0.5-0.3-0.8c-0.1-1.2-0.2-2.3-0.3-3.6c-0.1-1.2-0.1-2.4-0.1-3.6c0-0.3,0-0.6,0-0.8
      S139.6,7.7,139.6,7.5z"
          />
        </g>
      </g>
    </>
  );
};

export default StaticRooms;
